
import SideNav from "./SideNav";
import TopBar from "./TopBar";
import React, { useState,  useEffect, useRef,useContext } from 'react';
import axios from 'axios';
import { Link, useParams, useNavigate } from "react-router-dom";
import Select from 'react-select';
import Swal from "sweetalert2";
import ReactPaginate from 'react-paginate';
import $ from 'jquery';
import placeholderImage from '../img/image_placeholder.png';
import noImagePlaceholder from '../img/no_image_placeholder.png';
// import UserContext from './UserContext';
import moment from 'moment';
import { Collapse } from 'react-bootstrap'; 
import { Modal, Button } from 'react-bootstrap';
import UserContext from './UserContext';
import main_logo from '../img/logo_white.png';
import html2pdf from "html2pdf.js";
import QRCode from 'qrcode';
import dayjs from "dayjs";

function LeadsDetails(){

    const API_URL = process.env.REACT_APP_API_URL;
    const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;
    const PAYMENT_API_URL = process.env.REACT_APP_PAYMENT_URL;
    
    const API_BASE_URL = process.env.REACT_APP_BASE_URL;
    const navigate = useNavigate();
    const userContext = useContext(UserContext);  

    const [isLoading, setIsLoading] = useState(false);
    const [mergedArray, setMergedArray] = useState([]);
    const [customer, setCustomer] = useState([]);
    const [customerType, setCustomerType] = useState([]);
    const [assign_to, setAssign_to] = useState([]);
    const [email_template, setEmail_template] = useState([]);
    const [sms_template, setSms_template] = useState([]);
    const [note_template, setNote_template] = useState([]);
    const [team, setTeam] = useState([]);
    const [upload_template, setUpload_template] = useState([]);
    const [booking, setBooking] = useState([]);
    const [bookingScarborough, setBookingScarborough] = useState([]);
    const [pin_template, setPin_template] = useState([]);
    const [customerById, setCustomerById] = useState([]);
    const [customerBookedHistory, setCustomerBookedHistory] = useState([]);
    const [bookedSlotLogById, setBookedSlotLogById] = useState([]);
    const [paymentLinkById, setPaymentLinkById] = useState([]);
    const [emailLogById, setEmailLogById] = useState([]);
    const [smsLogById, setSmsLogById] = useState([]);
    const [meetLogById, setMeetLogById] = useState([]);
    const [noteLogById, setNoteLogById] = useState([]);
    const [uploadLogById, setUploadLogById] = useState([]);
    const [bookingById, setBookingById] = useState([]);
    const [timeSlotById, setTimeSlotById] = useState([]);
    const [inquiryById, setInquiryById] = useState([]);
    const { id } = useParams();


    const [loading, setLoading] = useState(false);
    const [paymentLoading, setPaymentLoading] = useState(false);
    const [adjustmentLoading, setAdjustmentLoading] = useState(false);
    const [staffLoading, setStaffLoading] = useState(false);
    const [foodLoading, setFoodLoading] = useState(false);
    const [drinkLoading, setDrinkLoading] = useState(false);
    const [filteredInventory, setFilteredInventory] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState([]);

   
    const [callVisible, setCallVisible] = useState(false);
    const [emailVisible, setEmailVisible] = useState(false);
    const [textVisible, setTextVisible] = useState(false);
    const [pinVisible, setPinVisible] = useState(false);
    const [meetVisible, setMeetVisible] = useState(false);
    const [noteVisible, setNoteVisible] = useState(false);
    const [uploadVisible, setUploadVisible] = useState(false);
    const [inqueryVisible, setInqueryVisible] = useState(true);
    const [infoVisible, setInfoVisible] = useState(true);
 const [newBookingVisible, setNewBookingVisible] = useState(false);
    const [historyVisible, setHistoryVisible] = useState(false);
    const [invoiceVisible, setInvoiceVisible] = useState(false);
    const [email_error_list, setEmailErrorList] = useState([]);
    const [meetingErrorList, setMeetingErrorList] = useState([]);
    const [noteErrorList, setNoteErrorList] = useState([]);
    const [paymentErrorList, setPaymentErrorList] = useState([]);
    const [uploadErrorList, setUploadErrorList] = useState([]);
    const [bookingErrorList, setBookingErrorList] = useState([]);
    const [error_list, setErrorList] = useState([]);
    const [adjustmentError, setAdjustmentError] = useState('');
    
    const [description, setDescription] = useState('');
    const [totalPlayersErrorList, setTotalPlayersErrorList] = useState([]);

    const [template, setTemplate] = useState("");
    const [text_template, setText_template] = useState("");
    const [note_template_select, setNote_template_select] = useState("");
    const [team_select, setTeam_select] = useState([]);
    const [upload_template_select, setUpload_template_select] = useState("");
    const [pin_template_select, setPin_template_select] = useState("");
    const [template_details, setTemplate_details] = useState([]);
    const [text_template_details, setText_template_details] = useState([]);
    const [note_template_details, setNote_template_details] = useState([]);
    const [upload_template_details, setUpload_template_details] = useState([]);
    const [pin_template_details, setPin_template_details] = useState([]);
    const [subject, setSubject] = useState("");
    const [note_subject, setNote_subject] = useState("");
    const [upload_subject, setUpload_subject] = useState("");
    const [message, setMessage] = useState("");
    const [email, setEmail] = useState("");
    const [first_name, setFirst_name] = useState("");
    const [phone_no, setPhone_no] = useState("");
    const [successMessage, setSuccessMessage] = useState('');
    const [images, setImages] = useState([]);
    const [videos, setVideos] = useState([]);
    const [previews, setPreviews] = useState([]);
    const [previewsVideo, setPreviewsVideo] = useState([]);
    const selectAllCheckboxRef = useRef();
    const [perPage, setPerPage] = useState(25);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [text_message, setText_message] = useState("");
    const [note_message, setNote_message] = useState("");
    const [upload_message, setUpload_message] = useState("");
    const [pin_message, setPin_message] = useState("");
    const [activeButton, setActiveButton] = useState(null);
    const [sortOrder, setSortOrder] = useState('newest'); 
    const [title, setTitle] = useState('');
    const [startDatetime, setStartDatetime] = useState('');
    const [endDatetime, setEndDatetime] = useState('');
    const [date, setDate] = useState('');
    const [booking_date, setBooking_date] = useState('');
    const [time, setTime] = useState('');
    const [booking_time, setBooking_time] = useState('');
    const [availableTimeSlots, setAvailableTimeSlot] = useState([]);
    const [bookingAvailableTimeSlots, setBookingAvailableTimeSlots] = useState([]);
    const [makeError, setMakeError] = useState();
    const [modelError, setModelError] = useState();
    const [isImageLoading, setIsImageLoading] = useState(true);
    const [isUploadImageLoading, setIsUploadImageLoading] = useState(true);
    const [isPhotoLoading, setIsPhotoLoading] = useState(true);
    const [user_type, setUser_type] = useState("");
    const [activeTab, setActiveTab] = useState('adults'); 
    const [kids_count, setKids_count] = useState(0);
    const [adults_count, setAdults_count] = useState(0);
  const [available_space, setAvailable_space] = useState(0);
  const [game_location, setGame_location] = useState('');
  const [game_type, setGame_type] = useState('');
  const [groupedBookedTimes, setGroupedBookedTimes] = useState([]);
    const [isEmail, setIsEmail] = useState(false); 
    const [openEmailId, setOpenEmailId] = useState(null);
    const [openNoteId, setOpenNoteId] = useState(null);
    const [openActivityEmailId, setOpenActivityEmailId] = useState(null);
    const [openActivitySmsId, setOpenActivitySmsId] = useState(null);
    const [openActivityNoteId, setOpenActivityNoteId] = useState(null);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [showAdjustmentModal, setShowAdjustmentModal] = useState(false);
    const [showFoodModal, setShowFoodModal] = useState(false);
    const [showDrinkModal, setShowDrinkModal] = useState(false);
    const [showStaffModal, setShowStaffModal] = useState(false);
  const [payment_method, setPayment_method] = useState('');
  const [payment_amount, setPayment_amount] = useState('');
  const [payment_date, setPayment_date] = useState(() => {
    const today = new Date();
  //  return today.toISOString().split("T")[0]; // Format: YYYY-MM-DD
   return today.toLocaleDateString("en-CA", {timeZone: 'America/Toronto'});
  });
  
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [adjustmentHistory, setAdjustmentHistory] = useState([]);
  const [paymentDeleteHistory, setPaymentDeleteHistory] = useState([]);
  const [paymentOnlyDeleteHistory, setPaymentOnlyDeleteHistory] = useState([]);
  const [adjustmentDeleteHistory, setAdjustmentDeleteHistory] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [isTemplate, setIsTemplate] = useState(false); 
  const [showModal, setShowModal] = useState(false); 
  const [availableSpaces, setAvailableSpaces] = useState({});
  const [timeSlotLoading, setTimeSlotLoading] = useState(false);
  const [disabledTimeSlots, setDisabledTimeSlots] = useState([]);
  const [timeSlotDetails, setTimeSlotDetails] = useState([]);
  const [game_packages, setGame_packages] = useState([]);
  const [corporate_events, setCorporate_events] = useState([]);
  const [corporatePrice, setCorporatePrice] = useState([]);
  const [game_types_array, setGame_types_array] = useState([]);
  const [game_count, setGame_count] = useState([]);
  const [game_types, setGame_types] = useState([]);
  const [minPlayers, setMinPlayers] = useState(0);
  const [maxPlayers, setMaxPlayers] = useState(0);
  const [grand_total, setGrand_total] = useState(0);
  const [adjusted_total, setAdjusted_total] = useState(0);
  const [sub_total, setSub_total] = useState(0);
  const [amount_paid, setAmount_paid] = useState(0);
  const [hst, setHst] = useState(0);
  const [cart_details, setCart_details] = useState('');
  const [deposit_amount, setDeposit_amount] = useState(0);
  const [deposit_details, setDeposit_details] = useState('');
  const [birthdayPrice, setBirthdayPrice] = useState([]);
  const [birthday_packages, setBirthday_packages] = useState([]);
  const [corporate_packages, setCorporate_packages] = useState([]);
  const [min_game, setMin_game] = useState(0);
  const [eventGame_count, setEventGame_count] = useState([]);
  const [basic_price, setBasic_price] = useState(0);
  const [initialSelectionDone, setInitialSelectionDone] = useState(false);
  const [initialSelectionSlots, setInitialSelectionSlots] = useState('');
  const [emailData, setEmailData] = useState({
    to: '',
    subject: '',
    message: ''
});
  const [foodOptions, setFoodOptions] = useState([]);
  const [drinkOptions, setDrinkOptions] = useState([]);
  const [selectedFoods, setSelectedFoods] = useState({});
  const [selectedDrinks, setSelectedDrinks] = useState({});
  const [pdfLoading, setPdfLoading] = useState(false);
  const [pdfConsentLoading, setPdfConsentLoading] = useState(false);
    const [pdfKidsConsentLoading, setPdfKidsConsentLoading] = useState(false);
  const [generatedAttachments, setGeneratedAttachments] = useState([]);
 const [invoiceEmailData, setInvoiceEmailData] = useState({ to: "", template:"", subject: "", message: "" , attachments: [] });
 const [showEmailDialog, setShowEmailDialog] = useState(false);
 const [showPaymentEmailDialog, setShowPaymentEmailDialog] = useState(false);
 const [emailLoading, setEmailLoading] = useState(false);
 const [extraPlayerPrice, setExtraPlayerPrice] = useState(0);
 const [extraGamePrice, setExtraGamePrice] = useState(0);
 const [generatePaymentAmount, setGeneratePaymentAmount] = useState(0);
 const [adjustedAmount, setAdjustedAmount] = useState(0);
const [reason, setReason] = useState('Pending Payment');
const [note, setNote] = useState('');
const [imageError, setImageError] = useState(false);
const [adjustedDate, setAdjustedDate] = useState(() => {
  const today = new Date();
 // return today.toISOString().split("T")[0]; // Format: YYYY-MM-DD
    return today.toLocaleDateString("en-CA", {timeZone: 'America/Toronto'});
});
const [adjustedReason, setAdjustedReason] = useState('');
const [adjustedNote, setAdjustedNote] = useState('');
const [toEmail, setToEmail] = useState('');
const [discountDetails, setDiscountDetails] = useState([]);
const [promoDetails, setPromoDetails] = useState([]);
const [pdfUrls, setPdfUrls] = useState({});
const [isTeamLoaded, setIsTeamLoaded] = useState(false);


  const handlePaymentMethodChange = (e) => {
    setPayment_method(e.target.value);
  };

  const handlePaymentAmountChange = (e) => {
    setPayment_amount(e.target.value);
  };

  const handlePaymentDateChange = (e) => {
    setPayment_date(e.target.value);
  };

   
  const getStatusStyle = (status) => {
    switch (status) {
        case 'Completed':
            return { color: 'green', fontWeight: 'bold' };
        case 'Incomplete':
            return { color: 'red', fontWeight: 'bold' };
        case 'Cancelled':
            return { color: 'blue', fontWeight: 'bold' };
        default:
            return { color: 'black' }; // Default color for unknown statuses
    }
};
  

  const handleShowPaymentModal = () => {
    const totalPaid = paymentHistory.reduce((total, payment) => total + parseFloat(payment.payment_amount), 0);

    const balanceAmount = (customerById.grand_total - totalPaid).toFixed(2);
    setPayment_amount(balanceAmount);
    setShowPaymentModal(true);
  }

  const handleShowAdjustmentModal = () => {
    setShowAdjustmentModal(true);
  }
    
    
  const handleClosePaymentModal = () => setShowPaymentModal(false);
  const handleCloseAdjustmentModal = () => setShowAdjustmentModal(false);

  const handleCloseFoodModal = () => setShowFoodModal(false);
  const handleCloseDrinkModal = () => setShowDrinkModal(false);
  const handleCloseStaffModal = () => setShowStaffModal(false);
  
    const handleToggle = (emailId) => {
        setOpenEmailId(openEmailId === emailId ? null : emailId);
    };

    const handleToggleNote = (noteId) => {
        setOpenNoteId(openNoteId === noteId ? null : noteId);
    };

    const handleToggleEmailActivity = (emailId) => {
        setOpenActivityEmailId(openActivityEmailId === emailId ? null : emailId);
    };

    
    const handleToggleSmsActivity = (smsId) => {
        setOpenActivitySmsId(openActivitySmsId === smsId ? null : smsId);
    };

    const handleToggleNoteActivity = (noteId) => {
        setOpenActivityNoteId(openActivityNoteId === noteId ? null : noteId);
    };

      // Filter the team based on the search input
      const filteredTeam = team.filter((member) =>
        `${member.first_name} ${member.last_name}`.toLowerCase().includes(searchQuery.toLowerCase())
      );
    

      const filteredConsentFormDetails = customerById.consent_form_details && customerById.consent_form_details.filter(item =>
        Number(item.is_deleted) === 0 && 
        (item.name && item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.dob && moment(item.dob).format('D MMMM YYYY').toLowerCase().includes(searchQuery.toLowerCase()))
    );



    const filteredKidsFormDetails = customerById.kids_form_details && customerById.kids_form_details.filter(item => 
        Number(item.is_deleted) === 0 && 
        (
            item.guardian_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.children.some(child => 
                child.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                moment(child.dob).format('D MMMM YYYY').toLowerCase().includes(searchQuery.toLowerCase())
            )
        )
    );

    const filteredBookedHistory =  customerBookedHistory.filter((item) => {
        return `${item.firstname} ${item.lastname}`.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.booking_ref_id.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.location_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.game_name.toLowerCase().includes(searchQuery.toLowerCase()) 
      });

   
    
    const handleDateChange = (e) => {
       
        const selectedDate = e.target.value;
        setDate(selectedDate);
        axios.get(`${API_URL}/booked-appointments`, { params: { selectedDate } })
        .then(response => {
            const bookedTimes = response.data.map(time => {
                const [hour, minute] = time.split(':');
                const hour12 = (parseInt(hour) % 12) || 12;
                const ampm = parseInt(hour) < 12 ? 'AM' : 'PM';
                return `${hour12}:${minute} ${ampm}`;
            });
   
            const availableTimes = generateTimeSlots(bookedTimes);
       
        })
        .catch(error => {
            console.error('Error fetching available date-time pairs:', error);
        });
      };


      const handleEditBooking = () => {
        
        setShowModal(true);
        // if(customerById.game_type_id)
        // {
        //     recalculateCosts();
        // }
        // if(customerById.package_name)
        //     {
        // recalculateBirthdayCosts();
        //     }
      };
    
      // Function to close the modal
      const handleCloseModal = () => setShowModal(false);

      const handleBookingDateChange = (value) => {

    const selectedDate = value;
    setBooking_date(selectedDate);
    setCustomerById(prevCustomer => ({
        ...prevCustomer,
        booking_date: selectedDate,
    }));
   
    };


    const handleTimeSlotChange = (e) => {
        const selectedSlot = e.target.value;
        setBooking_time(selectedSlot);

        const totalPeople = parseInt(kids_count, 10) + parseInt(adults_count, 10);
        const bookedPeople = groupedBookedTimes[selectedSlot] || 0;
        const remainingSpace = timeSlotById.reserved_slot - bookedPeople;
        setAvailable_space(remainingSpace - totalPeople);
    };

    

      const convertTo12HourFormat = (time) => {
        const [hour, minute] = time.split(':');
        const hour12 = (parseInt(hour) % 12) || 12;
        const ampm = parseInt(hour) < 12 ? 'AM' : 'PM';
        return `${hour12}:${minute} ${ampm}`;
    };
      const isImage = (fileName) => {
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
        return imageExtensions.some(ext => fileName.toLowerCase().endsWith(ext));
    };

    const isDocument = (fileName) => {
        const documentExtensions = ['.pdf', '.doc', '.docx', '.ppt', '.pptx', '.xls', '.xlsx', '.txt']; // Add more extensions if needed
        const fileExtension = fileName.toLowerCase().split('.').pop(); // Get the file extension
        
        return documentExtensions.includes(`.${fileExtension}`);
    };
      
      const formatMeetDate = (dateString) => {
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', options);
    };
    
    const formatMeetTime = (timeString) => {
        const options = { hour: '2-digit', minute: '2-digit', hour12: true };
        const date = new Date(`1970-01-01T${timeString}`);
        return date.toLocaleTimeString('en-US', options);
    };

  
      const generateTimeSlots = (bookedTimes) => {
        // Generate time slots from 9 AM to 4 PM
        const startTime = 9;
        const endTime = 16;
        const timeSlots = [];
    
        for (let hour = startTime; hour <= endTime; hour++) {
          const formattedHour = hour % 12 || 12;
          const ampm = hour < 12 ? 'AM' : 'PM';
          const timeSlot = `${formattedHour}:00 ${ampm}`;
          timeSlots.push(timeSlot);
        }   
    
  
       // console.log(timeSlots.filter(timeSlot => !timeSlot.includes(bookedTimes)))

        const availableTimeSlots = timeSlots.filter(timeSlot => !bookedTimes.includes(timeSlot));
       setAvailableTimeSlot(availableTimeSlots);
        return availableTimeSlots;
      };

      const formattedDate = new Date(date);
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      const formattedDateString = formattedDate.toLocaleDateString('en-US', options);

      const handlePageChange = (selectedPage) => {
        setCurrentPage(selectedPage.selected);
      };

      

      const filteredEmailHistory = emailLogById.filter((item) => {
        return item.subject.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.created_at.toLowerCase().includes(searchQuery.toLowerCase())  
      });

      
      const filteredMeetHistory = meetLogById.filter((item) => {
        return item.subject.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.created_at.toLowerCase().includes(searchQuery.toLowerCase())  
      });

      const filteredNoteHistory = noteLogById.filter((item) => {
        return item.subject.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.created_at.toLowerCase().includes(searchQuery.toLowerCase())  
      });

      const filteredUploadHistory = uploadLogById.filter((item) => {
        return item.subject.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.created_at.toLowerCase().includes(searchQuery.toLowerCase())  
      });

      const filteredBookingHistory = bookingById.filter((item) => {
        return item.game_title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.created_at.toLowerCase().includes(searchQuery.toLowerCase())  
      });


       const uploadImageClick = (imageURL) => {
        Swal.fire({
          imageUrl: imageURL,
          imageAlt: 'Uploaded Image',
          showCloseButton: true,
          showConfirmButton: false,
        });
      };


       
      const sortedSmsHistory = [...smsLogById]; // Make a copy of the original data

      if (sortOrder === 'oldest') {
          sortedSmsHistory.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
      } else {
          sortedSmsHistory.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      }



 

const handleUploadImageLoad = () => {
    setIsUploadImageLoading(false);
};

const handlePhotoLoad = () => {
    setIsPhotoLoading(false);
};

   const showToast = (message) => {
  Swal.fire({
    icon: 'success',
    title: message,
    color:"white",
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3500,
    customClass: {
        popup: 'sweetalert-popup',
        title: 'sweetalert-title',
        icon: 'sweetalert-icon',
      },
      background: '#333',
      showCloseButton: true,
      padding: '4px', 
  });
};

const showToastFail = (message) => {
    Swal.fire({
      icon: 'error',
      title: message,
      color:"white",
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3500,
      customClass: {
          popup: 'sweetalert-popup',
          title: 'sweetalert-title',
          icon: 'sweetalert-icon',
        },
        background: '#333',
        showCloseButton: true,
        padding: '4px', 
    });
  };



    const toggleDiv = (divName) => {
       setActiveButton(activeButton === divName ? null : divName);
        switch (divName) {
            case 'info':
                if (infoVisible) return; 
               
                setInfoVisible(!infoVisible);
                // setNewBookingVisible(false);
                setCallVisible(false);
                setEmailVisible(false);
                setTextVisible(false);
                setNoteVisible(false);
                setHistoryVisible(false);
                setInvoiceVisible(false);

                break;
                // case 'newBooking':
                // if (newBookingVisible) return; 
               
                // setNewBookingVisible(!newBookingVisible);
                // setInfoVisible(false);
                // setCallVisible(false);
                // setEmailVisible(false);
                // setTextVisible(false);
                // setNoteVisible(false);
                // setHistoryVisible(false);

                // break;
          
            
                case 'call':
                    if (callVisible) return; 
                    setCallVisible(!callVisible);
                setEmailVisible(false);
                setTextVisible(false);
                setPinVisible(false);
                setMeetVisible(false);
                setNoteVisible(false);
                setUploadVisible(false);
                setInqueryVisible(false);
                setInfoVisible(false);
                setHistoryVisible(false);
                setInvoiceVisible(false);
                    break;
                    case 'email':
                        if (emailVisible) return; 
                        // setSearchQuery("");
                        setTemplate_details([]);
                        setEmailErrorList([]);
                        resetEmail();
                        setEmailVisible(!emailVisible);
                        setCallVisible(false);
                        setTextVisible(false);
                        // setPinVisible(false);
                        // setMeetVisible(false);
                        setNoteVisible(false);
                        // setUploadVisible(false);
                        // setInqueryVisible(false);
                        setInfoVisible(false);
                        setHistoryVisible(false);
                        setInvoiceVisible(false);
                        // setNewBookingVisible(false);
                        break;
                        case 'text':
                            if (textVisible) return; 
                            setTextVisible(!textVisible);
                            setCallVisible(false);
                            setEmailVisible(false);
                            setPinVisible(false);
                            setMeetVisible(false);
                            setNoteVisible(false);
                            setUploadVisible(false);
                            setInqueryVisible(false);
                            setInfoVisible(false);
                            setHistoryVisible(false);
                            setInvoiceVisible(false);
                            resetSms();
                            setErrorList([]);
                            setText_template_details([]);
                            // setNewBookingVisible(false);
                            break;

                            case 'history':
                                if (historyVisible) return; 
                                setHistoryVisible(!historyVisible);
                                setInfoVisible(false);
                                setCallVisible(false);
                                setEmailVisible(false);
                                setTextVisible(false);
                                setNoteVisible(false);
                                setInvoiceVisible(false);
                                // setNewBookingVisible(false);
                
                                break;

                                case 'invoice':
                                    if (invoiceVisible) return; 
                                    setInvoiceVisible(!invoiceVisible);
                                    setInfoVisible(false);
                                    setCallVisible(false);
                                    setEmailVisible(false);
                                    setTextVisible(false);
                                    setNoteVisible(false);
                                    setHistoryVisible(false);
                                    // setNewBookingVisible(false);
                    
                                    break;
          case 'pin':
            if (pinVisible) return; 
            setPinVisible(!pinVisible);
            setCallVisible(false);
            setEmailVisible(false);
            setTextVisible(false);
            setMeetVisible(false);
            setNoteVisible(false);
            setUploadVisible(false);
            setInqueryVisible(false);
            setInvoiceVisible(false);
            // setNewBookingVisible(false);
            break;
          case 'meet':
            if (meetVisible) return; 
            setMeetVisible(!meetVisible);
            setCallVisible(false);
            setEmailVisible(false);
            setTextVisible(false);
            setPinVisible(false);
            setNoteVisible(false);
            setUploadVisible(false);
            setInqueryVisible(false);
            setMeetingErrorList([]);
            break;
          case 'note':
            if (noteVisible) return; 
            setNoteVisible(!noteVisible);
            setInfoVisible(false);
            setCallVisible(false);
            setEmailVisible(false);
            setTextVisible(false);
            setHistoryVisible(false);
            setInvoiceVisible(false);
            // setPinVisible(false);
            // setMeetVisible(false);
            // setUploadVisible(false);
            // setInqueryVisible(false);
            setNoteErrorList([]);
            setNote_template_details([]);
            // setNewBookingVisible(false);
            break;
            case 'upload':
                if (uploadVisible) return; 
                setUploadVisible(!uploadVisible);
                setCallVisible(false);
                setEmailVisible(false);
                setTextVisible(false);
                setPinVisible(false);
                setMeetVisible(false);
                setNoteVisible(false);
                setInqueryVisible(false);
                setUploadErrorList([]);
                setUpload_template_details([]);
                break;
          
          default:
            break;
        }
      };

      function getDayName(dateString) {
        const date = new Date(dateString);
        const options = { weekday: 'short' };
        return date.toLocaleDateString('en-US', options);
    }


      function formatDate(dateString) {
        const date = new Date(dateString);
        const options = { month: 'short', day: 'numeric', year: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    }
    
    function formatTime(dateString) {
        const date = new Date(dateString);
        const options = { hour: 'numeric', minute: 'numeric', hour12: true };
        return date.toLocaleTimeString('en-US', options);
    }

    // useEffect(() => {
    //     const loadBamboraSDK = () => {
    //         if (window.BamboraSDK) {
    //             connectCardReader();
    //         } else {
    //             console.error('BamboraSDK is not loaded yet. Retrying...');
    //             setTimeout(loadBamboraSDK, 100); // Retry after a short delay
    //         }
    //     };

    //     loadBamboraSDK();
    // }, []);

    // const connectCardReader = () => {
    //     // Initialize the Bambora SDK
    //     window.BamboraSDK.init();

    //     // Listen for card swipe or insertion
    //     window.BamboraSDK.onCardSwipe((cardData) => {
    //         console.log('Card Data:', cardData);
    //         // Handle card data (send to backend for processing)
    //       //  processPayment(cardData);
    //     });
    // };





    useEffect(() => { 
       
         //getCustomerList();
          // getTeamList();
          getCustomerById(id);
          fetchGameTypesArray();
        
           getEmailTemplateList();
        //   getSmsTemplateList();
           getNoteTemplateList();
        //   getUploadTemplateList();
        //   getPinTemplateList();
        //   getInventoryList(); 
        //   getBookingList();
        //  getTimeSlotList();
}, [id]);



useEffect(() => { 
  
   if (customerById.game_type_name === "Public" || customerById.game_type_name === "Private")

    {
        fetchGameTypes();
    }
  
    if(customerById.package_name == 'Birthday')
    {
        fetchOptionsForBirthdayPackage();
    }
  if(customerById.package_name == "Corporate"){
    fetchOptionsForCorporatePackage();
  }
   
}, [customerById]);



useEffect(() => {
  async function fetchTeam() {
    try {
      const res = await axios.get(`${API_URL}/view-team-members`);
      if (res.data.status === 200) {
        setTeam(res.data.team);
      } else if (res.data.status === 404) {
        setTeam([]);
      }
    } catch (error) {
      setTeam([]);
      console.error("Failed to fetch team:", error);
    } finally {
      setIsTeamLoaded(true);
    }
  }

  fetchTeam();
}, []);  // empty dependency means run once on mount




useEffect(() => {

    // Check if email_template is loaded and has the required default template
    const defaultTemplate = email_template.find(item => item.template_name === 'Booking Updation');
    if (defaultTemplate) {
        setTemplate('Booking Updation');
        setTemplate_details(defaultTemplate);

        setEmailData({
            ...emailData,
            subject: defaultTemplate.subject,
            message: defaultTemplate.message
        });
    } else {
        // Reset if default template is not found
        setTemplate("");
        setTemplate_details({});
        setEmailData({ subject: "", message: "", to: "" });
    }

}, [email_template]);

const fetchGamePackages = async (selectedPackageType) => {
  
    try {
        const response = await axios.get(`${API_URL}/view-game-package-by-package/${customerById.location_id}/${customerById.game_id}/${selectedPackageType}`);
 
        if (response.data.gamePackages) {
            setGame_packages(response.data.gamePackages);
   
        }
        else {
            setGame_packages([]);
        }
    } catch (error) {
        console.error("Error fetching package:", error);

    }
};


const fetchCorporateEvents = async (selectedPackageType) => {

    try {
        const response = await axios.get(`${API_URL}/view-corporate-event-by-package/${customerById.location_id}/${customerById.game_id}/${selectedPackageType}`);
 
        if (response.data.corporateEvents) {
            setCorporate_events(response.data.corporateEvents);
   
        }
        else {
            setCorporate_events([]);
        }
    } catch (error) {
        console.error("Error fetching coperate event:", error);

    }
};

const fetchGameTypes = async () => {
   
    try {
        const response = await axios.get(`${API_URL}/view-game-type-by-gameId/${customerById.game_id}/${customerById.location_id}`);
        if (response.data.gameType) {
            setGame_types(response.data.gameType);

        }
        else {
            setGame_types([]);
        }



    } catch (error) {
        console.error("Error fetching games:", error);

    }
}; 



useEffect(() => {
const totalPlayers = Number(kids_count) + Number(adults_count);

if(customerById.game_type_id)
{
    const totalPlayers = Number(kids_count) + Number(adults_count);
if ( totalPlayers < game_types.min_players || totalPlayers > game_types.max_players) {
        setTotalPlayersErrorList(`The total number of players must be between ${minPlayers} and ${maxPlayers}.`);
         //setBookingAvailableTimeSlots([]);
    } 
   
       else {
    fetchTimeSlots();
    setTotalPlayersErrorList('');
            }
}

if(customerById.package_name == "Birthday" )
    {
        // setBooking_time([]); // Clear selected time slots
        // setInitialSelectionDone(false); // Reset initial selection state
        // setInitialSelectionSlots([]);
 
        const totalPlayers = Number(kids_count) + Number(adults_count);
        if ( totalPlayers < birthday_packages.min_players || totalPlayers > birthday_packages.max_players_in_a_slot) {
            setTotalPlayersErrorList(`The total number of players must be between  ${birthday_packages.min_players} and ${birthday_packages.max_players_in_a_slot}.`);
            } 
        else {
        fetchGamePackages(1);
        fetchTimeSlotsBirthday();
        setTotalPlayersErrorList('');
        }
    }

    if(customerById.package_name == "Corporate" )
        {
            // setBooking_time([]); // Clear selected time slots
            // setInitialSelectionDone(false); // Reset initial selection state
            // setInitialSelectionSlots([]);
     
            const totalPlayers = Number(kids_count) + Number(adults_count);
            if ( totalPlayers < corporate_packages.min_players || totalPlayers > corporate_packages.max_players_in_a_slot) {
                setTotalPlayersErrorList(`The total number of players must be between  ${corporate_packages.min_players} and ${corporate_packages.max_players_in_a_slot}.`);
                } 
            else {
            fetchCorporateEvents(2);
            fetchTimeSlotsCorporate();
            setTotalPlayersErrorList('');
            }
        }



    }, [adults_count, kids_count, game_count]);

  async function getCustomerList(){
 
    axios.get(`${API_URL}/view-booked-slots`).then(res => {
        if(res.data.status === 200){
          const customer = res.data.bookedSlots;
            setCustomer(customer);
     
        }
        else if(res.data.status === 404){
            //setMessage(res.data.message);
            //console.log(res.data.status);
            }
            
        setIsLoading(false);
     });
       
    }


    
  useEffect(() => {
    if(game_types.length)
    {
        recalculateCosts();
    }
  
}, [kids_count ,adults_count,booking_time]);

useEffect(() => {
    if(game_packages.length)
        {

    recalculateBirthdayCosts();
        }
}, [kids_count, adults_count, booking_time]);

useEffect(() => {
    if(corporate_events.length)
        {

    recalculateCorporateCosts();
        }
}, [kids_count, adults_count, booking_time]);







const recalculateCosts = () => {

 
    if (!isLoading && booking_time && customerById.game_type_id) {


        const filteredGameType = game_types.filter(item => item.id === Number(customerById.game_type_id));
        const adultsFirstPrice = filteredGameType[0].adults_first_price;
        const adultsSecondPrice = filteredGameType[0].adults_second_price;
        const adultsThirdPrice = filteredGameType[0].adults_third_price;
        const depositMethod = filteredGameType[0].deposit_method;
        const depositAmountPerPerson = parseFloat(filteredGameType[0].deposit_amount_per_person).toFixed(2);
        const depositPercentage = parseFloat(filteredGameType[0].deposit_percentage).toFixed(2);
        const minPlayers = filteredGameType[0].min_players;
        const maxPlayers = filteredGameType[0].max_players;
      
      setMinPlayers(minPlayers);
      setMaxPlayers(maxPlayers);

        let totalPrice = 0;
        let slotDetails = {};
      const totalPlayers = Number(kids_count) + Number(adults_count);
     
        if (booking_time.length === 1) {
            totalPrice = adultsFirstPrice * kids_count +
            adultsFirstPrice * adults_count;
         
            slotDetails[booking_time[0]] = {
                time_slot: booking_time[0],
                extra_game: 0,
                extra_player:  0,
                price_for_slot: adultsFirstPrice.toFixed(2),
                total_players: totalPlayers,
                row_total: (adultsFirstPrice * totalPlayers).toFixed(2),
                no_games: 0,
                is_min_game: 0
            };


        } else if (booking_time.length === 2) {
            totalPrice = (adultsFirstPrice * kids_count +
                adultsFirstPrice * adults_count) +
                (adultsSecondPrice * kids_count +
                    adultsSecondPrice* adults_count);

                    
        slotDetails[booking_time[0]] = {
            time_slot: booking_time[0],
            extra_game: 0,
            extra_player:  0,
            price_for_slot: adultsFirstPrice.toFixed(2),
            total_players: totalPlayers,
            row_total: (adultsFirstPrice * totalPlayers).toFixed(2),
            no_games: 0,
            is_min_game: 0
        };

        slotDetails[booking_time[1]] = {
            time_slot: booking_time[1],
            extra_game: 0,
            extra_player:  0,
            price_for_slot: adultsSecondPrice.toFixed(2),
            total_players: totalPlayers,
            row_total: (adultsSecondPrice * totalPlayers).toFixed(2),
            no_games: 0,
            is_min_game: 0
        };
                
        } else if (booking_time.length >= 3) {
            const additionalSlots = booking_time.length - 2;
            totalPrice = (adultsFirstPrice * kids_count +
                adultsFirstPrice * adults_count) +
                (adultsSecondPrice * kids_count +
                    adultsSecondPrice * adults_count) +
                (additionalSlots * (adultsThirdPrice * kids_count +
                    adultsThirdPrice * adults_count));


                    slotDetails[booking_time[0]] = {
                        time_slot: booking_time[0],
                        extra_game: 0,
                        extra_player:  0,
                        price_for_slot: adultsFirstPrice.toFixed(2),
                        total_players: totalPlayers,
                        row_total: (adultsFirstPrice * totalPlayers).toFixed(2),
                        no_games: 0,
                        is_min_game: 0
                    };
        
                    slotDetails[booking_time[1]] = {
                        time_slot: booking_time[1],
                        extra_game: 0,
                        extra_player:  0,
                        price_for_slot: adultsSecondPrice.toFixed(2),
                        total_players: totalPlayers,
                        row_total: (adultsSecondPrice * totalPlayers).toFixed(2),
                        no_games: 0,
                        is_min_game: 0
                    };
        
                    for (let i = 2; i < booking_time.length; i++) {
                        const priceForSlot = adultsThirdPrice;
                        const rowTotal = priceForSlot * totalPlayers;
        
                        slotDetails[booking_time[i]] = {
                            time_slot: booking_time[i],
                            extra_game: 0,
                            extra_player:  0,
                            price_for_slot: priceForSlot.toFixed(2),
                            total_players: totalPlayers,
                            row_total: rowTotal.toFixed(2),
                            no_games: 0,
                            is_min_game: 0
                        };
                    }
                }
        
                setCart_details(slotDetails);
                
  

        setTimeSlotDetails((prev) => ({ ...prev, price: totalPrice }));
        setSub_total(totalPrice);

        const adjustedTotal = parseFloat(customerById.adjusted_total || 0);
        const totalAfterAdjustment = totalPrice + adjustedTotal;


        let discountAmount = 0;
            

  if (discountDetails.length > 0) {
    discountDetails.forEach(discount => {
      if (discount.type === "percentage") {
        discountAmount += totalAfterAdjustment * (Number(discount.value) / 100);
      } else if (discount.type === "amount") {
        discountAmount += Number(discount.value);
      }
    });
   
  }

  let promoAmount = 0;

  if (promoDetails.length > 0) {
    promoDetails.forEach(promo => {
      if (promo.type === "percentage") {
        const percentageDiscount = totalAfterAdjustment * (Number(promo.value) / 100);
        promoAmount += percentageDiscount;
      } else if (promo.type === "amount") {
        promoAmount += Number(promo.value);
      }
    });
  }
  

  const totalDiscount = discountAmount + promoAmount;
  const cappedDiscount = Math.min(totalDiscount, totalAfterAdjustment);


  const discountedPrice = totalAfterAdjustment - cappedDiscount;

        const hst = (discountedPrice * 13) / 100;
         setHst(hst);

        // Calculate grand total
        const grandTotal = discountedPrice + hst;
        const formattedGrandTotal = parseFloat(grandTotal.toFixed(2));

        setGrand_total(formattedGrandTotal);

            // Update customerById state with the new kids_count value
            setCustomerById(prevCustomer => ({
                ...prevCustomer,
                subtotal: totalPrice,
                grand_total: formattedGrandTotal,
                updated_by: userContext.userDetails.id,
                cart_details: JSON.stringify(slotDetails),
            }));



          // Calculate the deposit amount
    let depositAmount = 0;
    if (depositMethod === 1) { // Amount per person
        depositAmount = depositAmountPerPerson * (Number(kids_count) + Number(adults_count))* booking_time.length ;
    } else if (depositMethod === 2) { // Percentage
        depositAmount = (totalPrice * depositPercentage) / 100;
    }
    setDeposit_amount(depositAmount);
    setAmount_paid(depositAmount);

   


    let depositDetails = '';
    if(depositMethod === 1)
    {
      depositDetails = 'Deposit amount per person : ' +depositAmountPerPerson;
      setDeposit_details(depositDetails);
    
    }
    else if (depositMethod === 2)
    {
       depositDetails = 'Deposit amount percentage : ' +depositPercentage;
       setDeposit_details(depositDetails);

    }


    }
    

}


const recalculateBirthdayCosts = () => {
    
    if(!isLoading && booking_time  && customerById.package_name)
    {
   
        const filteredPackage = game_packages.filter(item => item.id === Number(customerById.sub_package_id));
        const birthdayPrice = filteredPackage[0].price_per_game;
        const basicPrice= filteredPackage[0].basic_price;
        const depositAmt= filteredPackage[0].deposit_amount;
        const min_players =filteredPackage[0].min_players;
        const minGames = filteredPackage[0].min_games;

        let totalPrice = basicPrice;
        let slotDetails = {};
        const totalPlayers =  Number(kids_count) + Number(adults_count);

        const totalPlayersExcludingBirthdayKid = totalPlayers > 1 ? totalPlayers - 1 : 0; // Ensure the total doesn't go below 0
       
        const totalSlots = booking_time.length;
        const freeGames = 2; // Number of free games

        // Calculate the number of paid slots
         const paidSlots = totalSlots > freeGames ? totalSlots - freeGames : 0;
        

        const extraPlayers = Math.max(0, totalPlayers - min_players);

      

        if (totalSlots > 0) {
        const extraPlayerCostForBaseGames = extraPlayers * minGames * birthdayPrice; // 3 extra players × 3 games × $10
        setExtraPlayerPrice(extraPlayerCostForBaseGames);
        // Extra game cost (beyond the 3 package games + 2 free games)
        const additionalPaidGames = Math.max(0, totalSlots - (minGames + freeGames)); 
        const extraGameCost = totalPlayersExcludingBirthdayKid * additionalPaidGames * birthdayPrice;
        setExtraGamePrice(extraGameCost);
        // Add extra player & extra game costs only after slot selection
        totalPrice += extraPlayerCostForBaseGames + extraGameCost;

        // Populate slot details
        // for (let i = 0; i < totalSlots; i++) {
        //     const timeSlot = booking_time[i];
        //     slotDetails[timeSlot] = {
        //         time_slot: timeSlot,
        //         price_for_slot: i < freeGames ? 0 : birthdayPrice.toFixed(2),
        //         total_players: totalPlayersExcludingBirthdayKid,
        //         row_total: i < freeGames ? '0.00' : (birthdayPrice * totalPlayersExcludingBirthdayKid).toFixed(2)
        //     };
        // }

        const sortedBookingTime = [...booking_time].sort((a, b) => {
          const parseTime = (timeStr) => new Date("1970/01/01 " + timeStr);
          return parseTime(a.split(" - ")[0]) - parseTime(b.split(" - ")[0]);
      });
      
      // Update initialSelectionSlots with first (minGames + freeGames) slots
      const initialSelectionSlots = sortedBookingTime.slice(0, minGames + freeGames);
      setInitialSelectionSlots(initialSelectionSlots); // If you're storing it in state
      

        let firstTime = initialSelectionSlots[0]?.split(" - ")[0]; // Start time of first slot
        let lastTime = initialSelectionSlots[minGames + freeGames - 1]?.split(" - ")[1]; // End time of last slot
        
        // Merge them into a single time slot
        let mergedTimeSlots = `${firstTime} - ${lastTime}`;

            slotDetails[mergedTimeSlots] = {
                time_slot: mergedTimeSlots,
                extra_player: 0, // Base slot has no extra players initially
                extra_game: 0,   // Base slot has no extra games initially
            // price_for_slot: i < freeGames ? 0 : birthdayPrice.toFixed(2),
                price_for_slot: 0,
                total_players: totalPlayers - totalPlayersExcludingBirthdayKid,
            //   row_total: i < freeGames ? '0.00' : (birthdayPrice * totalPlayersExcludingBirthdayKid).toFixed(2),
                row_total:basicPrice,
            // no_games: freeGames ? 0 : 1,
               no_games: minGames,
               
            // min_games: isInitialSelection ? 1 : 0,
                is_min_game: 1,
        
            };

            if (totalPlayers > min_players) {
                slotDetails["extra_player_price"] = {
                    time_slot: mergedTimeSlots,
                    extra_player: totalPlayers - totalPlayersExcludingBirthdayKid,
                    extra_game: 0,
                    price_for_slot: birthdayPrice.toFixed(2),
                    total_players: totalPlayers - min_players,
                    row_total: (extraPlayers * minGames * birthdayPrice).toFixed(2),
                    no_games: minGames.toString(),
                    is_min_game: 1,
                };
            }

            const extraGameSlots = booking_time.filter((timeSlot) => {
                return !initialSelectionSlots.includes(timeSlot); // Only keep slots that were NOT part of the base package
            });
            

            extraGameSlots.forEach((extraGameSlot, index) => {
                slotDetails[extraGameSlot] = {
                    time_slot: extraGameSlot,
                    //extra_player:  totalPlayers - totalPlayersExcludingBirthdayKid,
                    extra_player:  0,
                    extra_game: 1,
                    price_for_slot: birthdayPrice.toFixed(2),
                    total_players: totalPlayersExcludingBirthdayKid,
                    row_total: (totalPlayersExcludingBirthdayKid * birthdayPrice).toFixed(2),
                    //no_games:(freeGames + minGames) + index,
                    no_games:1,
                    is_min_game: 0,
                };
            });
        

                    setCart_details(slotDetails);

                    setBirthdayPrice((prev) => ({ ...prev, price: totalPrice }));
                    setSub_total(totalPrice);

                    const adjustedTotal = parseFloat(customerById.adjusted_total || 0);
                    const totalAfterAdjustment = totalPrice + adjustedTotal;



        let discountAmount = 0;
            

  if (discountDetails.length > 0) {
    discountDetails.forEach(discount => {
      if (discount.type === "percentage") {
        discountAmount += totalAfterAdjustment * (Number(discount.value) / 100);
      } else if (discount.type === "amount") {
        discountAmount += Number(discount.value);
      }
    });
   
  }

  let promoAmount = 0;

  if (promoDetails.length > 0) {
    promoDetails.forEach(promo => {
      if (promo.type === "percentage") {
        const percentageDiscount = totalAfterAdjustment * (Number(promo.value) / 100);
        promoAmount += percentageDiscount;
      } else if (promo.type === "amount") {
        promoAmount += Number(promo.value);
      }
    });
  }
  

  const totalDiscount = discountAmount + promoAmount;
  const cappedDiscount = Math.min(totalDiscount, totalAfterAdjustment);


  const discountedPrice = totalAfterAdjustment - cappedDiscount;

            
                const hst = (discountedPrice * 13) / 100;
                setHst(hst);
            
                const grandTotal = discountedPrice + hst;
                const formattedGrandTotal = parseFloat(grandTotal.toFixed(2));
            
            
                setGrand_total(formattedGrandTotal);
            
                // Update customerById state with the new kids_count value
                setCustomerById(prevCustomer => ({
                    ...prevCustomer,
                    subtotal: totalPrice,
                    grand_total: formattedGrandTotal,
                    game_count: paidSlots,
                    updated_by: userContext.userDetails.id,
                    cart_details: JSON.stringify(slotDetails),
                    extra_player_price: extraPlayerCostForBaseGames,
                    extra_game_price: extraGameCost,
                }));
           // console.log(totalSlots, extraPlayerCostForBaseGames,extraGameCost )

          }
      

    const calculatedDeposit = (totalPrice * 50) / 100;
    setDeposit_amount(calculatedDeposit.toFixed(2));
  //  setDeposit_amount(depositAmt);


    setAmount_paid(calculatedDeposit.toFixed(2));
 
    setBasic_price(basicPrice);

        if(customerById.package_name && birthday_packages.min_games)  
    { 
        setMin_game(birthday_packages.min_games);
    }

    let depositDetails = '';
      depositDetails = 'Package basic price : ' +depositAmt;
      setDeposit_details(depositDetails);


    }
}

const recalculateCorporateCosts = () => {
    
    if(!isLoading && booking_time  && customerById.corporate_package_name)
    {
   
        const filteredPackage = corporate_events.filter(item => item.id === Number(customerById.sub_package_id));
        const corporatePrice = filteredPackage[0].price_per_game;
        const basicPrice= filteredPackage[0].basic_price;
        const depositAmt= filteredPackage[0].deposit_amount;
        const min_players =filteredPackage[0].min_players;
        const minGames = filteredPackage[0].min_games;

        let totalPrice = basicPrice;
        let slotDetails = {};
        const totalPlayers =  Number(kids_count) + Number(adults_count);

        const totalPlayersExcludingBirthdayKid = totalPlayers > 1 ? totalPlayers - 1 : 0; // Ensure the total doesn't go below 0
       
        const totalSlots = booking_time.length;
        const freeGames = 2; // Number of free games

        // Calculate the number of paid slots
        const paidSlots = totalSlots > freeGames ? totalSlots - freeGames : 0;
        // const totalPriceForPaidSlots = corporatePrice * totalPlayers * paidSlots;

        // totalPrice += totalPriceForPaidSlots; // Add the calculated price


        const extraPlayers = Math.max(0, totalPlayers - min_players);

        if (totalSlots > 0) {
        const extraPlayerCostForBaseGames = extraPlayers * minGames * corporatePrice; // 3 extra players × 3 games × $10
        setExtraPlayerPrice(extraPlayerCostForBaseGames);
        // Extra game cost (beyond the 3 package games + 2 free games)
        const additionalPaidGames = Math.max(0, totalSlots - (minGames + freeGames)); 
        const extraGameCost = totalPlayersExcludingBirthdayKid * additionalPaidGames * corporatePrice;
        setExtraGamePrice(extraGameCost);
        // Add extra player & extra game costs only after slot selection
        totalPrice += extraPlayerCostForBaseGames + extraGameCost;



        const sortedBookingTime = [...booking_time].sort((a, b) => {
          const parseTime = (timeStr) => new Date("1970/01/01 " + timeStr);
          return parseTime(a.split(" - ")[0]) - parseTime(b.split(" - ")[0]);
      });
      
      // Update initialSelectionSlots with first (minGames + freeGames) slots
      const initialSelectionSlots = sortedBookingTime.slice(0, minGames + freeGames);
      setInitialSelectionSlots(initialSelectionSlots); // If you're storing it in state

        let firstTime = initialSelectionSlots[0]?.split(" - ")[0];
        let lastTime = initialSelectionSlots[minGames + freeGames - 1]?.split(" - ")[1];
        let mergedTimeSlots = `${firstTime} - ${lastTime}`;

        slotDetails[mergedTimeSlots] = {
          time_slot: mergedTimeSlots,
          extra_player: 0, // Base slot has no extra players initially
          extra_game: 0,   // Base slot has no extra games initially
         // price_for_slot: i < freeGames ? 0 : birthdayPrice.toFixed(2),
          price_for_slot: 0,
          total_players: totalPlayers - totalPlayersExcludingBirthdayKid,
       //   row_total: i < freeGames ? '0.00' : (birthdayPrice * totalPlayersExcludingBirthdayKid).toFixed(2),
         row_total:basicPrice,
        // no_games: freeGames ? 0 : 1,
        no_games: minGames,
         // min_games: isInitialSelection ? 1 : 0,
          is_min_game: 1,
     
      };

      if (totalPlayers > min_players) {
          slotDetails["extra_player_price"] = {
              time_slot: mergedTimeSlots,
              extra_player: totalPlayers - totalPlayersExcludingBirthdayKid,
              extra_game: 0,
              price_for_slot: corporatePrice.toFixed(2),
              total_players: totalPlayers - min_players,
              row_total: (extraPlayers * minGames * corporatePrice).toFixed(2),
              no_games: minGames.toString(),
              is_min_game: 1,
          };
      }

      const extraGameSlots = booking_time.filter((timeSlot) => {
          return !initialSelectionSlots.includes(timeSlot); // Only keep slots that were NOT part of the base package
      });
      

      extraGameSlots.forEach((extraGameSlot, index) => {
          slotDetails[extraGameSlot] = {
              time_slot: extraGameSlot,
              //extra_player:  totalPlayers - totalPlayersExcludingBirthdayKid,
              extra_player:  0,
              extra_game: 1,
              price_for_slot: corporatePrice.toFixed(2),
              total_players: totalPlayersExcludingBirthdayKid,
              row_total: (totalPlayersExcludingBirthdayKid * corporatePrice).toFixed(2),
              //no_games:(freeGames + minGames) + index,
              no_games:1,
              is_min_game: 0,
          };
      });

    
    setCart_details(slotDetails);
    setCorporatePrice((prev) => ({ ...prev, price: totalPrice }));
    setSub_total(totalPrice);

    const adjustedTotal = parseFloat(customerById.adjusted_total || 0);
    const totalAfterAdjustment = totalPrice + adjustedTotal;


        let discountAmount = 0;
            

  if (discountDetails.length > 0) {
    discountDetails.forEach(discount => {
      if (discount.type === "percentage") {
        discountAmount += totalAfterAdjustment * (Number(discount.value) / 100);
      } else if (discount.type === "amount") {
        discountAmount += Number(discount.value);
      }
    });
   
  }

  let promoAmount = 0;

  if (promoDetails.length > 0) {
    promoDetails.forEach(promo => {
      if (promo.type === "percentage") {
        const percentageDiscount = totalAfterAdjustment * (Number(promo.value) / 100);
        promoAmount += percentageDiscount;
      } else if (promo.type === "amount") {
        promoAmount += Number(promo.value);
      }
    });
  }
  

  const totalDiscount = discountAmount + promoAmount;
  const cappedDiscount = Math.min(totalDiscount, totalAfterAdjustment);


  const discountedPrice = totalAfterAdjustment - cappedDiscount;


const hst = (discountedPrice * 13) / 100;
setHst(hst);

const grandTotal = discountedPrice + hst;
const formattedGrandTotal = parseFloat(grandTotal.toFixed(2));


setGrand_total(formattedGrandTotal);

// Update customerById state with the new kids_count value
setCustomerById(prevCustomer => ({
    ...prevCustomer,
    subtotal: totalPrice,
    grand_total: formattedGrandTotal,
    game_count: paidSlots,
    updated_by: userContext.userDetails.id,
    cart_details: JSON.stringify(slotDetails),
    extra_player_price: extraPlayerCostForBaseGames,
    extra_game_price: extraGameCost,
}));


}
                


    setDeposit_amount(depositAmt);


    setAmount_paid(depositAmt);
 
    setBasic_price(basicPrice);

        if(customerById.corporate_package_name && corporate_packages.min_games)  
    { 
        setMin_game(corporate_packages.min_games);
    }

    let depositDetails = '';
      depositDetails = 'Package basic price : ' +depositAmt;
      setDeposit_details(depositDetails);


    }
}


const fetchOptionsForBirthdayPackage = async () => {
    try {
   
      const response = await axios.get(`${API_URL}/view-game-package-by-selectedBirthdayId/${customerById.game_package_id}`);
      setBirthday_packages(response.data.gamePackages[0]);

     const foodDetails = response.data.gamePackages[0].food_details || '';
  const drinkDetails = response.data.gamePackages[0].drink_details || '';

     setFoodOptions(foodDetails.split(',').map(item => item.trim()).filter(item => item));
    setDrinkOptions(drinkDetails.split(',').map(item => item.trim()).filter(item => item));
   setMin_game(response.data.gamePackages[0].min_games)
} catch (error) {
      console.error("Error fetching birthday Package:", error);
    }
  };


  const fetchOptionsForCorporatePackage = async () => {
    try {
   
      const response = await axios.get(`${API_URL}/view-corporate-event-by-selectedCorporateId/${customerById.sub_package_id}`);
      setCorporate_packages(response.data.corporateEvents[0]);

     const foodDetails = response.data.corporateEvents[0].food_details || '';
  const drinkDetails = response.data.corporateEvents[0].drink_details || '';

//   setEventFoodOptions(foodDetails.split(',').map(item => item.trim()).filter(item => item));
//   setEventDrinkOptions(drinkDetails.split(',').map(item => item.trim()).filter(item => item));
   setEventGame_count(response.data.corporateEvents[0].min_games)
} catch (error) {
      console.error("Error fetching locations:", error);
    }
  };



const handleEmailToggle = () => {
    setIsEmail(!isEmail); // Toggle the isEmail state
};



const calculateTimeSlots = (startTime, endTime, interval) => {
    const timeSlots = [];
    const [startHour, startMinute, startSecond] = startTime.split(':').map(Number);
    const [endHour, endMinute, endSecond] = endTime.split(':').map(Number);

    let current = new Date();
    current.setHours(startHour, startMinute, startSecond, 0);

    const end = new Date();
    end.setHours(endHour, endMinute, endSecond, 0);

    while (current <= end) {
      const timeSlot = current.toTimeString().split(' ')[0]; // 'HH:mm:ss' format
      timeSlots.push(timeSlot);
      current.setMinutes(current.getMinutes() + interval);
    }

    return timeSlots;
  };


    function getEmailTemplateList()
    {    
      axios.get(`${API_URL}/view-email-template`).then(res=>{
          if(res.data.status === 200){
              setEmail_template(res.data.emailTemplate);       
          }     
          else if(res.data.status === 404){
            setEmail_template([]);
             // setMessage(res.data.message);     
              }             
       });    
    }

    function getSmsTemplateList()
    {    
      axios.get(`${API_URL}/view-sms-template`).then(res=>{
          if(res.data.status === 200){
              setSms_template(res.data.smsTemplate);       
          }     
          else if(res.data.status === 404){
            setSms_template([]);
             // setMessage(res.data.message);     
              }             
       }); 
       
       
    }

    function getNoteTemplateList()
    {    
      axios.get(`${API_URL}/view-note-template`).then(res=>{
          if(res.data.status === 200){
              setNote_template(res.data.noteTemplate);       
          }     
          else if(res.data.status === 404){
            setNote_template([]);
             // setMessage(res.data.message);     
              }             
       });    
    }

    function getTeamList()
    {    
     
    axios.get(`${API_URL}/view-team-members`).then(res=>{
          if(res.data.status === 200){
              setTeam(res.data.team); 
              // console.log(res.data.team); 
               setIsTeamLoaded(true);     
          }     
          else if(res.data.status === 404){
            setTeam([]);
             setIsTeamLoaded(true);
             // setMessage(res.data.message);     
              }             
       });    
    }


    function getPinTemplateList()
    {    
      axios.get(`${API_URL}/view-pin-template`).then(res=>{
          if(res.data.status === 200){
              setPin_template(res.data.pinTemplate);       
          }     
          else if(res.data.status === 404){
            setPin_template([]);
             // setMessage(res.data.message);     
              }             
       });    
    }
   

    const formatBookedTime = (bookedTime) => {
        try {
          const timeSlots = JSON.parse(bookedTime); // Assuming bookedTime is a JSON string
          if (Array.isArray(timeSlots) && timeSlots.length > 0) {
            
            // Sort time slots by start time before merging
            const sortedSlots = timeSlots.sort((a, b) => {
              const [startA] = a.split(' - ');
              const [startB] = b.split(' - ');
              return moment(startA, 'hh:mm A').diff(moment(startB, 'hh:mm A'));
            });
      
            let mergedSlots = [];
            let currentRangeStart = null;
            let currentRangeEnd = null;
      
            sortedSlots.forEach((slot, index) => {
              const [startTime, endTime] = slot.split(' - ');
              const currentStartTime = moment(startTime, 'hh:mm A');
              const currentEndTime = moment(endTime, 'hh:mm A');
      
              if (!currentRangeStart) {
                // First time slot, initialize the range
                currentRangeStart = currentStartTime;
                currentRangeEnd = currentEndTime;
              } else if (currentRangeEnd.isSame(currentStartTime)) {
                // If the current slot starts when the last one ended, extend the range
                currentRangeEnd = currentEndTime;
              } else {
                // If the current slot does not continue from the last one, close the current range and start a new one
                mergedSlots.push(`${currentRangeStart.format('h:mm A')} - ${currentRangeEnd.format('h:mm A')}`);
                currentRangeStart = currentStartTime;
                currentRangeEnd = currentEndTime;
              }
      
              // If it's the last slot, push the current range
              if (index === sortedSlots.length - 1) {
                mergedSlots.push(`${currentRangeStart.format('h:mm A')} - ${currentRangeEnd.format('h:mm A')}`);
              }
            });
      
            return mergedSlots.join(', '); // Join the merged slots with a comma
          }
          return 'No time slots available';
        } catch (error) {
          console.error("Error parsing booked time:", error);
          return 'Invalid time format';
        }
      };
      
      useEffect(() => {
        if (customerById && customerById.grand_total) {
        //  console.log("Updated customerById.grand_total:", customerById.grand_total);
        }
      }, [customerById.grand_total]);
      

    function getCustomerById(id){

        setIsLoading(true);
        axios.get(`${API_URL}/view-booked-slots-by-id/`+id).then(res=>{
            if(res.data.status === 200){
                const bookedSlot = res.data.bookedSlot;
                // console.log( res.data.bookedSlot, 'history',res.data.customerBookedHistory,
                //     'bookedSlotLogs',  res.data.bookedSlotsLogs, 'email',res.data.emailLogs,
                //      'smsLogs', res.data.smsLogs, 'sortedLogs', res.data.sortedLogs,
                //       'payments',res.data.payments, 'transactions',res.data.transactions,
                //     ); 
         //  console.log(res.data.bookedSlot)
      const formattedBookedTime = formatBookedTime(bookedSlot.booked_time);

      
      let parsedCartDetails = [];

      try {
        if (bookedSlot.cart_details) {
          parsedCartDetails = typeof bookedSlot.cart_details === "string"
            ? JSON.parse(bookedSlot.cart_details)
            : bookedSlot.cart_details;
        }
      } catch (err) {
        console.error("Failed to parse cart_details:", err);
      }


 let parsedDiscountDetails = [];

      try {
        if (bookedSlot.discount_details) {
          parsedDiscountDetails = typeof bookedSlot.discount_details === "string"
            ? JSON.parse(bookedSlot.discount_details)
            : bookedSlot.discount_details;
        }
      } catch (err) {
        console.error("Failed to parse discount_details:", err);
      }

      let parsedPromoDetails = [];

      try {
        if (bookedSlot.promo_details) {
          parsedPromoDetails = typeof bookedSlot.promo_details === "string"
            ? JSON.parse(bookedSlot.promo_details)
            : bookedSlot.promo_details;
        }
      } catch (err) {
        console.error("Failed to parse promo_details:", err);
      }

      setCustomerById({
          ...bookedSlot,
          booked_time_formatted: formattedBookedTime,
          booking_time: bookedSlot.booked_time,
          consent_form_details: bookedSlot.consent_form_details ? JSON.parse(bookedSlot.consent_form_details) : [],
          kids_form_details: bookedSlot.kids_form_details ? JSON.parse(bookedSlot.kids_form_details) : [],
         // cart_details: bookedSlot?.cart_details ? JSON.parse(bookedSlot.cart_details) : [],
          cart_details: parsedCartDetails,
          discount_details: parsedDiscountDetails,
          promo_details: parsedPromoDetails,
        });
      


             setDiscountDetails(parsedDiscountDetails);
            setPromoDetails(parsedPromoDetails);
            setInitialSelectionDone(true);
            setSub_total(bookedSlot.subtotal);
            setGrand_total(bookedSlot.grand_total);
          //  setAdjusted_total(bookedSlot.adjusted_total);
           
            setBooking_date(bookedSlot.booked_date);
            setGame_count(bookedSlot.no_of_slots);
            setBooking_time(JSON.parse(bookedSlot.booked_time));
            // setInitialSelectionSlots(JSON.parse(bookedSlot.booked_time));
            // setInitialSelectionDone(true); // simulate the first selection already done
            setAdults_count(bookedSlot.no_of_adults);   
            setKids_count(bookedSlot.no_of_children);

            // setSelectedFoods(JSON.parse(bookedSlot?.food_details));   
            // setSelectedDrinks(JSON.parse(bookedSlot?.drink_details));  
            setSelectedFoods(bookedSlot.food_details ? JSON.parse(bookedSlot.food_details) : {}); 
            setSelectedDrinks(bookedSlot.drink_details ? JSON.parse(bookedSlot.drink_details) : {});
           if(bookedSlot.staff){
            const staffArray = bookedSlot.staff.split(",").map((id) => id.trim());
            setSelectedStaff(staffArray);
           }
     
          
          setCustomerBookedHistory(res.data.customerBookedHistory);
          setBookedSlotLogById(res.data.bookedSlotsLogs);
          setEmailLogById(res.data.emailLogs);
          setSmsLogById(res.data.smsLogs);
          setNoteLogById(res.data.sortedLogs);

          setPaymentLinkById(res.data.paymentLink);
          
          const adjustmentHis = res.data.adjustmentLogs.filter(item => item.is_delete === 0);

          const totalAdjustment = adjustmentHis.reduce((sum, item) => {
            return sum + parseFloat(item.adjustment_amount || 0);
          }, 0);
          setAdjusted_total(totalAdjustment);

          setAdjustmentHistory(res.data.adjustmentLogs.filter(item=> item.is_delete === 0));
          setAdjustmentDeleteHistory(res.data.adjustmentLogs.filter(item => item.is_delete === 1));

          setPaymentHistory(res.data.payments.filter(payment => payment.is_deleted === 0));
          setPaymentDeleteHistory(res.data.payments.filter(payment => payment.is_deleted === 1));
          setPaymentOnlyDeleteHistory(res.data.payments.filter(payment => payment.is_deleted === 1 && payment.is_refund === 0));
          setGeneratePaymentAmount(
            (
              (bookedSlot.grand_total) -
              res.data.payments
                .filter(payment => payment.is_deleted === 0)
                .reduce((total, payment) => total + parseFloat(payment.payment_amount || 0), 0)
            ).toFixed(2)
          );
          
      
        //   if(res.data.transactions)
        //   {
            setTransactions(res.data.transactions);
            setToEmail(bookedSlot.email);
        //   }
       
        //  console.log(res.data.sortedLogs)

            }
            else if(res.data.status === 404){
                //setMessage(res.data.message);
             
                //setIsLoading(false);
                }
          
                let defaultTab = 'info';
        
                //          if (inquiry.includes(latestActivity)) {
                //             defaultTab = 'inquiry';
                //          } else if (emailLogs.includes(latestActivity)) {
                //              defaultTab = 'email';
                //          } else if (smsLogs.includes(latestActivity)) {
                //              defaultTab = 'sms';
                //          } else if (noteLogs.includes(latestActivity)) {
                //              defaultTab = 'note';
                //          } else if (meetLogs.includes(latestActivity)) {
                //              defaultTab = 'meet';
                //          } else if (uploadDocuments.includes(latestActivity)) {
                //              defaultTab = 'upload';
                //          } else if (booking.includes(latestActivity)) {
                //             defaultTab = 'booking';
                //         }
            
              setActiveButton(defaultTab);
      
            //   console.log(activeButton);
            setIsLoading(false);
         });


      
        }

        

function handleChange(event) {
    const { name, value } = event.target;

    // Update the state based on the input field
    setCustomerById(prevState => ({
        ...prevState,
        [name]: value
    }));
}

        useEffect(() => {
            // Optional: Perform actions when `activeButton` changes
            setActiveButton(activeButton);
         
        }, [activeButton]);

  
    function getEmaillogbyId(id){
        axios.get(`${API_URL}/view-booked-slots-by-id/`+id).then(res=>{
            const bookedSlot = res.data.bookedSlot;
       
      const formattedBookedTime = formatBookedTime(bookedSlot.booked_time);

    
      setCustomerById({
          ...bookedSlot,
          booked_time_formatted: formattedBookedTime,
          consent_form_details: bookedSlot.consent_form_details ? JSON.parse(bookedSlot.consent_form_details) : [],
          kids_form_details: bookedSlot.kids_form_details ? JSON.parse(bookedSlot.kids_form_details) : []
      
        });
            //setEmail(res.data.customer[0].email);
            // setInquiryById(res.data.inquiry);
            setEmailLogById(res.data.emailLogs);
            // setInqueryVisible(false);
            setInfoVisible(false);
            setHistoryVisible(false);
            setCallVisible(false);
            setEmailVisible(true);
            setTextVisible(false);
            // setPinVisible(false);
            // setMeetVisible(false);
            // setNoteVisible(false);
            // setUploadVisible(false);
        });  
 
    }
    

    function getSmslogbyId(id){

        // axios.get(`${API_URL}/view-customer-by-id/`+id).then(res=>{

            axios.get(`${API_URL}/view-booked-slots-by-id/`+id).then(res=>{
                const bookedSlot = res.data.bookedSlot;
           
          const formattedBookedTime = formatBookedTime(bookedSlot.booked_time);
    
          setCustomerById({
              ...bookedSlot,
              booked_time_formatted: formattedBookedTime,
              consent_form_details: bookedSlot.consent_form_details ? JSON.parse(bookedSlot.consent_form_details) : [],
              kids_form_details: bookedSlot.kids_form_details ? JSON.parse(bookedSlot.kids_form_details) : []
          
            });


           // setCustomerById(res.data.customer);
            setSmsLogById(res.data.smsLogs);
            // setInqueryVisible(false);
            setCallVisible(false);
            setEmailVisible(false);
            setTextVisible(true);
            // setPinVisible(false);
            // setMeetVisible(false);
            setNoteVisible(false);
            // setUploadVisible(false);

        });  

    }

    function getMeetlogbyId(id){
        axios.get(`${API_URL}/view-customer-by-id/`+id).then(res=>{
            setCustomerById(res.data.customer);
            setMeetLogById(res.data.meetLogs);
            setInqueryVisible(false);
            setCallVisible(false);
            setEmailVisible(false);
            setTextVisible(false);
            setPinVisible(false);
            setMeetVisible(true);
            setNoteVisible(false);
            setUploadVisible(false);
        });  
 
    }
     
    function getNotelogbyId(id){
        axios.get(`${API_URL}/view-booked-slots-by-id/`+id).then(res=>{
                const bookedSlot = res.data.bookedSlot;
           
          const formattedBookedTime = formatBookedTime(bookedSlot.booked_time);
    
          setCustomerById({
              ...bookedSlot,
              booked_time_formatted: formattedBookedTime,
              consent_form_details: bookedSlot.consent_form_details ? JSON.parse(bookedSlot.consent_form_details) : [],
              kids_form_details: bookedSlot.kids_form_details ? JSON.parse(bookedSlot.kids_form_details) : []
          
            });
            // setCustomerById(res.data.customer);
            setNoteLogById(res.data.sortedLogs);
            // console.log(res.data.sortedLogs)
            // setInqueryVisible(false);
            setInfoVisible(false);
            setCallVisible(false);
            setEmailVisible(false);
            setTextVisible(false);
            // setPinVisible(false);
            // setMeetVisible(false);
            setNoteVisible(true);
            // setUploadVisible(false);
        });  
 
    }

    function getUploadlogbyId(id){
        axios.get(`${API_URL}/view-customer-by-id/`+id).then(res=>{
            setCustomerById(res.data.customer);
            setUploadLogById(res.data.uploadDocuments);
            setInqueryVisible(false);
            setCallVisible(false);
            setEmailVisible(false);
            setTextVisible(false);
            setPinVisible(false);
            setMeetVisible(false);
            setNoteVisible(false);
            setUploadVisible(true);
        });  
 
    }
     


 

 const handleSelectAllTeam = (event) => {
    if (event.target.checked) {
      const allTeamIds = team.map(member => member.id.toString()); // Convert all ids to strings for comparison
      setTeam_select(allTeamIds);
    } else {
      setTeam_select([]);
    }
  };
 

 const handleSelectAll = (e) => {
    const checked = e.target.checked;
    const allItemIds = filteredInventory.map((item) => item.id);
    if (checked) {
      setSelectedRows(allItemIds);
   //console.log(allItemIds);
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (e, id) => {
      const checked = e.target.checked;
      let updatedSelectedRows;
    
      if (checked) {
        updatedSelectedRows = [...selectedRows, id];
      } else {
        updatedSelectedRows = selectedRows.filter((row) => row !== id);
      }
    
      setSelectedRows(updatedSelectedRows);
  
      const allRowsSelected = filteredInventory.every((item) => updatedSelectedRows.includes(item.id));
  
      selectAllCheckboxRef.current.checked = allRowsSelected; // Assuming you have a ref to the "Select All" checkbox
    };
  




    const resetEmail = () => {
        setTemplate([]);
        setSubject("");
        setMessage("");
        setImages([]);
        setVideos([]);
        setPreviews([]);
        setPreviewsVideo([]);
        setSuccessMessage("");
        setLoading(false);
         };

         const resetMeeting = () => {
            setTitle("");
            setDate("");
            setTime("");
             };
    


             const resetBooking = () => {
                setGame_location("");
                setGame_type("");
                setBooking_date("");
                setBooking_time("");
                setKids_count(0);
                setAdults_count(0);
                setTimeSlotById((prev) => ({ ...prev, price: 0 }));
                 };




             const resetNote = () => {
                setNote_template_select("");
                setNote_subject("");
                setNote_message("");
                setIsEmail(false);  
                 };

                 const resetPayment = () => {
                    setPayment_method("");
                    const today = new Date();
          //  setPayment_date(today.toISOString().split("T")[0]);
             setPayment_date(today.toLocaleDateString("en-CA", {timeZone: 'America/Toronto'}));
                     };

                 const resetUpload = () => {
                    setUpload_template_select("");
                    setUpload_subject("");
                    setUpload_message("");
                    setImages([]);
                    setPreviews([]);
                     };

         const getFileType = (url) => {
            const extension = url.split('.').pop().toLowerCase();
            switch (extension) {
                case 'jpg':
                case 'jpeg':
                case 'png':
                    case 'webp':
                    return 'image';
                case 'pdf':
                    return 'pdf';
                case 'mp4':
                case 'avi':
                case 'mov':
                    return 'video';
                // Add more file types as needed
                default:
                    return 'unknown';
            }
        };
   
    const handleTemplateChange  = (event) => {
        setTemplate(event.target.value);
        if(event.target.value){
            const template_details = email_template.find(item=> item.template_name === event.target.value);
            setTemplate_details(template_details);
            setSubject(template_details.subject);
            setMessage(template_details.message);
            if (template_details.image_path) {

                const filepathArray = template_details.image_path.split(',');
                const imageUrlArray = filepathArray.map(filepath => `${LARAVEL_API_URL}/${filepath}`);
                setPreviews(imageUrlArray);
    
                const initialPreviewsPromises = imageUrlArray.map(async filepath => {
                    const filename = filepath.substring(filepath.lastIndexOf('/') + 1); // Extract filename from URL
                    const fileType = filename.split('.').pop().toLowerCase(); // Extract file extension and convert to lowercase
                
                    if (fileType === 'pdf') {
                        // For PDF files
                        try {
                            const response = await fetch(filepath);
                            const blob = await response.blob();
                            return new File([blob], filename, { type: 'application/pdf' });
                        } catch (error) {
                            console.error('Error fetching PDF file:', error);
                            return null;
                        }
                    } else if (['mp4', 'webm', 'ogg'].includes(fileType)) {
                        try {
                            const response = await fetch(filepath);
                            const blob = await response.blob();
                            return new File([blob], filename, { type: `video/${fileType}` });
                        } catch (error) {
                            console.error('Error fetching video:', error);
                            return null;
                        }
                    } else {
                        // For image files
                        try {
                            const response = await fetch(filepath);
                            const blob = await response.blob();
                            return new File([blob], filename, { type: `image/${fileType}` });
                        } catch (error) {
                            console.error('Error fetching image:', error);
                            return null;
                        }
                    }
                });
                
                Promise.all(initialPreviewsPromises)
                    .then(initialPreviews => {
                        // Filter out null values (in case of error)
                        const filteredPreviews = initialPreviews.filter(preview => preview !== null);
                        setImages(filteredPreviews);
                      //  console.log(filteredPreviews)
                    })
                    .catch(error => {
                        console.error('Error creating initial previews:', error);
                        setImages([]); // Set empty array in case of error
                    });
                
                const updatedPreviews = imageUrlArray.map(url => {
                    const fileType = getFileType(url);
                    return { type: fileType, url: url };
                });
                setPreviews(updatedPreviews);
            } 
            // if (template_details.video_path) {
            //     const filepathArray = template_details.video_path.split(',');
            //     const videoUrlArray = filepathArray.map(filepath => `${LARAVEL_API_URL}/${filepath}`);
            //     setPreviewsVideo(videoUrlArray);
    
            //     // Set videos based on preview videos
            //     const videoFiles = videoUrlArray.map(async url => {
            //         const res = await fetch(url);
            //         const blob = await res.blob();
    
            //         // Extract filename from URL
            //         const filename = url.substring(url.lastIndexOf('/') + 1);
    
            //         return new File([blob], filename, { type: "video/mp4" });
            //     });
            //     Promise.all(videoFiles).then(videos => {
            //         setVideos(videos);
            //     });
            // } else {
            //     setPreviewsVideo([]);
            //     setVideos([]);
            // }
        }
        else
        {   setTemplate(""); 
            setTemplate_details([]);
            setSubject("");
            setMessage("");
            setPreviews([]);
            setImages([]);
        }
        };

     

        const sendEmail = (e) => {
            e.preventDefault();
            setLoading(true);
            // let emailArray;
            // emailArray = email.split(",");

            let emailArray;
            emailArray =   toEmail.split(",");
          
                // const formattedMessage = (template_details?.message ?? '').replace(/\n/g, '<br>');
                    
            // const messageWithLogo = `<img src="https://www.attodesk.com/Auttodesk-Black.png" alt="Attodesk Logo Big" width="140" /><br><br>${formattedMessage}`;
          
            // let message = template_details?.message ?? ''; 

            const consentFormUrl = `${API_BASE_URL}/consent-form-page/${customerById.booking_ref_id}/${customerById.booking_id}`;
           
            let processedMessage  = convertPlainTextToHTML(message)
            .replace('[customer_name]', `${customerById.firstname} ${customerById.lastname}`)
            .replace('[event_date]', moment(customerById.booked_date).format('D MMMM YYYY'))
            .replace('[event_time]', customerById.booked_time_formatted)  // Joining the times array into a string
            .replace('[location]', customerById.location_name)
            .replace('[number_of_players]', customerById.total_players)
            .replace('[package_name]', 
                customerById.game_type_name ||
                        (customerById.package_name === 'Corporate' 
                          ? `${customerById.package_name} - ${customerById.corporate_package_name}`
                          : `${customerById.package_name} - ${customerById.game_package_name}`
                        ))
                // customerById.game_type_name || `${customerById.package_name} - ${customerById.game_package_name}`)
            .replace('[consent_form_link]', `<a href="${consentFormUrl}">Click here to complete the consent form</a>`)
            .replace('[qr_code]', `<img src="${LARAVEL_API_URL}/uploads/qrImages/${customerById.booking_ref_id}.png" alt="QR Code for Consent Form" />`);


            const formData = new FormData();
            // formData.append("customer_id", id);
            formData.append("booking_id", id);
            formData.append("to", emailArray);
            formData.append("subject", subject);
            formData.append("message", processedMessage );
            // if(template_details.message){
            //     formData.append("message", formattedMessage);
            // }
            // else{
            //     formData.append("message", message);
            // }
           
          
            images.forEach((image, index) => {
              formData.append(`image[${index}]`, image);
            });

           
          
            // videos.forEach((video, index) => {
            //   formData.append(`video[${index}]`, video);
            // });
          
            axios.post(`${API_URL}/send-email-attachment`, formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
                
              }
              )
              .then(() => {
                
               // console.log("Email sent successfully");
               showToast("Email sent successfully!"); 
               
                // setSuccessMessage("Email sent successfully!");
                setLoading(false);
                setTemplate_details([]);
                resetEmail();
                getEmaillogbyId(id);
                setEmailErrorList([]);
                setToEmail(customerById.email);
              })
              .catch((error) => {
                setLoading(false);
                setEmailErrorList(error.response.data.validate_err);
                //console.error("Error sending email:", error.response.data);
                Swal.fire({
                    text:error.response.data.message,
                    icon:"error"
                  })

              });
          };

          function convertPlainTextToHTML(text) {
            return text
                .replace(/\n/g, '<br>')  // Replace line breaks with <br>
                .replace(/ {2,}/g, match => '&nbsp;'.repeat(match.length));  // Replace multiple spaces with &nbsp;
        }

        

          const sendSMS = async () => {
            setLoading(true);

              try {

              
        const response = await axios.post(`${API_URL}/send-sms`, {
        booking_id: id,
        phone_no: customerById.phone,
        message: text_message,
        send_as_template: isTemplate,
     
    });

      if (response.data.status === "success") {
        // Update message history, or show a success message
              showToast("SMS sent successfully!"); 
              setText_template_details([]);
              resetSms();
              getSmslogbyId(id);
              setErrorList([]);
              setLoading(false);
              //console.log(response);
            
      }
      
     
    } catch (error) {
        setLoading(false);
        setErrorList({ message: "Failed to send message!" });
      console.error("Error sending message", error);

           Swal.fire({
                text: error.response.data.message,  // Use the extracted or default error message
                icon: "error"
            });
    }

          
        //     const formData = new FormData();
        //     // formData.append("customer_id", id);
        //     formData.append("booking_id", id);
        //     formData.append("phone_no", customerById.phone);
        //     formData.append("message", text_message);


        //       await  axios.post(`${API_URL}/send-sms`, formData) .then(() => {
        //     //   console.log('SMS sent successfully:', response.data);
        //       showToast("SMS sent successfully!"); 
        //       setText_template_details([]);
        //       resetSms();
        //       getSmslogbyId(id);
        //        setErrorList([]);
        //       setLoading(false);
            
        //     })
        //     .catch((error) => {
        //         setLoading(false);
        //       //console.error('Failed to send SMS:', error);      
        //         // Check if error.response and error.response.data exist
        //         const errorMessage = error.response && error.response.data && error.response.data.message
        //         ? error.response.data.message
        //         : "Failed to send message!"; // Default error message

        //     setErrorList({ message: errorMessage });

        //     Swal.fire({
        //         text: errorMessage,  // Use the extracted or default error message
        //         icon: "error"
        //     });
        
           
        
        //     //   showToastFail("Failed to send SMS");
        //     });
           };


          const makeCall = async () => {
            setLoading(true);
            try {
              
                const response = await axios.post(`${API_URL}/make-call`, {
                    recipient_number: '+94763125620' // Replace with recipient number
                });
              
            } catch (error) {
                console.error(error);
            }
            setLoading(false);
        };

        const MeetingFormatDate = (dateString) => {
            const date = new Date(dateString);
            const options = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };
            return date.toLocaleDateString('en-US', options);
        };
        
        const MeetingFormatTime = (dateTimeString) => {
            const date = new Date(dateTimeString);
            let hours = date.getHours();
            let minutes = date.getMinutes();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            return `${hours}:${minutes} ${ampm}`;
        };

        const sendMeetingEmail = (e) => {
            e.preventDefault();
            setLoading(true);
                 
            // Construct the message body
            const messageBody = `
            <div class="header">
    <img src="https://www.attodesk.com/Auttodesk-Black.png" alt="Attodesk Logo Big" width="140" />
   </div>

    <p><h2>Your appointment for ${title} has been confirmed, ${first_name}!<h2> </p>
    <p><strong>Date:</strong> ${formattedDateString}</p>
    <p><strong>Time:</strong> ${time}</p>
    <p><strong>Location:</strong> 415 The West Plaza, Ste. 110 Toronto, Ontario A9C 5J1</p><br>

 
<p>Regards,<br>Attodesk team,<br>Phone No: +1 (647) 555-5678</p>
 
            `;
        
            const formData = new FormData();
            formData.append("customer_id", id);
            formData.append("to", email);
            formData.append("title", title);
            formData.append("date", date);
            formData.append("time", time);

            formData.append("subject", "Appointment Confirmation");
            formData.append("message", messageBody); 
     
        
            axios.post(`${API_URL}/save-meeting`, formData)
            .then(() => {
                showToast("Email sent successfully!"); 
                setLoading(false);
                // setTemplate_details([]);
                resetMeeting();
                getMeetlogbyId(id);
                setMeetingErrorList([]);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
                 setMeetingErrorList(error.response.data.validate_err);
            });
        };


        async function updateBooking(event) {
            event.preventDefault();
            const totalPlayers = Number(kids_count) + Number(adults_count);
          
            if ( customerById.package_name =='Birthday' &&
                (totalPlayers < birthday_packages.min_players || totalPlayers > birthday_packages.max_players_in_a_slot))
               {
                alert(`The total number of players must be between ${birthday_packages.min_players} and ${birthday_packages.max_players_in_a_slot}.`)
              return;
            }

            if (customerById.package_name =='Birthday'&& customerById.no_of_slots < (min_game + 2 )) {
                alert(`Please select min ${min_game + 2} games.`)
              return;
            }

            if ( customerById.package_name =='Corporate' &&
                (totalPlayers < corporate_packages.min_players || totalPlayers > corporate_packages.max_players_in_a_slot))
               {
                alert(`The total number of players must be between ${corporate_packages.min_players} and ${corporate_packages.max_players_in_a_slot}.`)
              return;
            }

            if (customerById.package_name =='Corporate'&& customerById.no_of_slots < (min_game + 2 )) {
                alert(`Please select min ${min_game + 2} games.`)
              return;
            }
            if (customerById.game_type_id && (totalPlayers < minPlayers || totalPlayers > maxPlayers)) {
                alert(`The total number of players must be between ${minPlayers} and ${maxPlayers}.`);
                return;
            }


            setLoading(true); // Start loading spinner
          //  console.log(customerById)
           
            const sendEmailNotification = document.getElementById('sendNotificationCheckbox').checked;

            const data = customerById;
        
            try {
                // Await the booking update request
                const res = await axios.post(`${API_URL}/update-booked-slots/${customerById.id}`, data);
                if (sendEmailNotification) {
                // Prepare the email data from the booking response
                const emailData = prepareEmailData(res.data.booking);
        
                // Send the email notification (await the result)
                await axios.post(`${API_URL}/send-email`, emailData);
                }
                // Show success message once both requests are completed
                Swal.fire({
                    icon: "success",
                    text: res.data.message
                }).then(function () {
                 
                  getCustomerById(id);
                 //   console.log( `{customerById.cart_details?.extra_player_price?.total_players} Players X {customerById.cart_details?.extra_player_price?.no_games} Games X ${customerById.cart_details?.extra_player_price?.price_for_slot}`)
                    setLoading(false);   
                    handleCloseModal();
                  //  getCustomerById(customerById.id);
                   // Stop loading spinner
                });
        
            } catch (error) {
                // Handle any errors (from either the booking update or email sending)
                if (error.response && error.response.status === 422) {
                    setErrorList(error.response.data.validate_err);
                    console.log(error.response?.data?.message)
                } else {
                    Swal.fire({
                        text: error.response?.data?.message || "An error occurred",
                        icon: "error"
                    });
                }
                setLoading(false); // Stop loading in case of errors
            }
        }

        async function handleSaveAdjustment(event)
        {
          event.preventDefault();
          setAdjustmentLoading(true);

          if (!adjustedReason || adjustedReason.trim() === "") {
            setAdjustmentError("Reason is required");
            setAdjustmentLoading(false);
            return; // Stop form submission
          }
         
          const formData = new FormData();
      
          formData.append('booking_id', customerById.id);
          formData.append('adjusted_date', adjustedDate);
          formData.append('adjusted_amount', adjustedAmount);
          formData.append('adjusted_reason', adjustedReason);
          formData.append('adjusted_note', adjustedNote);
          formData.append('adjusted_by', userContext.userDetails.id);
       
         await axios.post(`${API_URL}/save-adjustment`, formData).then(res =>{
               
          
          Swal.fire({
            icon:"success",
            text:res.data.message
          }).then(function(){    

              getCustomerById(customerById.id);
              handleCloseAdjustmentModal();
              setAdjustmentLoading(false); 
              resetAdjustment();  
         

        });
        }).catch(function(error) {
          setAdjustmentLoading(false); 
          // if(error.response.status===422){         
         setErrorList(error.response.data.validate_err);
          // }
          // else{
            Swal.fire({
              text:error.response.data.message,
              icon:"error"
            })
          // }
        })
      }




      

      const resetAdjustment = () => {
        setAdjustedAmount(0);
        setAdjustedReason('');
        setAdjustedNote('');
        setAdjustmentError('');
        const today = new Date();
//setAdjustedDate(today.toISOString().split("T")[0]);
setAdjustedDate(today.toLocaleDateString("en-CA", {timeZone: 'America/Toronto'}));

         };
      

        const saveFoodDetails = async (e) => {
            e.preventDefault();
            setFoodLoading(true);
        
            const formattedEventFoods = {};
        
            // Loop through selected foods and add only those with quantity > 0
            Object.entries(selectedFoods).forEach(([food, quantity]) => {
                if (quantity > 0) {  // Only include foods that have a quantity greater than 0
                    formattedEventFoods[food] = String(quantity); // Convert quantity to string
                }
            });
        
            // Now send the updated food details with only foods having quantity > 0
            const updatedFoodDetails = JSON.stringify(formattedEventFoods);
        
            try {
                const response = await axios.put(`${API_URL}/update-food-details/${customerById.id}`, {
                    food_details: updatedFoodDetails, // Send the updated details
                });
        
                if (response.status === 200) {
                    setCustomerById(prev => ({ ...prev, food_details: response.data.food_details }));
                    showToast("Food details updated!");

                    setShowFoodModal(false);
                } else {
                    console.error(response.data.message || "Failed to update food details.");
                }
            } catch (error) {
                console.error("Error updating food details:", error);
            } finally {
                setFoodLoading(false);
            }
        };

        const saveDrinkDetails = async (e) => {
            e.preventDefault();
            setDrinkLoading(true);
        
            const formattedEventDrinks = {};
        
            // Loop through selected foods and add only those with quantity > 0
            Object.entries(selectedDrinks).forEach(([drink, quantity]) => {
                if (quantity > 0) {  // Only include foods that have a quantity greater than 0
                    formattedEventDrinks[drink] = String(quantity); // Convert quantity to string
                }
            });
        
            // Now send the updated food details with only foods having quantity > 0
            const updatedDrinkDetails = JSON.stringify(formattedEventDrinks);
        
            try {
                const response = await axios.put(`${API_URL}/update-drink-details/${customerById.id}`, {
                    drink_details: updatedDrinkDetails, // Send the updated details
                });
        
                if (response.status === 200) {
                    setCustomerById(prev => ({ ...prev, drink_details: response.data.drink_details }));
                    showToast("Drink details updated!");

                    setShowDrinkModal(false);
                } else {
                    console.error(response.data.message || "Failed to update drink details.");
                }
            } catch (error) {
                console.error("Error updating drink details:", error);
            } finally {
                setDrinkLoading(false);
            }
        };
        
        

        const saveStaff = async (e) => {
          e.preventDefault();
          setStaffLoading(true);

          const formData = new FormData();
          formData.append("booking_id", id);    
          formData.append("staff", selectedStaff);
          try {
          const response = await axios.post(`${API_URL}/save-staff`, formData);
                  
      
          if (response.data.status === 200) {
              showToast("Staff Assigned successfully!");
              setStaffLoading(false);
             // resetPayment();
              getCustomerById(id);
              handleCloseStaffModal();
        
            
        
            } else {
              const details = response.data.details || 'No additional details available';
              showToast(`Staff assignment failed: ${response.data.message || 'Unknown error'}`);
              setStaffLoading(false);
            }
          } catch (error) {
            setStaffLoading(false);
            const errorMessage = error.response?.data?.message || 'An unexpected error occurred';
        
            Swal.fire({
              text: errorMessage,
              icon: 'error',
            });
        
       
       }   
        }; 


        const savePayments = async (e) => {
            e.preventDefault();
            setPaymentLoading(true);

            const sendEmailNotification = document.getElementById('sendPaymentNotificationCheckbox').checked;

            const formData = new FormData();
            formData.append("booking_id", id);
            formData.append("location_id", customerById.location_id);     
            formData.append("payment_date", payment_date);
            formData.append("payment_amount", payment_amount);
            formData.append("payment_method", payment_method);

            try {
            const response = await axios.post(`${API_URL}/store-cash-payments`, formData)
                    
        
            if (response.data.status === 200) {
                showToast("Payment successfull!");
                setPaymentLoading(false);
                resetPayment();
                getCustomerById(id);
                setPaymentErrorList([]);
                handleClosePaymentModal();
        
          
                if (sendEmailNotification) {
                    const emailData = preparePaymentEmailData({
              
                        payment: {
                          amount: payment_amount,
                          method: payment_method,
                          date: payment_date,
                        }
                      });
                  await axios.post(`${API_URL}/send-email`, emailData);
                }
          
              } else {
                const details = response.data.details || 'No additional details available';
                showToast(`Payment failed: ${response.data.message || 'Unknown error'}`);
                setPaymentErrorList([details]);
                setPaymentLoading(false);
              }
            } catch (error) {
              setPaymentLoading(false);
              const errorMessage = error.response?.data?.message || 'An unexpected error occurred';
          
              Swal.fire({
                text: errorMessage,
                icon: 'error',
              });
          
              setPaymentErrorList([errorMessage]);
  }   
        

    
            // axios.post(`${API_URL}/process-payments`, formData)

            // const paymentData = {
            //     booking_id : id,
            //     location_id : customerById.location_id,
            //     payment_amount: payment_amount, // Amount in the smallest unit (e.g., cents, so $10.00 = 1000)
            //     currency: "CAD", // Currency code (e.g., CAD for Canadian Dollars)
            //     payment_method: payment_method, // Payment method type
            //     card: {
            //         number: "4030000010001234", // Visa test card number
            //         expiry_month: "12", // Expiry month (e.g., '12')
            //         expiry_year: "24", // Expiry year (e.g., '2024')
            //         cvd: "123", // CVV
            //         name: "John Doe", // Cardholder's name
             
            //     }
            // };

            // axios.post('https://api.na.bambora.com/v1/payments', paymentData, {
            //     headers: {
            //         'Authorization': `Passcode ${btoa('383612682:932F9C59A1194244bB31D8A9CF5Bcda2')}`, // Base64-encoded credentials
            //         'Content-Type': 'application/json'
            //     }
            // })
            // .then(response => {
                
            //     setPaymentLoading(false);
            //     showToast("Payment successful!");
            //     handleClosePaymentModal();
            //     console.log('Payment successful:', response.data);
            // })
            // .catch(error => {
            //     setPaymentLoading(false);
            //     const errorMessage = error.response?.data?.message || 'An unexpected error occurred.';
            //     showToast(`Payment failed: ${errorMessage}`);
            //     console.error('Payment error:', error.response?.data || error.message);
            // });

        //     if (payment_method === 'Cash') {
        //     axios.post(`${API_URL}/store-cash-payments`, paymentData)


        //       .then((response) => {
        //         if (response.data.status === 200) {
        //             showToast("Payment successful!");
        //             setPaymentLoading(false);
        //             resetPayment();
        //             getCustomerById(id);
        //             setPaymentErrorList([]);
        //             handleClosePaymentModal();
        //             console.log(response)
        //         } else {
        //             // Handle non-success status codes
        //             const details = response.data.details || 'No additional details available';
        //             showToast(`Payment failed: ${response.data.message || 'Unknown error'}`);
        //             setPaymentErrorList([details]);
        //             setPaymentLoading(false);
        //         }
        //     })
        //     .catch((error) => {
        //         setPaymentLoading(false);
    
        //         // Check if error.response exists and contains data
        //         const errorMessage = error.response?.data?.message || 'An unexpected error occurred';
    
        //         // Show an alert with the error message
        //         Swal.fire({
        //             text: errorMessage,
        //             icon: 'error',
        //         });
    
        //         // Optionally set error details for further use
        //         setPaymentErrorList([errorMessage]);
        //     });

        // }

        // if (payment_method === 'Card') {

        //     axios.post(`${API_URL}/store-card-payments`, paymentData)


        //     .then((response) => {
        //       console.log(response);
        //       if (response.data.status === 200) {
        //           showToast("Payment successful!");
        //           console.log("Transaction Details:", response.data.transaction);
        //           setPaymentLoading(false);
        //           resetPayment();
        //           getCustomerById(id);
        //           setPaymentErrorList([]);
        //           handleClosePaymentModal();
        //       } else {
        //           // Handle non-success status codes
        //           const details = response.data.details || 'No additional details available';
        //           showToast(`Payment failed: ${response.data.message || 'Unknown error'}`);
        //           setPaymentErrorList([details]);
        //           setPaymentLoading(false);
        //       }
        //   })
        //   .catch((error) => {
        //       setPaymentLoading(false);
  
        //       // Check if error.response exists and contains data
        //       const errorMessage = error.response?.data?.message || 'An unexpected error occurred';
  
        //       // Show an alert with the error message
        //       Swal.fire({
        //           text: errorMessage,
        //           icon: 'error',
        //       });
  
        //       // Optionally set error details for further use
        //       setPaymentErrorList([errorMessage]);
        //   });

        // }





    };



        const saveNote = (e) => {
            e.preventDefault();
            setLoading(true);

            const formData = new FormData();
            formData.append("booking_id", id);
            formData.append("note_subject", note_subject);
            formData.append("note_message", note_message);  

            axios.post(`${API_URL}/save-note`, formData)
              .then(() => {
               
               showToast("Note saved successfully!"); 
                setLoading(false);
             //   setNote_template_details([]);
                resetNote();
                getNotelogbyId(id);
                setNoteErrorList([]);
               
              })
              .catch((error) => {
                setLoading(false);
                setNoteErrorList(error.response.data.validate_err);
              //  console.error("Error sending email:", error.response.data);
                Swal.fire({
                    text:error.response.data.message,
                    icon:"error"
                  })
              });
          };



        const sendNoteEmail = (e) => {
            e.preventDefault();
            setLoading(true);
        
                // const formattedMessage = (template_details?.message ?? '').replace(/\n/g, '<br>');
                    
            // const messageWithLogo = `<img src="https://www.attodesk.com/Auttodesk-Black.png" alt="Attodesk Logo Big" width="140" /><br><br>${formattedMessage}`;
            
            const formData = new FormData();
            // formData.append("customer_id", id);
            formData.append("booking_id", id);
            formData.append("to", customerById.email);
            formData.append("note_subject", note_subject);
            formData.append("note_message", note_message.replace(/\n/g, '<br>'));
         
     
            axios.post(`${API_URL}/send-note-email`, formData)
              .then(() => {
               
               showToast("Email sent successfully!"); 
                setLoading(false);
                setNote_template_details([]);
                resetNote();
                getNotelogbyId(id);
                setNoteErrorList([]);
               
              })
              .catch((error) => {
                setLoading(false);
                setNoteErrorList(error.response.data.validate_err);
              //  console.error("Error sending email:", error.response.data);
                // Swal.fire({
                //     text:error.response.data.message,
                //     icon:"error"
                //   })
              });
          };

          const uploadDocuments = (e) => {
            e.preventDefault();
            setLoading(true);
          
            const formData = new FormData();
            formData.append("customer_id", id);
            formData.append("upload_subject", upload_subject);
            formData.append("upload_message", upload_message.replace(/\n/g, '<br>'));
           
            images.forEach((image, index) => {
              formData.append(`image[${index}]`, image);
            });
          
            axios.post(`${API_URL}/upload-documents-by-id`, formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
                
              }
              )
              .then(() => {
              
               showToast("Document uploaded!"); 
               
                setLoading(false);
                setUpload_template_details([]);
                resetUpload();
                getUploadlogbyId(id);
                setUploadErrorList([]);
               
              })
              .catch((error) => {
                setLoading(false);
                setUploadErrorList(error.response.data.validate_err);
                //console.error("Error sending email:", error.response.data);
                Swal.fire({
                    text:error.response.data.message,
                    icon:"error"
                  })

              });
          };
             
          


          function onSelectImages(event){
            const selectedImages = Array.from(event.target.files);

                const validImages = selectedImages.filter(image => image.size <= 15 * 1024 * 1024); // 15MB 
                if (validImages.length !== selectedImages.length) {
                  Swal.fire({
                    text: "Image file size should be less than or equal to 15MB.",
                    icon: "error"
                  });
                }       
                setImages([...images, ...validImages]);       
            
                //  console.log([...images, ...validImages]);
               // const filePreviews = validImages.map((image) => URL.createObjectURL(image));
        
                const filePreviews = validImages.map(file => {
                if (file.type === 'application/pdf') {
                    return { type: 'pdf', name: file.name , url: URL.createObjectURL(file)};
                } else if (file.type === 'video/mp4') {
                  return { type: 'video', name: file.name, url: URL.createObjectURL(file) };
                 } else {
                    return { type: 'image', name: file.name ,url: URL.createObjectURL(file) };
                }
            });
        
                setPreviews([...previews, ...filePreviews]);
                

            
          }
    
          function onSelectVideos(event){
    
            const selectedVideos = Array.from(event.target.files);
    
            // Check the file size for each selected video
            const validVideos = selectedVideos.filter(video => video.size <= 10 * 1024 * 1024); // 25MB
          
            if (validVideos.length !== selectedVideos.length) {
              // Show the validation error message
              Swal.fire({
                text: "Video file size should be less than or equal to 10MB.",
                icon: "error"
              });
            }
          
            setVideos(validVideos);
          
            const videoPreviews = validVideos.map(video => URL.createObjectURL(video));
            setPreviewsVideo(videoPreviews);
          }
    
          
          function deleteImage(index){
            const updatedFiles = [...images];
          updatedFiles.splice(index, 1);
          setImages(updatedFiles);
          setPreviews(previews.filter((_, i) => i !== index));
         
         }
    

        
          
          
        //  function deleteVideo(index){
        //     const updatedVideos = [...videos];
        //     updatedVideos.splice(index, 1);
        //   setVideos(updatedVideos);
        //   setPreviewsVideo(previewsVideo.filter((_, i) => i !== index));
         
        //  }

        const handleImageClick =  (index) => {
            Swal.fire({
                imageUrl: previews[index].url,
                imageAlt: `Preview ${index}`,
                showCloseButton: true,
                showConfirmButton: false,
                imageWidth: "100%",
                imageHeight: 'auto',
            });
          }
        
          const handlePdfClick = (index) => {
            const pdfUrl = previews[index].url;
            window.open(pdfUrl, '_blank');
        }
        
        const handleVideoClick = (index) => {
          const videoUrl = previews[index].url;
          
          Swal.fire({
            html: `<div style="overflow: hidden;">
                      <video width="100%" height="100%" controls style="margin-top: 15px;"> <!-- Adjust margin-right to accommodate scrollbar -->
                          <source src="${videoUrl}" type="video/mp4">
                          Your browser does not support the video tag.
                      </video>
                  </div>`,
            showCloseButton: true,
            showConfirmButton: false,
            scrollbarPadding: false 
          });
        };


        
        const resetSms = () => {
            setText_template([]);
            setText_message("");
            setLoading(false);
             };

             const handleTextTemplateChange  = (event) => {
                setText_template(event.target.value);
                if(event.target.value){
                    const text_template_details = sms_template.find(item=> item.template_name === event.target.value);
                    setText_template_details(text_template_details);
                    setText_message(text_template_details.message);
                 
                }
                else
                {   setText_template(""); 
                    setText_template_details([]);
                    setText_message("");
                }
                };

                const handleNoteTemplateChange  = (event) => {
                    setNote_template_select(event.target.value);
                    if(event.target.value){
                        const note_template_details = note_template.find(item=> item.note_title === event.target.value);
                        setNote_template_details(note_template_details);
                        setNote_subject(note_template_details.subject);
                        setNote_message(note_template_details.note_message);
                     
                    }
                    else
                    {   setNote_template_select(""); 
                        setNote_template_details([]);
                        setNote_subject("");
                        setNote_message("");
                    }
                    };


                    // const handleTeamChange  = (selectedOptions) => {
                    //         if (selectedOptions && selectedOptions.length > 0) {
                    //           // Check if "All" option is selected
                    //           const isAllSelected = selectedOptions.some(option => option.value === 'all');
                          
                    //           if (isAllSelected) {
                    //             // If "All" is selected, select all team members
                    //             const allTeamIds = team.map(item => item.id);
                    //             setTeam_select(allTeamIds);
                    //           } else {
                    //             // If individual team members are selected, update the selected team members
                    //             const selectedTeamMemberIds = selectedOptions.map(option => option.value);
                    //             setTeam_select(selectedTeamMemberIds);
                    //           }
                    //         } else {
                    //           // If no options are selected, clear the selected team members
                    //           setTeam_select([]);
                    //         }
                    //       };
                  
                          const handleTeamChange = (event) => {
                        var updatedList = [...team_select];
                  
                      if (event.target.checked) {
              updatedList = [...team_select, event.target.value];
      
            } else {
              updatedList.splice(team_select.indexOf(event.target.value), 1);
            }
            setTeam_select(updatedList);

          };    
                     
                  
                  
                        const handleUploadTemplateChange  = (event) => {
                        setUpload_template_select(event.target.value);
                        if(event.target.value){
                            const upload_template_details = upload_template.find(item=> item.upload_title === event.target.value);
                            setUpload_template_details(upload_template_details);
                            setUpload_subject(upload_template_details.subject);
                            setUpload_message(upload_template_details.upload_message);
                         
                        }


                        else
                        {   setUpload_template_select(""); 
                            setUpload_template_details([]);
                            setUpload_subject("");
                            setUpload_message("");
                        }
                        };


                    const handlePinTemplateChange  = (event) => {
                        setPin_template_select(event.target.value);
                        if(event.target.value){
                            const pin_template_details = pin_template.find(item=> item.pin_title === event.target.value);
                            setPin_template_details(pin_template_details);
                            setPin_message(pin_template_details.pin_message);
                         
                        }
                        else
                        {   setPin_template_select(""); 
                            setPin_template_details([]);
                            setPin_message("");
                        }
                        };


                        const handleSubmit = async (e) => {
                            e.preventDefault();
                            setLoading(true);
                           
                    
                                await axios.post(`${API_URL}/save-meet-template`, {
                                    title,
                                    start_datetime: startDatetime,
                                    end_datetime: endDatetime
                                }).then(res =>{
                               
                                    Swal.fire({
                                        icon:"success",
                                        text:res.data.message
                                      }).then(function(){ 
                                        setLoading(false);        
                                        resetMeetingData();
                                        setErrorList([]); 
                                        // fetchEvents();
                                    });
                                    }).catch(function(error) {
                                        setLoading(false);
                                        setErrorList(error.response.data.validate_err);
                                        Swal.fire({
                                          text:error.response.data.message,
                                          icon:"error"
                                        })
                                    })
                    
                            }
                    
                    
                        const resetMeetingData = () => {
                            setTitle('');
                            setStartDatetime('');
                            setEndDatetime('');
                        };


                   
                        const deleteAdultConsent = (e, index) => {
                            e.preventDefault();
                        
                            const buttonClicked = window.confirm("Are you sure you want to delete the adult consent form?");
                            if (buttonClicked) {
                                // Make sure the index is valid
                                if (index < 0 || index >= customerById.consent_form_details.length) {
                                    console.error("Invalid index:", index);
                                    return;
                                }
        //                  
                                const updatedConsentFormDetails = customerById.consent_form_details.map((detail) => {
                                    
                         
                                    if (detail === index ) {
                                        // console.log("Updating item:", detail);
                                        return { ...detail, is_deleted: 1 };
                                    }
                                    return detail;
                                });
                              
                        
                                // Make the API call to update the consent form
                                axios.put(`${API_URL}/delete-adult-consent`, {
                                    booking_ref_id: customerById.booking_ref_id,
                                     booking_id: customerById.booking_id,
                                    consent_form_details: updatedConsentFormDetails
                                }).then(res => {
                                    Swal.fire({
                                        icon: "success",
                                        text: res.data.message
                                    }).then(() => {
                                        getCustomerById(id); // Refresh data
                                    });
                                }).catch(error => {
                                    Swal.fire({
                                        icon: "error",
                                        text: "An error occurred while updating the consent form."
                                    });
                                });
                            } else {
                                getCustomerById(id); // Optionally refresh data if canceled
                            }
                        };
                        
                        const deleteKidConsent = (e, index) => {
                            e.preventDefault();
                        
                            const buttonClicked = window.confirm("Are you sure you want to delete the adult consent form?");
                            if (buttonClicked) {
                                // Make sure the index is valid
                                if (index < 0 || index >= customerById.kids_form_details.length) {
                                    console.error("Invalid index:", index);
                                    return;
                                }
        //                  
                                const updatedKidsConsentFormDetails = customerById.kids_form_details.map((detail) => {
                                    
                         
                                    if (detail === index ) {
                                        // console.log("Updating item:", detail);
                                        return { ...detail, is_deleted: 1 };
                                    }
                                    return detail;
                                });
                              
                        
                                // Make the API call to update the consent form
                                axios.put(`${API_URL}/delete-kid-consent`, {
                                    booking_ref_id: customerById.booking_ref_id,
                                    booking_id: customerById.booking_id,
                                    kids_form_details: updatedKidsConsentFormDetails
                                }).then(res => {
                                    Swal.fire({
                                        icon: "success",
                                        text: res.data.message
                                    }).then(() => {
                                        getCustomerById(id); // Refresh data
                                    });
                                }).catch(error => {
                                    Swal.fire({
                                        icon: "error",
                                        text: "An error occurred while updating the consent form."
                                    });
                                });
                            } else {
                                getCustomerById(id); // Optionally refresh data if canceled
                            }
                        };
                     
                        

                        const fetchTimeSlots = async () => {
                            setTimeSlotLoading(true);
                            try {
                             
                                const response = await axios.get(`${API_URL}/fetch-time-slots`, {
                                    params: {
                                        location_id: customerById.location_id,
                                        game_id: customerById.game_id,
                                        game_type_id: customerById.game_type_id,
                                        selected_date: customerById.booked_date,
                                        //created_by: userContext.userDetails.id,
                                    }
                                });
                                //   setTimeSlotDetails(prevState => ({
                                //     ...prevState,
                                //     [selectedGameType]: response.data // Assuming the response is an array with one object for the selected game type
                                //   }));
                    
                    
                                setTimeSlotDetails(response.data);
                              
                                const timeSlot = response.data;
                    
                                const { start_time, end_time, time_slot_interval } = timeSlot;
                                const timeSlots = calculateTimeSlots1(start_time, end_time, parseInt(time_slot_interval, 10));
                                const formattedTimeSlots = formatTimeSlots(timeSlots);
                    
                    
                                //   console.log('Generated Time Slots:', timeSlots);
                                const comparisonResponse = await axios.post(`${API_URL}/compare-time-slots`, {
                                    location_id: customerById.location_id,
                                    game_id: customerById.game_id,
                                    game_type_id: customerById.game_type_id,
                                    selected_date: customerById.booked_date,
                                    generated_time_slots: formattedTimeSlots,
                                    no_of_adults: adults_count,
                                    no_of_children: kids_count,
                                });
                    
                                const { disabledTimeSlots, availableSpaces } = comparisonResponse.data;
                    
                                setTimeSlotDetails(timeSlot);
                                setBookingAvailableTimeSlots(formattedTimeSlots);
                                setDisabledTimeSlots(disabledTimeSlots);
                                setAvailableSpaces(availableSpaces);
                    
                                await new Promise(resolve => setTimeout(resolve, 300));
                    
                               //  console.log('Fetched Data:', comparisonResponse.data);
                    
                            } catch (error) {
                                console.error('Error fetching data:', error);
                    
                            }
                            setTimeSlotLoading(false);
                        }

                        const fetchTimeSlotsBirthday = async () => {
                            setTimeSlotLoading(true);
                            try {
                                const response = await axios.get(`${API_URL}/fetch-time-slots-birthday`, {
                                    params: {
                                        location_id: customerById.location_id,
                                        game_id: customerById.game_id,
                                        game_package_id: customerById.game_package_id,
                                        selected_date: customerById.booked_date,
                                        // created_by: userContext.userDetails.id,
                                    }
                                });
                               
                    
                    
                                setTimeSlotDetails(response.data);
                                const timeSlot = response.data;
                    
                                const { start_time, end_time, time_slot_interval } = timeSlot;
                                const timeSlots = calculateTimeSlots1(start_time, end_time, parseInt(time_slot_interval, 10));
                                const formattedTimeSlots = formatTimeSlots(timeSlots);
                    
                        
                                const comparisonResponse = await axios.post(`${API_URL}/compare-time-slots-birthday`, {
                                    location_id: customerById.location_id,
                                    game_id: customerById.game_id,
                                    game_package_id: customerById.game_package_id,
                                    // game_type_id: selectedGameType,
                                    selected_date: customerById.booked_date,
                                    generated_time_slots: formattedTimeSlots,
                                    no_of_adults: adults_count,
                                    no_of_children: kids_count,
                                });
                    
                                const { disabledTimeSlots, availableSpaces } = comparisonResponse.data;
                    
                                 
                                
                                setTimeSlotDetails(timeSlot);
                                setBookingAvailableTimeSlots(formattedTimeSlots);
                                setDisabledTimeSlots(disabledTimeSlots);
                                setAvailableSpaces(availableSpaces);
                    
                                await new Promise(resolve => setTimeout(resolve, 300));
                    
                                // console.log('Fetched Data:', comparisonResponse.data);
                    
                            } catch (error) {
                                console.error('Error fetching data:', error);
                    
                            }
                            setTimeSlotLoading(false);
                        }


                        


                        const fetchTimeSlotsCorporate = async () => {
                            setTimeSlotLoading(true);
                            try {
                                const response = await axios.get(`${API_URL}/fetch-time-slots-corporate`, {
                                    params: {
                                        location_id:  customerById.location_id,
                                        game_id:  customerById.game_id,
                                        corporate_event_id: customerById.sub_package_id,
                                        selected_date: customerById.booked_date,
                                        created_by: userContext.userDetails.id,
                                    }
                                });
                              
                   
                    
                                setTimeSlotDetails(response.data);
                                const timeSlot = response.data;
                    
                                const { start_time, end_time, time_slot_interval } = timeSlot;
                                const timeSlots = calculateTimeSlots1(start_time, end_time, parseInt(time_slot_interval, 10));
                                const formattedTimeSlots = formatTimeSlots(timeSlots);
                    
                        

                                const comparisonResponse = await axios.post(`${API_URL}/compare-time-slots-corporate`, {
                                    location_id:  customerById.location_id,
                                    game_id:  customerById.game_id,
                                    corporate_event_id:  customerById.sub_package_id,
                                    // game_type_id: selectedGameType,
                                    selected_date: customerById.booked_date,
                                    generated_time_slots: formattedTimeSlots,
                                    no_of_adults: adults_count,
                                    no_of_children: kids_count,
                                });

                               // console.log(comparisonResponse);
                    
                                const { disabledTimeSlots, availableSpaces } = comparisonResponse.data;
                                
                                setTimeSlotDetails(timeSlot);
                                setBookingAvailableTimeSlots(formattedTimeSlots);
                                setDisabledTimeSlots(disabledTimeSlots);
                                setAvailableSpaces(availableSpaces);
                                //console.log(disabledTimeSlots);
                                await new Promise(resolve => setTimeout(resolve, 300));
                    
                                // console.log('Fetched Data:', comparisonResponse.data);
                    
                            } catch (error) {
                                console.error('Error fetching data:', error);
                    
                            }
                            setTimeSlotLoading(false);
                        }
                    




                    
  // Function to format time slots into ranges
  const formatTimeSlots = (timeSlots) => {
    const formattedSlots = [];

    for (let i = 0; i < timeSlots.length - 1; i++) {
        const startTime = timeSlots[i];
        const endTime = timeSlots[i + 1];

        // Convert to 12-hour format
        const startTime12h = convertTo12HourFormat1(startTime);
        const endTime12h = convertTo12HourFormat1(endTime);

        // Format the range
        const formattedRange = `${startTime12h} - ${endTime12h}`;
        formattedSlots.push(formattedRange);
    }

    return formattedSlots;
};

// Function to convert 24-hour time to 12-hour format
const convertTo12HourFormat1 = (time24h) => {
    const [hours, minutes] = time24h.split(':');
    let period = 'AM';
    let hours12 = parseInt(hours, 10);

    if (hours12 === 0) {
        hours12 = 12;
    } else if (hours12 === 12) {
        period = 'PM';
    } else if (hours12 > 12) {
        hours12 -= 12;
        period = 'PM';
    }

    return `${hours12.toString().padStart(2, '0')}:${minutes} ${period}`;
};

const fetchGameTypesArray = async () => {
    try {
        const response = await axios.get(`${API_URL}/view-game-type`);

        setGame_types_array(response.data.gameType);
      
       // setIsLoading(false);
 
    } catch (error) {
        //setIsLoading(false);
        console.error("Error fetching games:", error);

    }
   
};

const calculateTimeSlots1 = (startTime, endTime, interval) => {
    const timeSlots = [];
    const [startHour, startMinute] = parseTime(startTime);
    const [endHour, endMinute] = parseTime(endTime);

    let current = new Date();
    current.setHours(startHour, startMinute, 0, 0);

    const end = new Date();
    end.setHours(endHour, endMinute, 0, 0);

    while (current <= end) {
        const timeSlot = current.toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' });
        timeSlots.push(timeSlot);
        current.setMinutes(current.getMinutes() + interval);
    }

    return timeSlots;
};


 const parseTime = (timeString) => {
        const [time, period] = timeString.split(' ');
        const [hours, minutes] = time.split(':').map(Number);
        const adjustedHours = period === 'PM' && hours !== 12 ? hours + 12 : hours;
        return [adjustedHours, minutes];
    };

  
  
    const handleTimeSlotChange1 = (event) => {
        const selectedTimeSlot = event.target.value;
        const selectedSlotIndex = bookingAvailableTimeSlots.indexOf(selectedTimeSlot);
      
        if (customerById.package_name == 'Birthday') {

        }else  if (customerById.package_name == 'Corporate') {

        }


        const isConsecutiveSelection = (selectedSlots) => {
            for (let i = 1; i < selectedSlots.length; i++) {
                if (
                    bookingAvailableTimeSlots.indexOf(selectedSlots[i]) !==
                    bookingAvailableTimeSlots.indexOf(selectedSlots[i - 1]) + 1
                ) {
                    return false; // Non-consecutive selection
                }
            }
            return true;
        };
       
       
                setBooking_time((prevBookingTime) => {
                    const isSelected = prevBookingTime.includes(selectedTimeSlot);
                    const updatedBookingTime = isSelected 
                        ? prevBookingTime.filter((timeSlot) => timeSlot !== selectedTimeSlot) // Remove if already selected
                        : [...prevBookingTime, selectedTimeSlot]; // Add new time slot
                
                    const parseTimeSlot = (timeSlot) => {
                        const [startTime, endTime] = timeSlot.split(' - ');
                        return {
                            start: moment(startTime, 'hh:mm A'),
                            end: moment(endTime, 'hh:mm A'),
                            original: timeSlot
                        };
                    };
                
                    // Sort the updated time slots
                    const sortedBookingTime = updatedBookingTime
                        .map(parseTimeSlot)
                        .sort((a, b) => a.start - b.start) // Sort by start time
                        .map(item => item.original);
                
                   // console.log('Sorted Booking Time:', sortedBookingTime); 


                   const isConsecutiveSelection = (selectedSlots) => {
                    for (let i = 1; i < selectedSlots.length; i++) {
                        if (
                            bookingAvailableTimeSlots.indexOf(selectedSlots[i]) !==
                            bookingAvailableTimeSlots.indexOf(selectedSlots[i - 1]) + 1
                        ) {
                            return false; // Non-consecutive selection
                        }
                    }
                    return true;
                };
        
                if (!isConsecutiveSelection(sortedBookingTime)) {
                    alert("Please select only consecutive time slots.");
                    return prevBookingTime; // Prevent updating if slots are not consecutive
                }
        


                    setCustomerById((prevCustomerById) => ({
                        ...prevCustomerById,
                        booked_time: JSON.stringify(sortedBookingTime),
                        no_of_slots: sortedBookingTime.length, // Store booking_time as a JSON string
                    }));
                    
                    return sortedBookingTime;
                });


                

    //  };


    }


    const initiateCall = (phoneNumber) => {
            axios.post(`${API_URL}/make-call`, {
                phoneNumber: phoneNumber,
            })
        
          .then((response) => response.json())
          .then((data) => {
            console.log('Call initiated successfully:', data);
          })
          .catch((error) => {
            console.error('Error initiating call:', error);
          });
      };


      function prepareEmailData(bookingDetails) {

        const consentFormUrl = `${API_BASE_URL}/consent-form-page/${bookingDetails.booking_ref_id}/${bookingDetails.booking_id}`;
        const formattedBookedTime = formatBookedTime(bookingDetails.booked_time);

        // Generate and upload QR code image
        const qrCodeFilename = `${bookingDetails.booking_ref_id}.png`;
        const qrCodeImageUrl = `${LARAVEL_API_URL}/uploads/qrImages/${qrCodeFilename}`;


        const message = convertPlainTextToHTML(emailData.message)
            .replace('[customer_name]', `${bookingDetails.firstname} ${bookingDetails.lastname}`)
            .replace('[event_date]', moment(bookingDetails.booked_date).format('D MMMM YYYY'))
            .replace('[event_time]', formattedBookedTime)  // Joining the times array into a string
            .replace('[location]', bookingDetails.location_name)
            .replace('[number_of_players]', bookingDetails.total_players)
            .replace('[package_name]', 
                bookingDetails.game_type_name ||
                        (bookingDetails.package_name === 'Corporate' 
                          ? `${bookingDetails.package_name} - ${bookingDetails.corporate_package_name}`
                          : `${bookingDetails.package_name} - ${bookingDetails.game_package_name}`
                        ))
                // bookingDetails.game_type_name || `${bookingDetails.package_name} - ${bookingDetails.game_package_name}`)
            .replace('[consent_form_link]', `<a href="${consentFormUrl}">Click here to complete the consent form</a>`)
            .replace('[qr_code]', qrCodeImageUrl ? `<img src="${qrCodeImageUrl}" alt="QR Code for Consent Form" />` : 'QR code not available');
    

        return {
            booking_id: bookingDetails.booking_id,
            to: bookingDetails.email,
            subject: emailData.subject,
            message // This is now HTML formatted
        };
    }

    function preparePaymentEmailData(payment) {

        const PaymentTemplate = email_template.find(item => item.template_name === 'Payment Confirmation');
     
        // const adjustedGrandTotal = customerById.grand_total + customerById.adjusted_total;
        const updatedDueAmount = (parseFloat(customerById.payment_due) - parseFloat(payment_amount)).toFixed(2);

        const message = convertPlainTextToHTML(PaymentTemplate.message)
            .replace('[customer_name]', `${customerById.firstname} ${customerById.lastname}`)
            .replace('[booking_ref_id]', `${customerById.booking_ref_id}`)
            .replace('[payment_date]', moment(payment_date).format('MMMM D, YYYY'))
          .replace('[payment_amount]', parseFloat(payment_amount).toFixed(2))
              .replace('[payment_method]', payment_method)
              .replace('[grand_total]', `${customerById.grand_total.toFixed(2)}`)
              .replace('[due_amount]', updatedDueAmount)

                  
        return {
            booking_id: customerById.id,
            to: customerById.email,
            subject:  PaymentTemplate.subject,
            message// This is now HTML formatted
        };
    }

 function prepareCancelEmailData(bookingDetails, cancelReason ) {
 // console.log(bookingDetails)

    const CancelTemplate = email_template.find(item => item.template_name === 'Booking Cancellation');
 
    const formattedBookedTime = formatBookedTime(bookingDetails.booked_time);
    // Convert the plain text template to HTML
    const message = convertPlainTextToHTML(CancelTemplate.message)
        .replace('[customer_name]', `${bookingDetails.firstname} ${bookingDetails.lastname}`)
        .replace('[event_date]', moment(bookingDetails.booked_date).format('D MMMM YYYY'))
        .replace('[event_time]', formattedBookedTime)  // Joining the times array into a string
        .replace('[location]', bookingDetails.location_name)
        .replace('[number_of_players]', bookingDetails.total_players)
        .replace('[cancel_reason]', cancelReason)
        .replace('[package_name]',
          bookingDetails.game_type_name ||
          (bookingDetails.package_name === 'Corporate' 
            ? `${bookingDetails.package_name} - ${bookingDetails.corporate_package_name}`
            : `${bookingDetails.package_name} - ${bookingDetails.game_package_name}`
          ))

        

          //bookingDetails.game_type_name || `${bookingDetails.package_name} - ${bookingDetails.game_package_name}`)
        
              
    return {
        booking_id: bookingDetails.booking_id,
        to: bookingDetails.email,
        subject:  CancelTemplate.subject,
        message// This is now HTML formatted
    };
}

    const cancelBooking = (e, id) => {
        e.preventDefault();
        
        var buttonClicked = window.confirm("Are you sure you want to cancel booking?");
        
        if (buttonClicked === true) {

          const cancelReason = window.prompt("Enter the reason for cancellation (optional):");
  
          var sendNotification = window.confirm("Do you want to send a cancellation notification email?");
            
          
          // Make a PUT request to update booking_completed to 0

  
           axios.put(`${API_URL}/cancel-booked-slot/` + id, {
                booking_completed: 0 ,
                updated_by: userContext.userDetails.id,
                booked_date: customerById.booked_date,       // Add booked_date if needed
                booked_time:customerById.booked_time,       // Add booked_time if needed
                no_of_adults:customerById.no_of_adults,              // Add no_of_adults
                no_of_children: customerById.no_of_children ,
                cancel_reason: cancelReason || null,
          
            }).then(res => {
              if (sendNotification === true) {
            //   const data = customerById.find(item=>item.id === id)
              const emailData =  prepareCancelEmailData(customerById, cancelReason);
              // API call to send email
              const emailResponse =  axios.post(`${API_URL}/send-email`, emailData);
              }
               
                Swal.fire({
                    icon: "success",
                    text: res.data.message
                }).then(function() {
                 // setIsLoading(true);
                 navigate("/bookings")
                    // Optionally update UI after booking is cancelled
                   // getLocationByUser(); 
                });
            
            }).catch(error => {
                // Handle any errors here
              //   Swal.fire({
              //   text:error.response.data.message,
              //   icon:"error"
              // })
              setIsLoading(false);
                console.error("Error canceling booking:", error);
            });
        } else {
          setIsLoading(false);
           // getLocationByUser();
        }
    }


    // async function getLocationByUser() {
    //         setIsLoading(true);
    //         try {
    //             const res = await axios.get(`${API_URL}/view-team-member-by-username/${userContext.username}`);
    //             if (res.data.status === 200) {
    //                 const filtered = res.data.locations;
    //                 setFilteredLocations(filtered);
        
    //                 if (filtered.length > 0) {
    //                     const defaultLocation = filtered[0].id;
    //                     setSelectedGameLocation(defaultLocation);
    //                       fetchGameAvailable(defaultLocation);
    //                 }
    //             } else if (res.data.status === 404) {
    //                 // Handle 404 status if needed
    //             }
    //         } catch (error) {
    //             setIsLoading(false);
    //             console.error("Error fetching locations:", error);
    //         } 
        
    //     }

    const deletePayment = (e, id) => {
      e.preventDefault();
      const confirmed = window.confirm("Are you sure you want to delete this payment?");
      if (confirmed) {
        axios.post(`${API_URL}/delete-payment/${id}`, {
          booking_id: customerById.id,
          updated_by: userContext.userDetails.id,
          _method: 'DELETE' // Laravel will interpret this as a DELETE request
        })
        .then(res => {
          showToast("Payment deleted!");
          getCustomerById(customerById.id);
        })
        .catch(error => {
          console.error("Delete error:", error);
          showToastFail("Failed to delete payment.");
        });
      }
    };

    const deleteAdjustment = async(e, id) => {
      e.preventDefault();
      const confirmed = window.confirm("Are you sure you want to delete this adjustment?");
      if (confirmed) {
        axios.post(`${API_URL}/delete-adjustment/${id}`, {
          booking_id: customerById.id,
          updated_by: userContext.userDetails.id,
          _method: 'DELETE' // Laravel will interpret this as a DELETE request
        })
        .then(res => {
          showToast("Adjustment deleted!");
          getCustomerById(customerById.id);

        })
        .catch(error => {
          console.error("Delete error:", error);
          showToastFail("Failed to delete adjustment.");
        });
      }
    };
    




           

            const refundPayment = async (e, transactionId) => {
              e.preventDefault();
          
          
              const confirmed = window.confirm("Are you sure you want to refund this payment?");
              if (!confirmed || !transactionId) return;
              setIsLoading(true);
          
              const payload = {
                  id: transactionId,
                  updated_by: userContext.userDetails.id
              };
          
              try {
              const response = await axios.post(`${PAYMENT_API_URL}/api/returntransaction`, payload);
          

                  if (response.status === 200) {
                      showToast("Refund successful!");
                      getCustomerById(id); 
                  } else {
                      showToastFail("Refund failed");
                  }
               
              } catch (error) {
                console.error(error);
                console.log('An error occurred during refund.',error);
            } finally {
                setIsLoading(false);
            }
            }
          



       const handleEditFoodDetails = () => {
        setShowFoodModal(true);
       };
              
      const handleEditDrinkDetails = () => {
        setShowDrinkModal(true);
       };

       const handleEditStaff  = () => {
        setShowStaffModal(true);
       };


       const handleIncrement = (food) => {
        setSelectedFoods((prev) => ({
          ...prev,
          [food]: (parseInt(prev[food], 10) || 0) + 1
        }));
      };
      
      const handleDecrement = (food) => {
        setSelectedFoods((prev) => ({
          ...prev,
          [food]: Math.max((parseInt(prev[food], 10) || 1) - 1, 0)
        }));
      };

      const handleIncrementDrink = (drink) => {
        setSelectedDrinks((prev) => ({
          ...prev,
          [drink]: (parseInt(prev[drink], 10) || 0) + 1
        }));
      };
      
      const handleDecrementDrink = (drink) => {
        setSelectedDrinks((prev) => ({
          ...prev,
          [drink]: Math.max((parseInt(prev[drink], 10) || 1) - 1, 0)
        }));
      };

  
      
     
      const getTotalSelectedFoods = () => {
      return Object.values(selectedFoods || {}).reduce((total, count) => total + parseInt(count || 0, 10),0);
       
      };
      
      const getTotalSelectedDrinks = () => {
        return Object.values(selectedDrinks || {}).reduce((total, count) => total + parseInt(count || 0, 10),0);
      };
      
      const handleEmailDialogOpen = async () => {
 
        setPdfLoading(true);
        const defaultTemplate = email_template.find(item => item.template_name === 'Invoice');
  
        setInvoiceEmailData(prevState => ({
          ...prevState,
          to: customerById.email? customerById.email: '',
          template: defaultTemplate ? defaultTemplate.id : '', // Set default template ID
          subject: defaultTemplate ? defaultTemplate.subject : '', // Set subject based on 'Invoice' template, if available
          message: defaultTemplate ? defaultTemplate.message : '', // Set message based on 'Invoice' template, if available
          attachments: [], // Clear attachments on dialog open
        }));
        try {
          const pdfAttachments = [];
            const pdfBlob = await handleGeneratePDF();
            if (!pdfBlob) {
              console.warn(`Failed to generate PDF for Booking ID: ${customerById.booking_ref_id}`);
            
            } else if (pdfBlob instanceof Blob) {
              const file = new File([pdfBlob], `Invoice-${customerById.booking_ref_id}.pdf`, {
                type: "application/pdf",
              });
              pdfAttachments.push(file);
            } else {
              console.warn(`Invalid Blob generated for Booking ID: ${customerById.booking_ref_id}`);
            }
          // Save generated attachments to state
          setGeneratedAttachments(pdfAttachments);
          
         // console.log("Generated Attachments:", pdfAttachments);
          // Open the email dialog
          setPdfLoading(false);
          setShowEmailDialog(true);
      }catch (error) {
          console.error("Error opening email dialog:", error);
          setPdfLoading(false);
        }
      };



      const handlePaymentEmailDialogOpen = async () => {
 
        setLoading(true);
        const defaultTemplate = email_template.find(item => item.template_name === 'Payment Link');
        try {
        setInvoiceEmailData(prevState => ({
          ...prevState,
          to: customerById.email? customerById.email: '',
          template: defaultTemplate ? defaultTemplate.id : '', // Set default template ID
          subject: defaultTemplate ? defaultTemplate.subject : '', // Set subject based on 'Invoice' template, if available
          message: defaultTemplate ? defaultTemplate.message : '', // Set message based on 'Invoice' template, if available
          
        }));

          setLoading(false);
          setShowPaymentEmailDialog(true);
      }catch (error) {
          console.error("Error opening email dialog:", error);
          setLoading(false);
        }
      };



      const handleGeneratePDF = async () => {
          try {
            await new Promise((resolve) => setTimeout(resolve, 2000));
          
            const invoiceContent = document.getElementById("invoiceDiv");
          
      
            if (!invoiceContent) {
              console.error(`Invoice content not found for Booking ID: ${customerById.booking_ref_id}`);
            }
      
            const options = {
              margin: 1,
              filename: `${customerById.booking_ref_id}.pdf`,
              image: { type: 'jpeg', quality: 0.8 }, // You can experiment with different qualities (0.8 for reduced size)
              html2canvas: {
                scale: 2, // Reduce scale for a lower resolution to make the PDF smaller
                useCORS: true, // Ensure that cross-origin images are handled properly
              },
              jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            };
      
        // Generate PDF Blob
        const pdfBlob = await html2pdf().from(invoiceContent).set(options).outputPdf('blob');
       
       
        return pdfBlob;
      
          } catch (error) {
            console.error(`Failed to generate PDF for Booking ID: ${customerById.booking_ref_id}`, error);
            return null;

          }
    
      };



      
      const handleEmailDialogClose = () => setShowEmailDialog(false);
      const handlePaymentEmailDialogClose = () => setShowPaymentEmailDialog(false);

const handleSendEmail = async () => {
    setEmailLoading(true);

    try {
        if (!generatedAttachments.length) {
     
            Swal.fire({
              text: 'No PDFs generated to attach. Please try again.' ,
              icon:"error"
            })

            return;
        }

        const customerFirstName = customerById?.firstname || "Customer";
      
          // Replace placeholders in the email message
          const updatedMessage = invoiceEmailData.message
              .replace(/\[customer_name\]/g, customerFirstName);
          

        const emailData = {
            customer_id: customerById ? parseInt(customerById.customer_id, 10) : 0,
            to: invoiceEmailData.to,
            subject: invoiceEmailData.subject,
            //message: invoiceEmailData.message,
            message: convertPlainTextToHTML(updatedMessage),
            attachments: generatedAttachments,
        };

        // Create FormData object
        const formData = new FormData();
        formData.append("booking_id", customerById.booking_id);
        formData.append("customer_id", emailData.customer_id.toString());
        formData.append("to", emailData.to);
        formData.append("subject", emailData.subject);
        formData.append("message", emailData.message);

        emailData.attachments.forEach((file) => {
            formData.append("attachments[]", file);
        });

        const headers = {
            Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
        };

        const emailResponse = await axios.post(`${API_URL}/send-email-invoice`, formData, { headers });

        if (emailResponse) {
      
            showToast("Email sent successfully"); 
            setTemplate_details([]);
            // getEmaillogbyId(id);
           
          //  setInvoiceEmailData({ ...invoiceEmailData, subject: "", message: "" });
        } else {
            Swal.fire({
              text:'Failed to send email' ,
              icon:"error"
            })

        }
    } catch (error) {
        console.error("Error during email sending:", error);
       
        Swal.fire({
          text:error.response.data.message || 'Failed to send email' ,
          icon:"error"
        })

    } finally {
        handleEmailDialogClose();
        setEmailLoading(false);
    }
};


const handlePaymentSendEmail = async () => {
  setEmailLoading(true);

  

  try {
      const customerFirstName = customerById?.firstname || "Customer";
   
      const formData = new FormData();
      formData.append("booking_id", customerById.booking_id);
      formData.append("customer_id", customerById.customer_id);
      formData.append("requested_amt", generatePaymentAmount);
      formData.append( "total_due",
        customerById.grand_total ? customerById.grand_total.toFixed(2) : "0.00"
      );
      formData.append("reason", reason);
      formData.append("note", note);
  
      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      };
  

      const response = await axios.post(`${API_URL}/generate-payment-link`, formData, { headers });
  
      const paymentId = response.data.payment_link?.payment_id;
  
      if (!paymentId) throw new Error("Payment ID not returned.");
  
      const paymentLink = `${PAYMENT_API_URL}/${paymentId}`;
  
  // Update message and send email
  let  updatedMessage = invoiceEmailData.message
        ? invoiceEmailData.message
            .replace(/\[customer_name\]/g, customerFirstName)
            .replace(/\[payment_link\]/g, paymentLink)
            .replace(/\[amount\]/g, generatePaymentAmount)
        : "";
        // Remove entire line if reason is empty
if (reason && reason.trim() !== "") {
  updatedMessage = updatedMessage.replace("[reason]", reason.trim());
} else {
  updatedMessage = updatedMessage.replace(/.*Reason\s*:\s*\[reason\]\s*\n?/gi, "");
}

// Remove entire line if note is empty
if (note && note.trim() !== "") {
  updatedMessage = updatedMessage.replace("[note]", note.trim());
} else {
  updatedMessage = updatedMessage.replace(/.*Note\s*:\s*\[note\]\s*\n?/gi, "");
}
  
      const emailFormData = new FormData();
      emailFormData.append("booking_id", customerById.booking_id);
      emailFormData.append("customer_id", customerById.customer_id.toString());
      emailFormData.append("to", invoiceEmailData.to);
      emailFormData.append("subject", invoiceEmailData.subject);
      emailFormData.append("message", convertPlainTextToHTML(updatedMessage));
  
      // Attachments if needed
      // invoiceEmailData.attachments.forEach((file) => {
      //   emailFormData.append("attachments[]", file);
      // });
  
      const emailSendResponse = await axios.post(`${API_URL}/send-email-invoice`, emailFormData, { headers });
  
      if (emailSendResponse) {
        showToast("Email sent successfully");
  
        const res = await axios.get(`${API_URL}/view-booked-slots-by-id/${id}`);
        const bookedSlot = res.data.bookedSlot;
  
        setCustomerById({
          ...bookedSlot,
          booked_time_formatted: formatBookedTime(bookedSlot.booked_time),
          consent_form_details: bookedSlot.consent_form_details ? JSON.parse(bookedSlot.consent_form_details) : [],
          kids_form_details: bookedSlot.kids_form_details ? JSON.parse(bookedSlot.kids_form_details) : []
        });
  
        setEmailLogById(res.data.emailLogs);
      }
  
    } catch (error) {
      console.error("Error during email send:", error);
      Swal.fire({
        text: error.response?.data?.message || "Failed to send email",
        icon: "error"
      });
    } finally {
      handlePaymentEmailDialogClose();
      setEmailLoading(false);
    }
  };


const  generateQr = async() =>{

  const consentFormUrl = `${API_BASE_URL}/consent-form-page/${customerById.booking_ref_id}/${customerById.booking_id}`;
  const qrCodeFilename = `${customerById.booking_ref_id}.png`; // Use the same filename for consistency

  const qrCodeImageUrl  = await generateQRCodeImage(consentFormUrl, qrCodeFilename);
 
  if (qrCodeImageUrl) {
    setImageError(false);  // Reset imageError state if the image is successfully generated
  }
}

 
  async function generateQRCodeImage(url, filename,size = 150) {
    try {
        // Generate QR Code as Data URL
        const dataUrl = await QRCode.toDataURL(url,  { width: size, height: size });

        // Convert Data URL to Blob
        const blob = await (await fetch(dataUrl)).blob();
        
        // Upload Blob to your server and get the URL
        const imageUrl = await uploadQRCodeImage(blob, filename);
        
       
        return imageUrl;
    } catch (error) {
        console.error('Error generating QR code image:', error);
        return null;
    }
}

async function uploadQRCodeImage(blob, filename) {
    const formData = new FormData();
    formData.append('file', blob, filename);

    try {
        const response = await axios.post(`${API_URL}/upload-qr-code`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.status !== 200) {
            throw new Error('Failed to upload QR code image');
        }

        const result = response.data; 
       
        return result.imageUrl;         
    } catch (error) {
        console.error('Error uploading QR code image:', error);
        return null;
    }
}



    return(
<div>
   
    <SideNav/>
      <TopBar/>
      {isLoading?
     <div className="loader-container" style ={{backgroundColor: "rgba(0, 0, 0, 0.5)", position: "fixed",top: "0",left: "0",width: "100%",height: "100%",display: "flex",justifyContent: "center",alignItems: "center",zIndex: "9999"}}>
    <div class="d-flex justify-content-center">
  <div class="spinner-border" role="status">
  </div>
  </div>
</div>:null}


      <div class="right_panel position contact_section vh-100" id="right_panel">
        <div class="contact_section_wrapper">
            <div class="d-lg-flex">
            
                <a id="contact_inbox" class="a_id_contact_inbox position-relative"></a>
              
                                                
                                
    <>
    <div class="border border-top-0 border-bottom-0 user_panel bg-white" style={{width:'60%'}}>
   
    {/* <div class="row">
    <div class="col-4">
    <div className="booking-box" style={{height:'300px'}} >
        <div class="profile_photo_wrapper vm_bg_cover vm_bg_center vm_bg_norepeat w-100 d-flex align-items-center flex-column ">
         
         </div>
        <h2 class="text-center vm_font_bold pt-2 mt-2">{customerById.firstname} {customerById.lastname} - {customerById.booking_ref_id}</h2>
        <div class="d-flex justify-content-center">
            <a href="tel:${item.phone_no}">
                <div style={{cursor:"pointer"}} class="d-flex align-items-center pe-3"  >
                    <i class="bi bi-telephone me-2"></i>
                    <p>{customerById.phone}</p>
                </div>
           </a>
        
                <div style={{cursor:"pointer"}} class="d-flex align-items-center"  onClick={() => toggleDiv('email')}>
                    <i class="bi bi-envelope me-2"></i>
                    <p>{customerById.email}</p>
                </div>
           
        </div>
        </div>
    </div>
    <div class="col-8">
    <div className="booking-box" >
            <div className="booking-info">
                <p><i class="bi bi-pin-map text-success"></i>Location</p>
                <h6>{customerById.location_name}</h6>
            </div>
            <div className="booking-info">
                <p><i class="bi bi-controller pe-1 text-success"></i>Game Package</p>
                <h6>{customerById.game_type_name ? customerById.game_type_name: customerById.package_name - customerById.game_package_name}</h6>
            </div>
            <div className="booking-info">
                <p><i className="bi bi-calendar3 me-2 text-success" ></i>Booked date</p>
                <h6>{moment(customerById.booked_date).format('D MMMM YYYY')}</h6>
            </div>
            <div className="booking-info">
                <p><i className="bi bi-clock-fill me-2 text-success" ></i>Booked Time</p>
                <h6>{customerById.booked_time}</h6>
            </div>
            <div className="booking-info">
                <p><i className="bi bi-person text-success"></i>Adults</p>
                <h6>{customerById.no_of_adults}</h6>
            </div>

            <div className="booking-info">
                <p><i className="bi bi-person text-success"></i>Kids</p>
                <h6>{customerById.no_of_children}</h6>
            </div>
            </div>

    </div>
    </div> */}
    
   

  
        {/* <div class="profile_photo_wrapper vm_bg_cover vm_bg_center vm_bg_norepeat w-100 d-flex align-items-center flex-column ">

        <img style={{margin:'80px 10px 10px 600px'}} src={`${LARAVEL_API_URL}/uploads/qrImages/${customerById.booking_ref_id}.png`}
            className="qr-image"
            alt="QR Code"/>
            
         </div> */}

         <div className="profile_photo_wrapper vm_bg_cover vm_bg_center vm_bg_norepeat w-100 d-flex align-items-center flex-column">
  <div style={{ margin: '80px 10px 10px 600px' }} 
  // onClick={() => window.open(`${API_BASE_URL}/consent-form-page/${customerById.booking_ref_id}`, '_blank')}
  >   {!imageError ? (

<img src={`${LARAVEL_API_URL}/uploads/qrImages/${customerById.booking_ref_id}.png`}
            className="qr-image"
            alt="QR Code"
            onError={() => setImageError(true)}/>
          ) : (
            <button
            className="btn btn-sm text-white"
            style={{ backgroundColor: '#6c757d' }} // Bootstrap's secondary gray
            onClick={generateQr}
          >
            Generate QR Code
          </button>
          
          )}
    
  {/* <QRCodeSVG
      value={`${API_BASE_URL}/consent-form-page/${customerById.booking_ref_id}`}
      size={120}
      fgColor="#000000"
      bgColor="#ffffff"
    /> */}
  </div>
</div>

         {/* Mobile QR - visible after invoice tab */}
<div className="d-flex d-md-none justify-content-center pt-3">

{!imageError ? (

<img src={`${LARAVEL_API_URL}/uploads/qrImages/${customerById.booking_ref_id}.png`}
            className="qr-image"
            alt="QR Code"
            onError={() => setImageError(true)}/>
          ) : (
            <button
            className="btn btn-sm text-white"
            style={{ backgroundColor: '#6c757d' }} // Bootstrap's secondary gray
            onClick={generateQr}
          >
            Generate QR Code
          </button>
          
          )}

{/* <QRCodeSVG
      value={`${API_BASE_URL}/consent-form-page/${customerById.booking_ref_id}`}
      size={120}
      fgColor="#000000"
      bgColor="#ffffff"
    /> */}

</div>
        <h2 class="text-center vm_font_bold pt-2 mt-2">{customerById.firstname} {customerById.lastname} - {customerById.booking_ref_id} -  <i className="bi bi-person-fill" style={{ fontSize: '1rem' }}>{customerById.total_players}</i>
    </h2>
        <div class="d-flex justify-content-center">
            <a href="tel:${item.phone_no}">
                <div style={{cursor:"pointer"}} class="d-flex align-items-center pe-3"  >
                    <i class="bi bi-telephone me-2"></i>
                    <p>{customerById.phone}</p>
                </div>
           </a>
        
                <div style={{cursor:"pointer"}} class="d-flex align-items-center"  onClick={() => toggleDiv('email')}>
                    <i class="bi bi-envelope me-2"></i>
                    <p>{customerById.email}</p>
                </div>
           
        </div>
      

        <div class="option d-flex justify-content-center flex-wrap pt-2">
                   
     

<a href="#" class="ps-2 d-flex justify-content-center flex-column align-items-center" onClick={() => toggleDiv('info')}>
                <div class={`item d-flex justify-content-center align-items-center ${activeButton === 'info' ? 'selected' : ''}`}>
                <i class="bi bi-info-circle text-white"></i>
                </div>
                <p class="text-center">Info</p>
            </a>

{/*             
<a href="#" class="ps-2 d-flex justify-content-center flex-column align-items-center" onClick={() => toggleDiv('newBooking')}>
                <div class={`item d-flex justify-content-center align-items-center ${activeButton === 'newBooking' ? 'selected' : ''}`}>
                <i className="bi bi-plus-circle text-white"></i>
                </div>
                <p class="text-center">Booking</p>
            </a> */}


{/* <a target="self" onClick={() => initiateCall(customerById.phone)} class="ps-2 d-flex justify-content-center flex-column align-items-center" >
                <div class={`item d-flex justify-content-center align-items-center ${activeButton === 'call' ? 'selected' : ''}`}>
                    <i class="bi bi-telephone-fill text-white"></i>
                </div>
                <p class="text-center">Call</p>
            </a>  */}

            
            {/* <a href="#" class="ps-2 d-flex justify-content-center flex-column align-items-center" onClick={() => toggleDiv('call')}>
                <div class={`item d-flex justify-content-center align-items-center ${activeButton === 'call' ? 'selected' : ''}`}>
                    <i class="bi bi-telephone-fill text-white"></i>
                </div>
                <p class="text-center">Call</p>
            </a> */}
            <a href="#" class="ps-2 d-flex justify-content-center flex-column align-items-center" onClick={() => toggleDiv('email')}>
                <div class={`item d-flex justify-content-center align-items-center ${activeButton === 'email' ? 'selected' : ''}`}>
                    <i class="bi bi-envelope-fill text-white"></i>
                </div>
                <p class="text-center w-100">Email</p>
            </a>


            {/* <a   href={`https://wa.me/1${customerById.phone}?text=Hello%2C%20I%20would%20like%20to%20get%20more%20information!`} target="self" class="ps-2 d-flex justify-content-center flex-column align-items-center" onClick={() => toggleDiv('whatsapp')}>
    <div class={`item d-flex justify-content-center align-items-center ${activeButton === 'whatsapp' ? 'selected' : ''}`}>
    <i class="bi bi-chat-dots-fill text-white"></i>
    </div>
    <p class="text-center w-100">Text</p>
</a> */}
            {/* <a href="#" class="ps-2 d-flex justify-content-center flex-column align-items-center" onClick={() => toggleDiv('text')} >
                <div class={`item d-flex justify-content-center align-items-center ${activeButton === 'text' ? 'selected' : ''}`}>
                    <i class="bi bi-chat-dots-fill text-white"></i>
                </div>
                <p class="text-center w-100">Text</p>
            </a> */}

            <a href="#" class="ps-2 d-flex justify-content-center flex-column align-items-center"  onClick={() => toggleDiv('note')}>
                <div class={`item d-flex justify-content-center align-items-center ${activeButton === 'note' ? 'selected' : ''}`}>
                    <i class="bi bi-stickies-fill text-white"></i>
                </div>
                <p class="text-center w-100">Note</p>
            </a>

            <a href="#" class="ps-2 d-flex justify-content-center flex-column align-items-center" onClick={() => toggleDiv('history')} >
                <div class={`item d-flex justify-content-center align-items-center ${activeButton === 'history' ? 'selected' : ''}`}>
                    <i class="bi bi-clock-history text-white"></i>
                </div>
                <p class="text-center w-100">History</p>
            </a>

            <a href="#" class="ps-2 d-flex justify-content-center flex-column align-items-center" onClick={() => toggleDiv('invoice')} >
                <div class={`item d-flex justify-content-center align-items-center ${activeButton === 'invoice' ? 'selected' : ''}`}>
                <i class="bi bi-receipt text-white"></i>

                </div>
                <p class="text-center w-100">Invoice</p>
            </a>
            {/* <a href="#" class="ps-2 d-flex justify-content-center flex-column align-items-center"  onClick={() => toggleDiv('pin')}>
                <div class={`item d-flex justify-content-center align-items-center ${activeButton === 'pin' ? 'selected' : ''}`}>
                    <i class="bi bi-geo-fill text-white"></i>
                </div>
                <p class="text-center w-100">Pin</p>
            </a> */}
            {/* <a href="#" class="ps-2 d-flex justify-content-center flex-column align-items-center"  onClick={() => toggleDiv('meet')}>
                <div class={`item d-flex justify-content-center align-items-center ${activeButton === 'meet' ? 'selected' : ''}`}>
                    <i class="bi bi-calendar-check text-white"></i>
                </div>
                <p class="text-center w-100">Meet</p>
            </a> */}
           
            {/* <a href="#" class="ps-2 d-flex justify-content-center flex-column align-items-center" onClick={() => toggleDiv('upload')}>
                <div class={`item d-flex justify-content-center align-items-center ${activeButton === 'upload' ? 'selected' : ''}`}>
                    <i class="bi bi-cloud-arrow-up-fill text-white"></i>
                </div>
                <p class="text-center w-100">Upload</p>
            </a> */}

            {/* <a href="#" class="ps-2 d-flex justify-content-center flex-column align-items-center" onClick={() => toggleDiv('booking')}>
                <div class={`item d-flex justify-content-center align-items-center ${activeButton === 'booking' ? 'selected' : ''}`}>
                    <i class="bi bi-cloud-arrow-up-fill text-white"></i>
                </div>
                <p class="text-center w-100">Booking</p>
            </a> */}
        </div>

<div>

</div>


    
      {callVisible && <div id="callDiv" style={{height:"100vh"}}>
      {/* <a href="tel:+94763125620">

        <button  class="btn btn-sm btn_secondary text-white">{loading?"Calling...":"Call"}</button>
        </a> */}
      <h3 class="vm_font_bold ps-3 pt-3">Call History</h3>

<div class="activity_wrapper">
    <div class="row pt-3">
        <div class="col-md-4 col-4 d-flex justify-content-center align-items-center pe-md-0">
            <div class="border-bottom col"></div>
            <div class="vm_bg_light_red px-2 py-1 text-center">03 Feb</div>
            <div class="border-bottom col"></div>
        </div>
        <div class="col-md-8 col-8 vm_bg_light_red p-2">
            <p class="vm_font_bold">Call | Business LIne</p>
            <p>Outgoing | Wed at 07:45am</p>
        </div>
    </div>
    <div class="row pt-3">
        <div class="col-md-4 col-4 d-flex justify-content-center align-items-center pe-md-0">
            <div class="border-bottom col"></div>
            <div class="vm_bg_light_blue px-2 py-1 text-center">02 Feb</div>
            <div class="border-bottom col"></div>
        </div>
        <div class="col-md-8 col-8 vm_bg_light_blue p-2">
            <p class="vm_font_bold">Call | Business LIne</p>
            <p>Outgoing | Wed at 07:45am</p>
        </div>
    </div>
</div>
        
        
        </div>}
      {emailVisible && <div id="emailDiv" >
        
      <div class="px-3 pb-3 pt-2 bg-light mt-3">
                        <h3 class="vm_font_semi_bold border-bottom mb-3 pb-2">
                            <i class="bi bi-pencil"></i> Compose Email
                        </h3>
                        <div class="form-group row pb-2">
                            <div class="col-md-2 d-flex pt-2">
                                <label for="toemail">To email</label>
                            </div>
                            <div class="col-md-10">
                                <input class="form-control col" type="text" name="toemail" id="toemail" value={toEmail}  onChange={(e) => setToEmail(e.target.value)} placeholder="Enter to Email"/>
                            </div>
                        </div>
                       
 <div class="form-group row pb-2">
                            <div class="col-md-2 d-flex pt-2">
                                <label for="toemail">Subject</label>
                            </div>
                            <div class="col-md-10">
                                <input class="form-control col" type="text" name="subject" id="subject" value={subject} onChange={(event) =>{ setSubject(event.target.value); }}
                                 placeholder="Enter Subject"/>
                                <span class="text-danger">{email_error_list.subject}</span> 
                            </div>
                        </div>

                        <div class="form-group pb-2">
                            <label for="toemail">Message</label>
                            <textarea class="mh-100 form-control" name="message" id="message" cols="100%" value={message} placeholder="Enter Message" rows="4"
                            onChange={(event) =>{ setMessage(event.target.value); }}></textarea>
                             <span class="text-danger">{email_error_list.message}</span> 
                            
                        </div>
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center" style={{ marginLeft:"4px"}}>
                                <label class="vm_cursor_pointer" for="image"><i class="bi bi-card-image h2"></i></label>
                                <input class="d-none" type="file" name="image" id="image" multiple onChange= {onSelectImages}/>


 

                             
                                <select class="form-select ms-3 form-select-sm" name="template" id="template" value={template} onChange={handleTemplateChange}>
                                    <option value="">Select Template</option>
                                    {email_template
                                    .filter(item => item.is_show === 1)
                                    .map((item) => (
                                    <option value={item.template_name}>{item.template_name}</option>
                                    ))}
                                </select>

                            </div>



                            {successMessage && <p class="text-left" style={{color:"green"}}>{successMessage}</p>}
                            <div>

                                <button onClick={sendEmail} class="btn btn-sm btn_secondary text-white"><i class="bi bi-send"> </i>{loading?"Sending...":"Send Message"} </button>
                            </div>

                            
                        </div>
                        <div className="container"  style={{ maxHeight: "200px", overflowY: "auto", display: "flex" , padding:"15px"}}>
                        { previews.length > 0 && previews.map((preview, index) => (
                                                <div key={index} style={{ position: "relative", marginRight: "5px", marginBottom: "8px", height: "75px", width: "75px" }}  >
                                                   <span  style={{position:"absolute",cursor: "pointer",top: "-2px",right: "2px", fontSize: "20px", color:"limegreen"}}
                                                   className="delete" onClick={() => deleteImage(index)}>&times;</span>
                                                {preview.type === 'image' && (
                                                <img
                                                    loading="lazy"
                                                    onClick={() => handleImageClick(index)}
                                                    style={{ width: "100%", height: "100%", borderRadius: "5px" }}
                                                    src={preview.url}
                                                    alt={`Preview ${index}`}
                                                />
                                            )}
                                    
                                    {preview.type === 'pdf' && (
                                                
                                                    <img src="/img/pdf_icon.jpg" alt={`Preview ${index}`}  onClick={() => handlePdfClick(index)} 
                                                    style={{ width: "100%", height: "100%", borderRadius: "5px" }}/>
                                                
                                             
                                            )}
                                    
                                    {preview.type === 'video' && (
                                             
                                                <video  src={preview.url} alt={`Preview ${index}`}  onClick={() => handleVideoClick(index)} 
                                                style={{ width: "100%", height: "100%", borderRadius: "5px" }}/>
                                           
                                        )}
                                                </div>
                                            ))}
                                        </div>
                    </div>

                    <h3 class="vm_font_bold ps-3 pt-2">Email History</h3>
                    <div class="content">
                    <div class="row pt-3" style={{padding:"10px"}}>
                    <div class="col-md-8 form-group" >
                 
                                  <div class="d-flex input_wrapper" >
                                  <div ><label>Show   <select name="example_length" aria-controls="example" value={perPage} onChange={(e) => {setCurrentPage(0);setPerPage(Number(e.target.value))}}>
                                      <option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option>
                                    </select>  entries</label>
                                    </div>
                                  </div>
                              </div>
  
                              <div class="col-md-4 form-group">
                                  <div class="d-flex input_wrapper">
                                  
                                      <input class="form-control" name="searchQuery" id="searchQuery" placeholder="Search..." type="text" 
                                      value={searchQuery} onChange={(e) => {setSearchQuery(e.target.value)}}/>
                                  </div>
                              </div>
                              </div>
                    {filteredEmailHistory.length==0?
                <p style={{ textAlign: "center" }}>No records found</p>
                :
(filteredEmailHistory.slice((currentPage * perPage), ((currentPage * perPage) + perPage)).map((item, index) => (
                    <div class="activity_wrapper pb-3 mb-1">
                        <div class="row pt-1">
                            <div class="col-md-4 col-4 d-flex justify-content-center align-items-center pe-md-0">
                                <div class="border-bottom col"></div>
                                <div class="vm_bg_light_red px-2 py-1 text-center">{formatDate(item.created_at)}</div>
                                <div class="border-bottom col"></div>
                            </div>
                            <div class="col-md-8 col-8 vm_bg_light_red p-2">
                                <p class="vm_font_bold">Subject | {item.subject}</p>
                               
                                <p>  
                                <a
                            className="btn btn-link p-0"
                            style={{ fontSize: '0.85rem' }}
                            onClick={() => handleToggle(item.id)} // Replace item.id with unique identifier for each email
                            aria-controls={`collapse-text-${item.id}`}
                            aria-expanded={openEmailId === item.id}
                        >
                            {openEmailId === item.id ? 'Show Less' : 'Show More'}
                        </a>
                    </p>
                    <Collapse in={openEmailId === item.id}>
                        <div id={`collapse-text-${item.id}`} dangerouslySetInnerHTML={{ __html: item.message }} />
                    </Collapse>
                                <p>{getDayName(item.created_at)} at {formatTime(item.created_at)}</p>
                            </div>
                           
                        </div>                    
                    </div>
                    )))}
<div class="col-md-4" style={{ float: "left", padding: "20px 0px 0px 10px" }}>
                                        {filteredEmailHistory.length > 0 && `Showing 1 to ${Math.min(perPage, filteredEmailHistory.length)} of ${emailLogById.length} entries`}
                                    </div><div class="col-md-8" style={{ float: "right" }}>

                                        <ReactPaginate style={{ float: "right" }}
                                            previousLabel={"< Prev"}
                                            nextLabel={"Next >"}
                                            breakLabel={'...'}
                                            pageCount={Math.ceil(filteredEmailHistory.length / perPage)}
                                            onPageChange={handlePageChange}
                                            containerClassName={"pagination pagination-sm justify-content-center custom-pagination"} // Bootstrap pagination class
                                            disabledClassName={"disabled"}
                                            breakClassName={['page-item']}
                                            breakLinkClassName={'page-link'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item'}
                                            nextLinkClassName={'page-link'}
                                            activeClassName={['active']} />


                                    </div>

                    </div>
                
        
        </div>}
      {textVisible && <div id="textDiv">
        
      <div class="py-4 mt-4 border-top bg-light">
                        <div class="form-group pb-4 px-3">
                            <label for="toemail">Text Message</label>
                            <textarea class="mh-100 form-control" name="text_message" id="text_message" cols="100%" rows="3" value={text_message}  placeholder="Enter Text Message"
                            onChange={(event) =>{ setText_message(event.target.value); }}></textarea>
                            <span  class="text-danger">{error_list.text_message}</span>
                        </div>
                        <div class="d-md-flex">
                            {/* <div>
                            <select class="form-select ms-3 form-select-sm" name="text_template" id="text_template" value={text_template} onChange={handleTextTemplateChange}>
                                    <option value="">Select Template</option>
                                    {sms_template.map((item) => (
                                    <option value={item.template_name}>{item.template_name}</option>
                                    ))}
                                </select>
                            </div> */}
                            <div class="ms-auto me-3">
                                <button  onClick={sendSMS} class="btn btn-sm btn_secondary text-white ms-md-4"><i class="bi bi-send"></i>{loading?' Sending...':' Send SMS'}</button>
                            </div>
                        </div>
                    </div>

                    <h3 class="vm_font_bold ps-3 pt-2">Text History</h3>
                    <div class="content">
                    <div class="row pt-3" style={{padding:"10px"}}>
                    <div class="col-md-9 form-group" >
                 
                                  <div class="d-flex input_wrapper" >
                                  <div ><label>Show   <select name="example_length" aria-controls="example" value={perPage} onChange={(e) => {setCurrentPage(0);setPerPage(Number(e.target.value))}}>
                                      <option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option>
                                    </select>  entries</label>
                                    </div>
                                  </div>
                              </div>
  
                              <div class="col-md-3 form-group">
                                  <div class="d-flex input_wrapper">
                                  
                                      <input class="form-control" name="searchQuery" id="searchQuery" placeholder="Search..." type="text" 
                                      value={searchQuery} onChange={(e) => {setSearchQuery(e.target.value)}}/>
                                  </div>
                              </div>

{/* <div class="col-md-3 form-group">
    <div class="d-flex input_wrapper">
       <div> <label>Sort by <select  value={sortOrder}   onChange={(e) => setSortOrder(e.target.value)} >
                <option value="newest">Newest</option>
                <option value="oldest">Oldest</option>
            </select>
        </label>
        </div>
    </div>
</div> */}
                              </div>
                    {sortedSmsHistory.length==0?
                <p style={{ textAlign: "center" }}>No records found</p>
                :
(sortedSmsHistory.slice((currentPage * perPage), ((currentPage * perPage) + perPage)).map((item, index) => (
                    <div class="activity_wrapper pb-3 mb-1">
                        <div class="row pt-1">
                            <div class="col-md-4 col-4 d-flex justify-content-center align-items-center pe-md-0">
                                <div class="border-bottom col"></div>
                                <div class="vm_bg_light_blue px-2 py-1 text-center">{formatDate(item.created_at)}</div>
                                <div class="border-bottom col"></div>
                            </div>
                            <div class="col-md-8 col-8 vm_bg_light_blue p-2">
                                <p class="vm_font_bold">Message | {item.message}</p>
                                <p>{getDayName(item.created_at)} at {formatTime(item.created_at)}</p>
                            </div>
                        </div>
                      
                    </div>
                        )))}
                        <div class="col-md-4" style={{ float: "left", padding: "20px 0px 0px 10px" }}>
                                                                {sortedSmsHistory.length > 0 && `Showing 1 to ${Math.min(perPage, sortedSmsHistory.length)} of ${smsLogById.length} entries`}
                                                            </div><div class="col-md-8" style={{ float: "right" }}>
                        
                                                                <ReactPaginate style={{ float: "right" }}
                                                                    previousLabel={"< Prev"}
                                                                    nextLabel={"Next >"}
                                                                    breakLabel={'...'}
                                                                    pageCount={Math.ceil(sortedSmsHistory.length / perPage)}
                                                                    onPageChange={handlePageChange}
                                                                    containerClassName={"pagination pagination-sm justify-content-center custom-pagination"} // Bootstrap pagination class
                                                                    disabledClassName={"disabled"}
                                                                    breakClassName={['page-item']}
                                                                    breakLinkClassName={'page-link'}
                                                                    pageClassName={'page-item'}
                                                                    pageLinkClassName={'page-link'}
                                                                    previousClassName={'page-item'}
                                                                    previousLinkClassName={'page-link'}
                                                                    nextClassName={'page-item'}
                                                                    nextLinkClassName={'page-link'}
                                                                    activeClassName={['active']} />
                        
                        
                                                            </div>
                        
                                            </div>
               
        
        
        </div>}
      {pinVisible && <div id="pinDiv">
      
      <div class="py-4 mt-4 border-top bg-light">
                        <div class="form-group pb-4 px-3">
                            <label for="toemail">Enter Pin Message</label>
                            <textarea class="mh-100 form-control" name="pin_message" id="pin_message" cols="100%" value={pin_message}
                            onChange={(event) =>{ setPin_message(event.target.value); }} rows="3"></textarea>
                             <span  class="text-danger">{error_list.pin_message}</span>
                        </div>
                        <div class="d-md-flex justify-content-start">
                            <div>
                            <select class="form-select ms-3 form-select-sm" name="pin_template_select" id="pin_template_select" value={pin_template_select} onChange={handlePinTemplateChange}>
                                    <option value="">Select Pin Template</option>
                                    {pin_template.map((item) => (
                                    <option value={item.pin_title}>{item.pin_title}</option>
                                    ))}
                                </select>
                            </div>
                            <div class="ms-auto me-3">
                                <button class="btn btn-sm btn_secondary text-white ms-md-4"><i class="bi bi-send"></i>{loading?' Sending...':' Send Message'}</button>
                            </div>
                        </div>
                    </div>

                    <h3 class="vm_font_bold ps-3 pt-2">Pin History</h3>

                    <div class="activity_wrapper pb-5 mb-5">
                        <div class="row pt-1">
                            <div class="col-md-4 col-4 d-flex justify-content-center align-items-center pe-md-0">
                                <div class="border-bottom col"></div>
                                <div class="vm_bg_light_red px-2 py-1 text-center">03 Feb</div>
                                <div class="border-bottom col"></div>
                            </div>
                            <div class="col-md-8 col-8 vm_bg_light_red p-2">
                                <p class="vm_font_bold">Call | Business LIne</p>
                                <p>Outgoing | Wed at 07:45am</p>
                            </div>
                        </div>
                        <div class="row pt-3">
                            <div class="col-md-4 col-4 d-flex justify-content-center align-items-center pe-md-0">
                                <div class="border-bottom col"></div>
                                <div class="vm_bg_light_blue px-2 py-1 text-center">02 Feb</div>
                                <div class="border-bottom col"></div>
                            </div>
                            <div class="col-md-8 col-8 vm_bg_light_blue p-2">
                                <p class="vm_font_bold">Call | Business LIne</p>
                                <p>Outgoing | Wed at 07:45am</p>
                            </div>
                        </div>
                    </div>
                
      </div>}
      {meetVisible && <div id="meetDiv">
      <div class="py-4 mt-4 border-top bg-light">

      <div className="content px-3">
                         
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                                <label htmlFor="meeting_title">Enter Title</label>
                                            <input type="text" className="form-control" id="meeting_title" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Ex: Meeting..." />
                                            <span class="text-danger">{meetingErrorList.title}</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group py-2">
                                            <label htmlFor="date">Select Date</label>
                                            <div class="d-flex input_wrapper">
                                                <div class="icon_wrapper">
                                                    <i class="bi bi-calendar2-plus icon"></i>
                                                </div>
                                                {/* <input type="datetime-local" className="form-control" id="start_datetime" value={startDatetime} onChange={(e) => setStartDatetime(e.target.value)} /> */}
                                         
          <input type="date" id="date" value={date} className="form-control" onChange={handleDateChange} required />
     

                                            </div>
                                            <span class="text-danger">{meetingErrorList.date}</span>
                                        </div>
                                    </div>


                                    <div className="col-md-6">
                                    <div className="form-group py-2">
          <label htmlFor="time">Select Time:</label>
          <select id="time" value={time} className="form-control" onChange={(e) => setTime(e.target.value)} required>
            <option value="">Select Time</option>
            {availableTimeSlots.map((timeSlot, index) => (
              <option key={index} value={timeSlot}>{timeSlot}</option>
            ))}
          </select>
          <span class="text-danger">{meetingErrorList.time}</span>
          </div>
        </div>




                                  
                                </div>

                                <div class="d-flex justify-content-end ms-auto py-3">
                                        <button onClick={sendMeetingEmail} class="btn btn-sm btn_secondary text-white "><i class="bi bi-send"></i>  {loading ? "Sending..." : "Send Message"} </button>
                                </div>
                         
                                </div>
        
      </div> 

      <h3 class="vm_font_bold ps-3 pt-2">Meet History</h3>


<div class="content">
<div class="row pt-3" style={{padding:"10px"}}>
<div class="col-md-8 form-group" >

              <div class="d-flex input_wrapper" >
              <div ><label>Show   <select name="example_length" aria-controls="example" value={perPage} onChange={(e) => {setCurrentPage(0);setPerPage(Number(e.target.value))}}>
                  <option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option>
                </select>  entries</label>
                </div>
              </div>
          </div>

          <div class="col-md-4 form-group">
              <div class="d-flex input_wrapper">
              
                  <input class="form-control" name="searchQuery" id="searchQuery" placeholder="Search..." type="text" 
                  value={searchQuery} onChange={(e) => {setSearchQuery(e.target.value)}}/>
              </div>
          </div>
          </div>


<div class="activity_wrapper pb-5 mb-5">


{filteredMeetHistory.length==0?
<p style={{ textAlign: "center" }}>No records found</p>
:
(filteredMeetHistory.slice((currentPage * perPage), ((currentPage * perPage) + perPage)).map((item, index) => (
<div class="activity_wrapper pb-3 mb-1">
    <div class="row pt-1">
        <div class="col-md-4 col-4 d-flex justify-content-center align-items-center pe-md-0">
            <div class="border-bottom col"></div>
            <div class="vm_bg_light_green px-2 py-1 text-center">{formatDate(item.created_at)}</div>
            <div class="border-bottom col"></div>
        </div>
        <div class="col-md-8 col-8 vm_bg_light_green p-2">
            <p class="vm_font_bold">{item.subject} on {formatMeetDate(item.date)} at {formatMeetTime(item.time)} </p>
            <p>{getDayName(item.created_at)} at {formatTime(item.created_at)}</p>
        </div>
       
    </div>                    
</div>
)))}
<div class="col-md-4" style={{ float: "left", padding: "20px 0px 0px 10px" }}>
                    {filteredMeetHistory.length > 0 && `Showing 1 to ${Math.min(perPage, filteredMeetHistory.length)} of ${meetLogById.length} entries`}
                </div><div class="col-md-8" style={{ float: "right" }}>

                    <ReactPaginate style={{ float: "right" }}
                        previousLabel={"< Prev"}
                        nextLabel={"Next >"}
                        breakLabel={'...'}
                        pageCount={Math.ceil(filteredMeetHistory.length / perPage)}
                        onPageChange={handlePageChange}
                        containerClassName={"pagination pagination-sm justify-content-center custom-pagination"} // Bootstrap pagination class
                        disabledClassName={"disabled"}
                        breakClassName={['page-item']}
                        breakLinkClassName={'page-link'}
                        pageClassName={'page-item'}
                        pageLinkClassName={'page-link'}
                        previousClassName={'page-item'}
                        previousLinkClassName={'page-link'}
                        nextClassName={'page-item'}
                        nextLinkClassName={'page-link'}
                        activeClassName={['active']} />


                </div>

</div>

</div>


      </div>
    
      
      }



      {noteVisible && <div id="noteDiv">
        
        
      <div class="py-4 mt-4 border-top bg-light">

      <div class="form-group pb-4 px-3">
                            <label for="note_subject">Subject</label>
                            <input class="mh-100 form-control" name="note_subject" id="note_subject" cols="100%" value={note_subject}
                            onChange={(event) =>{ setNote_subject(event.target.value); }} placeholder="Enter Subject"/>
                             <span  class="text-danger">{noteErrorList.note_subject}</span>
                        </div>

                        <div class="form-group pb-4 px-3">
                            <label for="note_message">Note Message</label>
                            <textarea class="mh-100 form-control" name="note_message" id="note_message" cols="100%" value={note_message}
                            onChange={(event) =>{ setNote_message(event.target.value); }} rows="3" placeholder="Enter Note Message"></textarea>
                             <span  class="text-danger">{noteErrorList.note_message}</span>
                        </div>

                        <div className="form-group px-3">
                            <label className="d-flex align-items-center">
                                <div
                                    onClick={handleEmailToggle}
                                    className={`toggle-button ${isEmail ? 'on' : 'off'}`}
                                    style={{
                                        width: '30px',
                                        height: '15px',
                                        backgroundColor: isEmail ? '#4caf50' : '#ccc',
                                        borderRadius: '10px',
                                        cursor: 'pointer',
                                        position: 'relative',
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '13px',
                                            height: '13px',
                                            backgroundColor: '#fff',
                                            borderRadius: '50%',
                                            position: 'absolute',
                                            top: '1px',
                                            left: isEmail ? '16px' : '1px',
                                            transition: 'left 0.2s',
                                        }}
                                    ></div>
                                </div>
                                <span className="ms-2">Send as Email</span>
                            </label>
                        </div>
      {isEmail ? (
                        <div class="d-md-flex">
                            <div>
                            <select class="form-select ms-3 form-select-sm" name="note_template_select" id="note_template_select" value={note_template_select} onChange={handleNoteTemplateChange}>
                                    <option value="">Select Note Template</option>
                                    {note_template.map((item) => (
                                    <option value={item.note_title}>{item.note_title}</option>
                                    ))}
                                </select>
                            </div>
                            <div class="ms-auto me-3">
                                <button onClick={sendNoteEmail} class="btn btn-sm btn_secondary text-white ms-md-4"><i class="bi bi-send"></i>{loading?' Sending...':' Send Note'}</button>
                            </div>
                        </div>
                   ) :(
                <div className="d-md-flex justify-content-end me-3">

                                <button onClick={saveNote} class="btn btn-sm btn_secondary text-white ms-md-4"><i class="bi bi-send"></i>{loading?' Saving...':' Save Note'}</button>
                            </div>
                   )
                }
                  
                  
                    </div>

                    <h3 class="vm_font_bold ps-3 pt-2">Note History</h3>


                    <div class="content">
                    <div class="row pt-3" style={{padding:"10px"}}>
                    <div class="col-md-8 form-group" >
                 
                                  <div class="d-flex input_wrapper" >
                                  <div ><label>Show   <select name="example_length" aria-controls="example" value={perPage} onChange={(e) => {setCurrentPage(0);setPerPage(Number(e.target.value))}}>
                                      <option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option>
                                    </select>  entries</label>
                                    </div>
                                  </div>
                              </div>
  
                              <div class="col-md-4 form-group">
                                  <div class="d-flex input_wrapper">
                                  
                                      <input class="form-control" name="searchQuery" id="searchQuery" placeholder="Search..." type="text" 
                                      value={searchQuery} onChange={(e) => {setSearchQuery(e.target.value)}}/>
                                  </div>
                              </div>
                              </div>


                    <div class="activity_wrapper pb-5 mb-5">
    

                    {filteredNoteHistory.length==0?
                <p style={{ textAlign: "center" }}>No records found</p>
                :
(filteredNoteHistory.slice((currentPage * perPage), ((currentPage * perPage) + perPage)).map((item, index) => (
                    <div class="activity_wrapper pb-3 mb-1">
                        <div class="row pt-1">
                            <div class="col-md-4 col-4 d-flex justify-content-center align-items-center pe-md-0">
                                <div class="border-bottom col"></div>
                                <div class="vm_bg_light_yellow px-2 py-1 text-center">{formatDate(item.created_at)}</div>
                                <div class="border-bottom col"></div>
                            </div>
                            <div class="col-md-8 col-8 vm_bg_light_yellow p-2">
                                <p class="vm_font_bold">
                               
                                    Subject | {item.subject}
                                    {item.to ? <span style={{ backgroundColor: "#059618", fontSize: "12px", borderRadius: "50%", marginLeft: "10px" }} class="badge badge-success">E</span> : null}</p>
                                    <p>  
                                <a
                            className="btn btn-link p-0"
                            style={{ fontSize: '0.85rem' }}
                            onClick={() => handleToggleNote(item.id)} // Replace item.id with unique identifier for each email
                            aria-controls={`collapse-text-${item.id}`}
                            aria-expanded={openEmailId === item.id}
                        >
                            {openNoteId === item.id ? 'Show Less' : 'Show More'}
                        </a>
                    </p>
                    <Collapse in={openNoteId === item.id}>
                        <div id={`collapse-text-${item.id}`} dangerouslySetInnerHTML={{ __html: item.message }} />
                    </Collapse>
                               
                                <p>{getDayName(item.created_at)} at {formatTime(item.created_at)}</p>
                            </div>
                           
                        </div>                    
                    </div>
                    )))}
<div class="col-md-4" style={{ float: "left", padding: "20px 0px 0px 10px" }}>
                                        {filteredNoteHistory.length > 0 && `Showing 1 to ${Math.min(perPage, filteredNoteHistory.length)} of ${noteLogById.length} entries`}
                                    </div><div class="col-md-8" style={{ float: "right" }}>

                                        <ReactPaginate style={{ float: "right" }}
                                            previousLabel={"< Prev"}
                                            nextLabel={"Next >"}
                                            breakLabel={'...'}
                                            pageCount={Math.ceil(filteredNoteHistory.length / perPage)}
                                            onPageChange={handlePageChange}
                                            containerClassName={"pagination pagination-sm justify-content-center custom-pagination"} // Bootstrap pagination class
                                            disabledClassName={"disabled"}
                                            breakClassName={['page-item']}
                                            breakLinkClassName={'page-link'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item'}
                                            nextLinkClassName={'page-link'}
                                            activeClassName={['active']} />


                                    </div>

                  
                


</div>

                    </div>
                
        
       </div>}
      {uploadVisible && <div id="uploadDiv">
        
      <div class="py-4 mt-4 border-top bg-light">

      <div class="form-group col-3 pb-4 px-0.5">
      <select class="form-select ms-3 form-select-sm" name="upload_template_select" id="upload_template_select" value={upload_template_select} onChange={handleUploadTemplateChange}>
                              <option value="">Select Category</option>
                              {upload_template.map((item) => (
                              <option value={item.upload_title}>{item.upload_title}</option>
                              ))}
                          </select>
</div>
<div class="form-group pb-4 px-3">
                      <label for="upload_subject">Subject</label>
                      <input class="mh-100 form-control" name="upload_subject" id="upload_subject" cols="100%" value={upload_subject}
                      onChange={(event) =>{ setUpload_subject(event.target.value); }} placeholder="Enter Subject"/>
                       <span  class="text-danger">{uploadErrorList.upload_subject}</span>
                  </div>

                  <div class="form-group pb-3 px-3">
                      <label for="note_message">Upload Message</label>
                      <textarea class="mh-100 form-control" name="upload_message" id="upload_message" cols="100%" value={upload_message}
                      onChange={(event) =>{ setUpload_message(event.target.value); }} rows="3" placeholder="Enter Upload Message"></textarea>
                       <span  class="text-danger">{uploadErrorList.upload_message}</span>
                  </div>
           
                      <div class="d-flex pb-3 px-3 align-items-center justify-content-between">
                            <div  >
                                {/* <label class="vm_cursor_pointer" for="image"><i class="bi bi-card-image" style={{fontSize: '2rem'}} ></i></label> */}
                                <label class="vm_cursor_pointer border border-1 d-flex align-items-center px-2" for="image" style={{width:"max-content"}}>
                                    <i class="bi bi-upload  h3 me-2"></i>
                                    Upload Files
                                </label>
                                <input class="d-none" type="file" name="image" id="image" multiple onChange= {onSelectImages}/>
                     
 <div>
                            </div>


                      </div>


                      <div class="ms-auto me-3">
                          <button onClick={uploadDocuments}  class="btn btn-sm btn_secondary text-white ms-md-4"><i class="bi bi-send"></i>{loading?' Uploading...':' Upload'}</button>
                      </div>


                      </div>
                      <div className="container"  style={{ maxHeight: "200px", overflowY: "auto", display: "flex" , padding:"15px"}}>
                        { previews.length > 0 && previews.map((preview, index) => (
                                                <div key={index} style={{ position: "relative", marginRight: "5px", marginBottom: "8px", height: "75px", width: "75px" }}  >
                                                   <span  style={{position:"absolute",cursor: "pointer",top: "-2px",right: "2px", fontSize: "20px", color:"limegreen"}}
                                                   className="delete" onClick={() => deleteImage(index)}>&times;</span>
                                                {preview.type === 'image' && (
                                                <img
                                                    loading="lazy"
                                                    onClick={() => handleImageClick(index)}
                                                    style={{ width: "100%", height: "100%", borderRadius: "5px" }}
                                                    src={preview.url}
                                                    alt={`Preview ${index}`}
                                                />
                                            )}
                                    
                                    {preview.type === 'pdf' && (
                                                
                                                    <img src="/img/pdf_icon.jpg" alt={`Preview ${index}`}  onClick={() => handlePdfClick(index)} 
                                                    style={{ width: "100%", height: "100%", borderRadius: "5px" }}/>
                                                
                                             
                                            )}
                                    
                                    {/* {preview.type === 'video' && (
                                             
                                                <video  src={preview.url} alt={`Preview ${index}`}  onClick={() => handleVideoClick(index)} 
                                                style={{ width: "100%", height: "100%", borderRadius: "5px" }}/>
                                           
                                        )} */}
                                                </div>
                                            ))}
                                        </div>
                        

                 
              </div>

            <h3 class="vm_font_bold ps-3 pt-2">Uploaded Documents</h3>
            <ul className="nav nav-tabs" id="messageTabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button className={`nav-link ${activeTab === 'documents' ? 'active' : ''}`} id="documents-tab" data-bs-toggle="tab" data-bs-target="#documents" type="button" role="tab" aria-controls="documents"  aria-selected={activeTab === 'documents' ? 'true' : 'false'} onClick={() => setActiveTab('documents')}>Documents</button>
          </li>
            
            
          <li className="nav-item" role="presentation">
            <button className={`nav-link ${activeTab === 'timeline' ? 'active' : ''}`} id="timeline-tab" data-bs-toggle="tab" data-bs-target="#timeline" type="button" role="tab" aria-controls="timeline"   aria-selected={activeTab === 'timeline' ? 'true' : 'false'} onClick={() => setActiveTab('timeline')}>Timeline</button>
          </li>
            
        </ul>     

        <div className="tab-content" id="messageTabsContent">
          <div className={`tab-pane fade ${activeTab === 'documents' ? 'show active' : ''}`} id="documents" role="tabpanel" aria-labelledby="documents-tab">
         

          <div class="row pt-4 d-flex justify-content-center px-4">
                        <h4 class="text-center vm_font_bold pb-2 text-uppercase">Images</h4>
                        
                        {filteredUploadHistory.length==0?
          <p style={{ textAlign: "center" }}>No records found</p>
          :
(filteredUploadHistory.slice((currentPage * perPage), ((currentPage * perPage) + perPage)).map((item, index) => (              
                     <>{item.document_path ? (
            item.document_path.split(',').map((path, index) => (
               
                isImage(path.trim()) && (
             
                    <div key={index} class="col-md-4 col-6 pb-3 position-relative">
                      {(isUploadImageLoading && item.document_path) ? <img class="w-100" onLoad={handleUploadImageLoad} src={placeholderImage} />
                  :  <img class="w-100" onClick={() => uploadImageClick(`${LARAVEL_API_URL}/${path.trim()}`)}  src={path?`${LARAVEL_API_URL}/${path.trim()}`:placeholderImage} />
                }
                </div>
                  
                )              
            ))
        ) : 'No records found'}</>
)))}

                       
                    </div>
         
          <div class="row pt-4 d-flex justify-content-center px-4 pb-3">
                        <h4 class="text-center vm_font_bold pb-2 text-uppercase">Documents</h4>
                       
                        {filteredUploadHistory.length==0?
          <p style={{ textAlign: "center" }}>No records found</p>
          :
(filteredUploadHistory.slice((currentPage * perPage), ((currentPage * perPage) + perPage)).map((item, index) => (              
                      <p class="vm_font_bold">{item.document_path ? (
            item.document_path.split(',').map((path, index) => (
               
                isDocument(path.trim()) && (
                <span key={index}>
                    <div class="d-flex align-items-center border-bottom pb-2 mb-2">   
                      
                   {/* <label for="checkbox1" class="d-flex align-items-center ps-2"> */}
                  <i class="bi bi-file-earmark-pdf-fill fs-5"></i>
                  <a  class="ps-2" href={`${LARAVEL_API_URL}/${path.trim()}`} target="_blank">{` ${path.trim().split('/').pop()}`}</a>
                  {/* <p class="ps-2">Document Name 1</p> */}
              {/* </label> */}
                
                </div>
                    </span>
                )              
            ))
        ) : 'No records found'}</p>
)))}  
                        
  
                       
                    </div>
</div>


          <div className={`tab-pane fade ${activeTab === 'timeline' ? 'show active' : ''}`} id="timeline" role="tabpanel" aria-labelledby="timeline-tab">

          <div class="content">
              <div class="row pt-3" style={{padding:"10px"}}>
              <div class="col-md-8 form-group" >
           
                            <div class="d-flex input_wrapper" >
                            <div ><label>Show   <select name="example_length" aria-controls="example" value={perPage} onChange={(e) => {setCurrentPage(0);setPerPage(Number(e.target.value))}}>
                                <option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option>
                              </select>  entries</label>
                              </div>
                            </div>
                        </div>

                        <div class="col-md-4 form-group">
                            <div class="d-flex input_wrapper">
                            
                                <input class="form-control" name="searchQuery" id="searchQuery" placeholder="Search..." type="text" 
                                value={searchQuery} onChange={(e) => {setSearchQuery(e.target.value)}}/>
                            </div>
                        </div>
                        </div>


              <div class="activity_wrapper pb-5 mb-5">


              {filteredUploadHistory.length==0?
          <p style={{ textAlign: "center" }}>No records found</p>
          :
(filteredUploadHistory.slice((currentPage * perPage), ((currentPage * perPage) + perPage)).map((item, index) => (
              <div class="activity_wrapper pb-3 mb-1">
                  <div class="row pt-1">
                      <div class="col-md-4 col-4 d-flex justify-content-center align-items-center pe-md-0">
                          <div class="border-bottom col"></div>
                          <div class="vm_bg_light_pink px-2 py-1 text-center">{formatDate(item.created_at)}</div>
                          <div class="border-bottom col"></div>
                      </div>
                      
                      <div class="col-md-8 col-8 vm_bg_light_pink p-2">
                      <p class="vm_font_bold"> {item.subject} - {item.document_path ? (
            item.document_path.split(',').map((path, index) => (
                <span key={index}>
                    {` ${path.trim().split('/').pop()}`}
                    {/* <a style={{ color: 'gray', textDecoration: 'underline' }}>
                        {item.document_path.split(',').length > 1 ?   `View document ${index + 1}` : 'View document'}
                    </a> */}
                    {index !== item.document_path.split(',').length - 1 && ', '}
                </span>
            ))
        ) : 'No records found'}</p>
                          <p>{getDayName(item.created_at)} at {formatTime(item.created_at)}</p>
                      </div>
                     
                  </div>                    
              </div>
              )))}
<div class="col-md-4" style={{ float: "left", padding: "20px 0px 0px 10px" }}>
                                  {filteredUploadHistory.length > 0 && `Showing 1 to ${Math.min(perPage, filteredUploadHistory.length)} of ${uploadLogById.length} entries`}
                              </div><div class="col-md-8" style={{ float: "right" }}>

                                  <ReactPaginate style={{ float: "right" }}
                                      previousLabel={"< Prev"}
                                      nextLabel={"Next >"}
                                      breakLabel={'...'}
                                      pageCount={Math.ceil(filteredUploadHistory.length / perPage)}
                                      onPageChange={handlePageChange}
                                      containerClassName={"pagination pagination-sm justify-content-center custom-pagination"} // Bootstrap pagination class
                                      disabledClassName={"disabled"}
                                      breakClassName={['page-item']}
                                      breakLinkClassName={'page-link'}
                                      pageClassName={'page-item'}
                                      pageLinkClassName={'page-link'}
                                      previousClassName={'page-item'}
                                      previousLinkClassName={'page-link'}
                                      nextClassName={'page-item'}
                                      nextLinkClassName={'page-link'}
                                      activeClassName={['active']} />


                              </div>

</div>

              </div>


</div>
</div>
        
        
        
        </div>}



{infoVisible && 
            <>
               {/* <div class="border vm_bg_secondary p-2 d-flex justify-content-between align-items-center shadow-lg vm_cursor_pointer mx-3 my-3" data-bs-target="#exampleModalToggle" data-bs-toggle="modal">
                <h5 class="text-white text-uppercase vm_font_bold ps-2">Booking Information</h5>
              
            </div> */}

{/* <div className="d-flex justify-content-end align-items-center border-top bg-light my-3 mx-3"> */}
<div class=" mt-2 pt-2 px-3 border-top bg-light">
<div className="d-flex justify-content-end">
  
{customerById?.is_same_day === 1 && (
      <div className="alert alert-danger mb-0 py-1 px-3 me-3" style={{ margin: 0, borderRadius: '5px' }}>
        <strong>Same Day Booking</strong>
      </div>
    )}

<Link
  to={`/view-booking/${customerById.customer_id}`}
  className="btn btn-sm btn_secondary me-2"
  style={{ color: 'white', textDecoration: 'none' }}
>
  Add New Booking
</Link>

    

      <Link
  to={`/edit-booking/${customerById.id}`}
  className="btn btn-sm btn_secondary"
  style={{ backgroundColor: '#6c757d', color: 'white', textDecoration: 'none' }}
>
  Edit
</Link>


    

      <button class="btn btn-sm btn_secondary" data-bs-target="#createNewCustomre" style={{ background: "red", margin: "0px 0px 0px 10px" }}
       onClick={(e) => cancelBooking(e, customerById.id)}><i class="bi-x-circle"></i></button>
 
    </div>
    </div>
                  
<div class="d-flex mt-2 pt-2 px-3 border-top bg-light">


        <div className="vm_content_box_1 mt-2 ">

      
       
        <div class="title">
       
            <h2>Booking Details</h2>

     
           

            <button style={{ color: "white", backgroundColor: "transparent", border: "none", padding: "0" }} onClick={handleEditBooking}>
        <i className="bi bi-pencil-square vm_bg_secondary text-white pt-1 pb-1 px-2 py-2"></i>
      </button>
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Booking - {moment(customerById.booked_date).format('D MMMM YYYY')}  </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="col-md-12">
        <div className="form-box py-2 px-3 bg-light border  shadow-sm mb-4">
        <div className="col-md-12">
        <div className='row'>
            

                                          {/* <div className="col-md-12">
                                                    <div className="col-md-4">
                                                        <div className="form-group ">
                                                        <label htmlFor="date"> Date</label>
                                                        <div class="d-flex input_wrapper">
                                                                        <div class="icon_wrapper">
                                                                            <i class="bi bi-calendar2-plus icon"></i>
                                                                        </div>
                                                        <input type="date" id="booking_date" value={booking_date} className="form-control"
                                                           onChange={(e) => {
                                                            const value = e.target.value;
                                                            setBooking_date(value); // Update individual kids_count state
                                            
                                                            // Update customerById state with the new kids_count value
                                                            setCustomerById(prevCustomer => ({
                                                                ...prevCustomer,
                                                                booking_date: value,
                                                            }));
                                                        }}  />
                                                        </div>
                                                        <span class="text-danger">{bookingErrorList.booked_date}</span>
                                                    </div>  
                                                        </div>  
                                                        </div> */}

                                                         <div className="col-md-3">
                                                        <div className="form-group ">
                                                            <label htmlFor="kids_count">Kids</label>
                                                            <input
                                                                type="number"
                                                                id="kids_count"
                                                                name="kids_count"
                                                                value={kids_count}
                                                                className="form-control"
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    // const filteredGameType = game_types.filter(item => item.id === Number(customerById.game_type_id));
                                                                    // const totalPlayers = Number(kids_count) + Number(adults_count);
                                                                    // const min_players = filteredGameType[0].min_players;
                                                                    // const max_players = filteredGameType[0].max_players;
                                                                    // if (totalPlayers < min_players || totalPlayers > max_players) 
                                                                       
                                                                    //     {
                                                                           
                                                                    //         alert(`The total number of players must be between ${min_players} and ${max_players}.`);
                                                                    //         setKids_count(customerById.no_of_children);
                                                                     
                                                                    //     }
                                                                    //     else
                                                                    //     {
                                                                    setKids_count(value); // Update individual kids_count state
                                                    
                                                                    // Update customerById state with the new kids_count value
                                                                    setCustomerById(prevCustomer => ({
                                                                        ...prevCustomer,
                                                                        no_of_children: value,
                                                                    }));
                                                                }}
                                                            // }
                                                                min="0"
                                                                required
                                                            />
                                                        </div>
                                                    </div>   <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="adults_count">Adults</label>
                                                            <input
                                                                type="number"
                                                                id="adults_count"
                                                                name="adults_count"
                                                                value={adults_count}
                                                                className="form-control"
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    setAdults_count(value); // Update individual kids_count state
                                                    
                                                                    // Update customerById state with the new kids_count value
                                                                    setCustomerById(prevCustomer => ({
                                                                        ...prevCustomer,
                                                                        no_of_adults: value,
                                                                    }));
                                                                }}
                                                                required
                                                                min="0"
                                                            />
                                                        </div>
                                                       
                                                    </div>
                                                   
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="grand_total">Cost</label>
                                                            <input type="number" className="form-control" id="grand_total" value={sub_total}  readOnly/>

                                                        </div>
                                                    </div>  

                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="grand_total">Grand Total</label>
                                                            <input type="number" className="form-control" id="grand_total" value={grand_total} readOnly/>
                                                            <span class="text-danger">{bookingErrorList.grand_total}</span>
                                                        </div>
                                                    </div>
                                                    <span class="text-danger">{totalPlayersErrorList}</span>
                                                    {/* {customerById.package_name == "Birthday" &&
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="game_count">Game Count</label>
                                                            <input type="number" className="form-control" id="game_count" value={game_count}   onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    setGame_count(value); 
                                                                    setCustomerById(prevCustomer => ({
                                                                        ...prevCustomer,
                                                                        no_of_slots: value,
                                                                    }));
                                                                }} />
                                                            <span class="text-danger">{bookingErrorList.game_count}</span>
                                                        </div>
                                                    </div>
 */}

                                                     
                                            <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor="booking_time">Select Time:</label>
                                                            <div id="booking_time" className="form-control py-3">
                                                           
                                                            {timeSlotLoading ? (
                                                                    <div>Loading...</div>
                                                                ) : (
                                                                    bookingAvailableTimeSlots
                                                                    .map((timeSlot, index) => {
                                                                        const remainingSpace = availableSpaces[timeSlot] || 0;
                                                                         const game_type = game_types_array.find(item => item.id.toString() === customerById.game_type_id);
                                                                        // const isBooked = customerById.booking_time.includes(timeSlot);
                                                                         const isBooked = customerById?.booking_time?.includes(timeSlot);
                                                             
                                                                         let isDisabled = Array.isArray(disabledTimeSlots) && disabledTimeSlots.includes(timeSlot) && !isBooked;
                                                                         

                                                                          // Check if the time slot is in customerById.booki

                                                                      
                                                                     
                                                                             // Handle specific logic for "Private" game type
                                                                        if (game_type && game_type.game_type_name.toLowerCase().includes('private')) {
                                                                            // Disable slots that do not have exactly max players available
                                                                            if ( remainingSpace !== game_type.max_players_in_a_slot) {
                                                                                isDisabled = true;
                                                                            }
                                                                        }
                                                                     
                                                                    

                                                                        // Handle specific logic for "Birthday Package"
                                                                        // if (customerById.package_name === 'Birthday' ) {
                                                                            
                                                                        //     const userGameCount = parseInt(customerById.no_of_slots, 10); // Replace with the actual number of games selected by the user

                                                                          
                                                                        //         if ( userGameCount <= bookingAvailableTimeSlots.length) {
                                                                        //         const isConsecutiveAvailable = bookingAvailableTimeSlots.slice(index, index + userGameCount).every(slot => availableSpaces[slot] === game_packages[0].max_players_in_a_slot);
                                                                          
                                                                        //         if (!isConsecutiveAvailable) {
                                                                        //             isDisabled = true;
                                                                        //         }
                                                                        //     } 
                                                                        //     else {
                                                                        //         isDisabled = true;
                                                                        //     }

                                                                        // }                                                        
                                                                     

                                                                        if (booking_time.includes(timeSlot) ) {
                                                                            isDisabled = false;
                                                                        }

                                                                          const currentTime = dayjs(); // Get current system time
                                                                          const slotStartTimeString = timeSlot.split(" - ")[0]; // Extract "04:30 PM" from "04:30 PM - 05:00 PM"
                                                                          const slotStartTime = dayjs(slotStartTimeString, "hh:mm A", true); // Parse correctly
                                                                                                                                                
                                                                          if (!slotStartTime.isValid()) {
                                                                          console.error("Invalid time format:", slotStartTimeString);
                                                                          }

                                                                          if (dayjs(customerById.booked_date).isSame(dayjs(), "day") && slotStartTime.isValid() && slotStartTime.isBefore(currentTime)) {
                                                                           isDisabled = true;
                                                                           }

                                                                        return (
                                                                            <div
                                                                                key={index}
                                                                                className="form-group-checkbox d-flex align-items-center justify-content-between"
                                                                                style={isDisabled ? { color: '#a9a9a9', opacity: 0.6, pointerEvents: 'none' } : {}}
                                                                            >
                                                                        
                                                                                <div className="d-flex align-items-center">
                                                                                    <div>
                                                                                        <input
                                                                                            style={{ boxShadow: "2px 2px #059618", transition: "all .5s ease" }}
                                                                                            type="checkbox"
                                                                                            className="checkbox"
                                                                                            id={`timeslot_${index}`}
                                                                                            value={timeSlot}
                                                                                            checked={booking_time.includes(timeSlot)}
                                                                                            onChange={handleTimeSlotChange1}
                                                                                            disabled={isDisabled}
                                                                                            
                                                                                        />
                                                                                        <label
                                                                                            htmlFor={`timeslot_${index}`}
                                                                                            style={{ marginLeft: "5px" }}
                                                                                        >
                                                                                            <span style={isDisabled ? { textDecoration: 'line-through' } : {}}>
                                                                                                {timeSlot}
                                                                                            </span>
                                                                                            <span style={{ color: 'green', marginLeft: '30px' }}>
                                                                                                {remainingSpace} left
                                                                                            </span>
                                                                                        </label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })
                                                                
                                                                 )}
                                                               
                                                            </div>
                                                            <span className="text-danger">{bookingErrorList.booked_time}</span>
                                                        </div>
                                                    </div>


                                                    <div className="col-md-8 form-group">
        <div className="form-group-checkbox d-flex align-items-center justify-content-between">
            <div  className="d-flex align-items-center">
                <input
                    type="checkbox"
                    id="sendNotificationCheckbox"
                    defaultChecked={true}
                    style={{
                        height:'15px', width:'15px',
                        border:' solid' ,
                        boxShadow: "2px 2px #059618", transition: "all .5s ease"// Optional: Add cursor pointer for better UX
                    }}
                    required
                />
                <label  htmlFor="consent" style={{ marginTop: '10px' }}>
                Send email notification
                </label>
            </div>
            <span className="text-danger">{error_list.consent}</span>
            </div>
        </div>
                                                    </div>
                                                    </div>
                                                    </div>
                                                    </div>

         
        </Modal.Body>
        <Modal.Footer>
        <div class="d-md-flex align-items-center justify-content-end">
                                    <div>
                                        <button  class="btn btn-sm btn_secondary text-white" onClick={updateBooking}><i class="bi bi-save me-2"></i> 
                                         {loading ?'Updating' : 'Update'}
                                        </button>
                                    </div>
                                </div>
        </Modal.Footer>
      </Modal>
            
        </div>
        
<div className="content py-0 bg-white px-3 mb-3 w-100" >
            
          

<div className="row">
<div className="col-md-12">
<div className="row border-top pb-3">
                {[
                    // { label: 'Booking Id', value: customerById.booking_ref_id },
                    {
                      label: 'Scheduled Staff',
                      value: (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                          <span>
                          {customerById.staff_names
    ? customerById.staff_names
    : 'No staff assigned'}
                          </span>
                          <button
                            style={{
                              color: "white",
                              backgroundColor: "transparent",
                              border: "none",
                              padding: "0",
                              cursor: "pointer"
                            }}
                            onClick={handleEditStaff} // your popup trigger function
                          >
                          <i className={`bi ${
  customerById.staff_names
    ? "bi-pencil-square"
    : "bi-plus-circle"
} vm_bg_secondary text-white pt-1 pb-1 px-2 py-2`}></i>


                          </button>
                        </div>
                      )
                    },
                    { label: 'Game Name', value: customerById.game_name },
                    { label: 'Location', value: customerById.location_name },
                    { label: 'Game Package', 
                        value:  customerById.game_type_name ||
                        (customerById.package_name === 'Corporate' 
                          ? `${customerById.package_name} - ${customerById.corporate_package_name}`
                          : `${customerById.package_name} - ${customerById.game_package_name}`
                        )},
                        // value: customerById.game_type_name ? customerById.game_type_name : `${customerById.package_name} - ${customerById.game_package_name}` },
                    { label: 'Booked Date', value: (
                        <div className="d-flex align-items-center">
                            <i className="bi bi-calendar3 me-2 text-success" ></i>
                            <span>{moment(customerById.booked_date).format('D MMMM YYYY')}</span>
                        </div>
                    ) },
                    { label: 'Booked Time', value: (
                        <div className="d-flex align-items-center">
                            <i className="bi bi-clock-fill me-2 text-success" ></i>
                            <span>{customerById.booked_time_formatted}</span>
                           
                        </div>
                    ) },
                    {
                      label: 'Booked By',
                      value: (
                        <div className="d-flex align-items-center">
                          {
                            customerById.first_name || customerById.last_name
                              ? <span>{customerById.first_name} {customerById.last_name}</span>
                              : <span>Online</span>
                          }
                        </div>
                      )
                    },
                    
                    { label: 'Adult Count', value: customerById.no_of_adults },
                    { label: 'Kids Count', value: customerById.no_of_children },
                   
                    {  label: 'Consent Form Status',
                        value: (
                          filteredConsentFormDetails && 
                          filteredConsentFormDetails.length === customerById.no_of_adults &&
                          filteredKidsFormDetails && 
                          filteredKidsFormDetails.reduce((count, form) => count + form.children.length, 0) === customerById.no_of_children ? (
                            <p style={{ color: 'green' }}>Completed</p>
                          ) : (
                            <p style={{ color: 'red' }}>Incomplete</p>
                          )
                        ), },
                      
                    ...(customerById.package_name 
                        ? [
                          
                            { label: 'Birthday Kid Name', value: customerById.birthday_kid_name },
                            ...(customerById.package_name == 'Birthday' 
                                ? 
                                [
                                    {
                                    label: 'Food details',
                                    value: (
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                          <span>
                                            {customerById.food_details && Object.keys(JSON.parse(customerById.food_details || "{}")).length > 0
                                              ? Object.entries(JSON.parse(customerById.food_details)).map(([name, count]) => `${name} (${count})`).join(", ")
                                              : "No food details available"}
                                          </span>
                                          <button
                                            style={{ color: "white", backgroundColor: "transparent", border: "none", padding: "0", cursor: "pointer" }}
                                            onClick={handleEditFoodDetails}>
                                           <i className={`bi ${customerById.food_details &&
            Object.keys(JSON.parse(customerById.food_details)).length > 0
              ? "bi-pencil-square"
              : "bi-plus-circle"
          } vm_bg_secondary text-white pt-1 pb-1 px-2 py-2`}
        ></i>
                                          </button>
                                        </div>
                                      )
                              }, 
                        ]
                              
                                : []),
                              
                                ...(customerById.package_name == 'Birthday' 
                                    ? [{
                                        label: 'Drink details',
                                        value: (
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                              <span>
                                              {customerById.drink_details && Object.keys(JSON.parse(customerById.drink_details || "{}")).length > 0
                                               ? Object.entries(JSON.parse(customerById.drink_details || "{}"))
                                                  .map(([name, count]) => `${name} (${count})`)
                                                  .join(", ")
                                                  : "No drink details available"}
                                              </span>
                                              <button 
                                                style={{ color: "white", backgroundColor: "transparent", border: "none", padding: "0", cursor: "pointer" }}
                                                onClick={() => handleEditDrinkDetails()} // Function to edit food details
                                              >
                                                  <i className={`bi ${customerById.drink_details &&
            Object.keys(JSON.parse(customerById.drink_details)).length > 0
              ? "bi-pencil-square"
              : "bi-plus-circle"
          } vm_bg_secondary text-white pt-1 pb-1 px-2 py-2`}
        ></i>
                                               
                                              </button>
                                            </div>
                                          )
                                  }]
                                    : []),
                                  

                        ]
                        : []),

           

                ].map((detail, index) => (
                    <div className="d-flex border-bottom py-2" key={index}>
                        <div className="col-5 p-1 border-end vm_font_bold text-secondary">{detail.label}</div>
                        <div className="col-7 p-1 ps-3">{detail.value}</div>
                    </div>
                ))}
            </div>


          
</div>

<Modal show={showFoodModal} onHide={handleCloseFoodModal}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Food Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
<div class="row">

<div className="col-md-6">
    <div className="form-group">
      <label htmlFor="food_details">Food Details</label>
      {birthday_packages.food_quantity && (
        <div className="mb-1 text-muted" style={{ fontSize: '0.9em', marginTop: '-5px' }}>
          *Select {birthday_packages.food_quantity} food options.
        </div>
      )}
      <div className="px-2 py-2 bg-white mt-1 ">
        {foodOptions.map((food, index) => (
          <div
            className="d-flex align-items-center justify-content-between py-1"
            key={index}
           
          >
            <label style={{ marginTop: '5px' }}>{food}</label>
            <div className="d-flex align-items-center">
              <button
                type="button"
                className="btn btn-outline-secondary"
                style={{
                  width: '25px',
                  height: '25px',
                  padding: '0',
                  fontSize: '1.0em',
                   fontWeight: 'bold'
                }}
                onClick={() => handleDecrement(food)}
                disabled={(selectedFoods?.[food] || 0) <= 0}
              >
                -
              </button>
       
              <span className="mx-2" >{selectedFoods?.[food] || 0}</span>
              <button
                type="button"
                className="btn btn-outline-secondary"
                style={{
                  width: '25px',
                  height: '25px',
                  padding: '0',
                  fontSize: '1.0em',
                  fontWeight: 'bold'
                }}
                onClick={() => handleIncrement(food)}
                disabled={getTotalSelectedFoods() >= birthday_packages.food_quantity
                  
                }
              >
                + 
              </button>
            </div>
          </div>
        ))}
          {/* <span class="text-danger">{foodErrorList}</span> */}
        <span className="text-danger" >{bookingErrorList.food_details}</span>
      </div>
    </div>
  </div>
       
                      
                        </div>
        </Modal.Body>
        <Modal.Footer>
         
          <button class="btn btn-sm btn_secondary" onClick={saveFoodDetails}>
           {foodLoading? 'Updating..':'Update'} 
          </button>
        </Modal.Footer>
      </Modal>


      <Modal show={showDrinkModal} onHide={handleCloseDrinkModal}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Drink Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
<div class="row">

<div className="col-md-6">
    <div className="form-group">
      <label htmlFor="food_details">Drink Details</label>
      {birthday_packages.drink_quantity && (
        <div className="mb-1 text-muted" style={{ fontSize: '0.9em', marginTop: '-5px' }}>
          *Select {birthday_packages.drink_quantity} food options.
        </div>
      )}
      <div className="px-2 py-2 bg-white mt-1 ">
        {drinkOptions.map((drink, index) => (
          <div
            className="d-flex align-items-center justify-content-between py-1"
            key={index}
           
          >
            <label style={{ marginTop: '5px' }}>{drink}</label>
            <div className="d-flex align-items-center">
              <button
                type="button"
                className="btn btn-outline-secondary"
                style={{
                  width: '25px',
                  height: '25px',
                  padding: '0',
                  fontSize: '1.0em',
                   fontWeight: 'bold'
                }}
                onClick={() => handleDecrementDrink(drink)}
                disabled={(selectedDrinks?.[drink] || 0) <= 0}
              >
                -
              </button>
              <span className="mx-2" >{selectedDrinks?.[drink] || 0}</span>
              <button
                type="button"
                className="btn btn-outline-secondary"
                style={{
                  width: '25px',
                  height: '25px',
                  padding: '0',
                  fontSize: '1.0em',
                  fontWeight: 'bold'
                }}
                onClick={() => handleIncrementDrink(drink)}
                disabled={getTotalSelectedDrinks() >= birthday_packages.drink_quantity}
              >
                + 
              </button>
            </div>
          </div>
        ))}
          {/* <span class="text-danger">{foodErrorList}</span> */}
        <span className="text-danger" >{bookingErrorList.drink_details}</span>
      </div>
    </div>
  </div>
       




                      
                        </div>
        </Modal.Body>
        <Modal.Footer>
         
          <button class="btn btn-sm btn_secondary" onClick={saveDrinkDetails}>
           {drinkLoading? 'Updating..':'Update'} 
          </button>
        </Modal.Footer>
      </Modal>


      <Modal show={showStaffModal} onHide={handleCloseStaffModal}>
  <Modal.Header closeButton>
    <Modal.Title>Schedule Staff</Modal.Title>
  </Modal.Header>
  <Modal.Body>
  <div className="col-md-12">
  <label>Select staff members:</label>
  <div class="px-3 mb-1 bg-light mt-1 pb-3 pt-3">
  <div className="row">
    {team
      .filter(
        (staff) =>
          staff.user_role === "Coordinator" &&
          staff.location_id
            ?.split(",")
            .map((id) => id.trim())
            .includes(String(customerById.location_id))
      )
      .map((staff) => (
        <div className="col-md-6 pb-2" key={staff.id}>
          <div className="form-group-checkbox d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <input
                type="checkbox"
                id={`staff-${staff.id}`}
                value={staff.id}
                onChange={(e) => {
                  const value = e.target.value;
                  if (e.target.checked) {
                    setSelectedStaff((prev) => [...prev, value]);
                  } else {
                    setSelectedStaff((prev) => prev.filter((id) => id !== value));
                  }
                }}
                checked={selectedStaff.includes(String(staff.id))}
                style={{ boxShadow: "2px 2px #059618", transition: "all .5s ease" }}
              />
              <label htmlFor={`staff-${staff.id}`} >
                {staff.first_name} {staff.last_name}
              </label>
            </div>
          </div>
        </div>
      ))}
  </div>
  </div>
</div>

  </Modal.Body>
  <Modal.Footer>
    <button class="btn btn-sm btn_secondary"  onClick={saveStaff}>  {staffLoading? 'Saving..':'Save'} </button>
  </Modal.Footer>
</Modal>




<Modal show={showPaymentModal} onHide={handleClosePaymentModal}>
        <Modal.Header closeButton>
          <Modal.Title>Make a Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
<div class="row">

<div className="col-md-6">
  <div className="form-group">
    <label htmlFor="payment_date">Date</label>
    <input
      type="date"
      className="form-control"
      name="payment_date"
      id="payment_date"
      value={payment_date}
      onChange={handlePaymentDateChange}
    />
  </div>
</div>

       
<div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="payment_amount">Payment Amount</label>
                                <input
                                    type="number" className="form-control" name="payment_amount" id="payment_amount" value={payment_amount}
                                    onChange={handlePaymentAmountChange} min="0" 
                                />
                                <span className="text-danger">{paymentErrorList.payment_amount}</span>
                            </div>
                        </div>

        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="payment_method">Payment Method</label>
                                <select  class="form-select" id="payment_method" name="payment_method" value={payment_method} 
                                 onChange={handlePaymentMethodChange }>
         <option value="">Select Payment Method</option>
              <option value="Cash">Cash</option>
              <option value="Credit">Credit </option>
              <option value="Debit">Debit </option>
              <option value="E-transfer">E-transfer</option>
         
        </select>
                                <span className="text-danger">{paymentErrorList.payment_method}</span>
                            </div>
                        </div>
                        <div className="col-md-8 form-group">
        <div className="form-group-checkbox d-flex align-items-center justify-content-between">
            <div  className="d-flex align-items-center">
                <input
                    type="checkbox"
                    id="sendPaymentNotificationCheckbox"
                    defaultChecked={true}
                    style={{
                        height:'15px', width:'15px',
                        border:' solid' ,
                        boxShadow: "2px 2px #059618", transition: "all .5s ease"// Optional: Add cursor pointer for better UX
                    }}
                    required
                />
                <label  htmlFor="consent" style={{ marginTop: '10px' }}>
                Send email notification
                </label>
            </div>

            </div>
        </div>
                      
                        </div>
        </Modal.Body>
        <Modal.Footer>
         
          <button class="btn btn-sm btn_secondary" onClick={savePayments}>
           {paymentLoading? 'Processing...':'Confirm Payment'} 
          </button>
        </Modal.Footer>
      </Modal>


</div>






</div>

            
        </div>
    </div>



    <div class="d-flex mt-2 pt-2 px-3 ">
        <div className="vm_content_box_1 mt-2 ">
      
        <div class="title">
            <h2>Payment Details</h2>
        </div>
<div className="content py-0 bg-white px-3 mb-3 w-100" >
            
          

<div className="row">
<div className="col-md-12">
<div className="row border-top pb-3">
{[
  ...(customerById.package_name === 'Birthday' || customerById.package_name === 'Corporate' 
    ? [
        ...(customerById.package_price ? [{ label: 'Package Price', value: customerById.package_price }] : []),
        ...(customerById.extra_player_price ? [{ label: 'Extra Player Price', 
          value: (() => {
            let cartDetails = customerById.cart_details;
        
            // Parse if string
            if (typeof cartDetails === 'string') {
              try {
                cartDetails = JSON.parse(cartDetails);
              } catch {
                cartDetails = {};
              }
            }
        
            const extra = cartDetails?.extra_player_price;
        
            if (!extra) return <div>${customerById.extra_player_price}</div>;
        
            const players = extra.total_players || 0;
            const games = extra.no_games || 0;
            const price = parseFloat(extra.price_for_slot || 0).toFixed(2);
        
            return (
              <div>
                ${customerById.extra_player_price} {" ("}
                {players} Player{players !== 1 ? 's' : ''} X {games} Game{games !== 1 ? 's' : ''} X ${price}
                {")"}
              </div>
            );
          })()
        }] : []),
        ...(customerById.extra_game_price ? [{ label: 'Extra Game Price', 
          value: (
            <div>
              ${customerById.extra_game_price} {" ("}
              {(() => {
                let cartDetails = customerById.cart_details;
        
                // Safely parse if it's a string
                if (typeof cartDetails === 'string') {
                  try {
                    cartDetails = JSON.parse(cartDetails);
                  } catch {
                    cartDetails = {};
                  }
                }
        
                const slots = Object.values(cartDetails || {}).filter(slot => Number(slot.extra_game) > 0);
        
                const aggregated = slots.reduce((acc, slot) => {
                  const totalPlayers = parseInt(slot.total_players, 10) || 0;
                  const noGames = parseInt(slot.no_games, 10) || 0;
                  const pricePerSlot = parseFloat(slot.price_for_slot) || 0;
        
                  acc.totalPlayers = totalPlayers; // If all rows share same players, otherwise use +=
                  acc.totalGames += noGames;
                  acc.pricePerSlot = pricePerSlot; // If prices differ, consider adjusting this logic
        
                  return acc;
                }, { totalPlayers: 0, totalGames: 0, pricePerSlot: 0 });
        
                if (aggregated.totalGames === 0 || aggregated.pricePerSlot === 0) return null;
        
                return (
                  <span>
                    {aggregated.totalPlayers} Player{aggregated.totalPlayers !== 1 ? "s" : ""} X {aggregated.totalGames} Game{aggregated.totalGames !== 1 ? "s" : ""} X ${aggregated.pricePerSlot.toFixed(2)}
                  </span>
                );
              })()}
              {")"}
            </div>
          )
        }] : [])
      ]
    : []),
// { label: 'Hst', value: customerById.hst && customerById.hst },
{ label: 'Sub Total', value: customerById.subtotal ? customerById.subtotal.toFixed(2) : '0.00'},
{ label: 'Adjusted Amount', value:  adjustmentHistory
  .reduce((acc, item) => acc + (item.adjusted_amount ? parseFloat(item.adjusted_amount) : 0), 0)
  .toFixed(2)},

  ...(customerById.discount_amount > 0
    ? [{ label: 'Discount Amount', value: '-' + customerById.discount_amount.toFixed(2) }] 
    : []),

    ...(customerById.promo_amount > 0
    ? [{ label: 'Promo Code Amount', value: '-' + customerById.promo_amount.toFixed(2) }]
    : []),
 {
  label: 'Total (before HST)',
  value: (
    (customerById.subtotal ? parseFloat(customerById.subtotal) : 0) +
    adjustmentHistory.reduce((acc, item) => acc + (item.adjusted_amount ? parseFloat(item.adjusted_amount) : 0), 0) -
    (customerById.discount_amount ? parseFloat(customerById.discount_amount) : 0) -
    (customerById.promo_amount ? parseFloat(customerById.promo_amount) : 0)
  ).toFixed(2)
},

{ label: 'Total Amount (incl. HST)', value: customerById.grand_total ? customerById.grand_total.toFixed(2) : '0.00'},

// { label: 'Adjusted Total', value: customerById.adjusted_total ? customerById.adjusted_total.toFixed(2): '0.00'},
{
    label: 'Amount Paid',
    value: paymentHistory.reduce((total, payment) => total + parseFloat(payment.payment_amount), 0).toFixed(2)
},
{
  
  label: 'Balance Amount',
  value: (
    <div className="d-flex justify-content-between align-items-center">
      <span>
        {(
          (customerById.grand_total)- 
          paymentHistory.reduce((total, payment) => total + parseFloat(payment.payment_amount || 0), 0)
        ).toFixed(2)}
      </span>
      <button className="btn btn-sm btn_secondary" onClick={handleShowPaymentModal}>
        Pay
      </button>
    </div>
  ),
},


  {
    label: 'Payment History',
    value: (
        <div className="mt-0">
            {paymentHistory.filter(payment => payment.payment_amount > 0).length > 0 ? (
                 <div class="table-responsive">
                <table class="display dataTable dtr-inline" style={{ width: "100%" }}>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Amount</th>
                            <th>Method</th>
                            <th>Mode</th>
                            <th>Action</th>
                  
                        </tr>
                    </thead>
                    <tbody>
                            {paymentHistory
                            .filter(payment => payment.payment_amount > 0) 
                            .map((payment, index) => (
                                <tr key={index}>
                                <td >{moment(payment.payment_date ?? payment.created_at).format('DD-MMM-YY')}</td>
                                    <td>${payment.payment_amount}</td>
                                    <td>{payment.payment_method}</td>
                                    <td>{payment.payment_mode.toLowerCase()}</td>
                                   
                                    {payment.payment_mode.toLowerCase() === 'online' ? (
                          <>      
                                <button
                                className="btn btn-sm btn-warning"
                                style={{ fontSize: '0.75rem', margin: "5px 0px 0px 10px" }}
                                onClick={(e) => refundPayment(e, payment.transaction_id)}
                                title="Refund" 
                              >
                                <i className="bi bi-arrow-counterclockwise"></i> 
                              </button>


 </>                           

                            ) : (
                                <button  className="btn btn-sm btn-danger" title="Delete" style={{  fontSize: '0.75rem', margin: "5px 0px 0px 10px" }}
                                  onClick={(e) => deletePayment(e, payment.id)}><i class="bi bi-trash3"></i> </button>
                               
                                )}
                                  </tr>
                        ))}
                    </tbody>
                </table>
                </div>
            ) : (
                <p>No payments made yet.</p>
            )}
        </div>
    ),
},


// {
//     label: 'Transaction History',
//     value: (
//         <div className="mt-0">
//             {transactions.length > 0 ? (
//                  <div class="table-responsive">
//                 <table class="display dataTable dtr-inline" style={{ width: "100%", overflowY: 'auto' }}>
//                     <thead>
//                         <tr>
//                             <th>Date</th>
//                             <th>TXID</th>
//                             <th>Card </th>
//                             <th>Amount</th>
//                             <th>Status</th>
                  
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {transactions.map((item, index) => (
//                             <tr key={index}>
//                                 <td style={{width:'80px'}}><p>{moment(item.tran_date).format('D MMM YYYY')}</p><p> {moment(item.tran_time, 'HH:mm:ss').format('h:mm:ss A')}</p></td>
//                                 <td>{item.transaction_id}</td>
//                                 <td>{item.tran_card_type} Ending with {item.card_last_four} </td>
//                                 <td>${item.tran_amount.toFixed(2)}</td>
//                                 <td>{item.message_text}</td>
                               
                               
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//                 </div>
//             ) : (
//                 <p>No online transactions made yet.</p>
//             )}
//         </div>
//     ),
// },


{
  label: 'Refund History',
  value: (
      <div className="mt-0">
          {paymentDeleteHistory.filter(item => item.payment_mode === 'ONLINE' && item.is_refund === 1).length > 0 ? (
               <div class="table-responsive">
              <table class="display dataTable dtr-inline" style={{ width: "100%", overflowY: 'auto' }}>
                  <thead>
                      <tr>
                          <th>Date</th>
                          <th>TXID</th>
                          <th>Card </th>
                          <th>Amount</th>
                
                      </tr>
                  </thead>
                  <tbody>
                  {paymentDeleteHistory
                .filter(item => item.payment_mode === 'ONLINE'  && item.is_refund === 1)
                .map((item, index) => (
                          <tr key={index}>
                              <td style={{width:'80px'}}><p> {moment(item.payment_date ?? item.created_at).format('DD-MMM-YY')}</p></td>
                              <td>{item.transaction_id}</td>
                              <td>{item.payment_method} </td>
                              <td>${item.payment_amount}</td>
                             
                          </tr>
                      ))}
                  </tbody>
              </table>
              </div>
          ) : (
            <p>No refunds processed yet.</p>
          )}
      </div>
  ),
},

{
  label: 'Adjustment History',
  value: (
      <div className="mt-0">
         <div className="d-flex justify-content-end align-items-end">
          <button className="btn btn-sm btn_secondary" onClick={handleShowAdjustmentModal}>
          <i className="bi bi-plus-circle vm_bg_secondary text-white"></i>
        </button>
        </div>
          {adjustmentHistory.length > 0 ? (
               <div class="table-responsive">
              <table class="display dataTable dtr-inline" style={{ width: "100%" }}>
                  <thead>
                      <tr>
                          <th>Date</th>
                          <th>Amount</th>
                          <th>Reason</th>
                          <th>Note</th>
                          <th>Action</th>
                
                      </tr>
                  </thead>
                  <tbody>
                          {adjustmentHistory
                          .map((item, index) => (
                              <tr key={index}>
                              <td >{moment(item.adjusted_date).format('DD-MMM-YY')}</td>
                              <td>
  {item.adjusted_amount != null
    ? (item.adjusted_amount < 0
        ? `-$${Math.abs(item.adjusted_amount).toFixed(2)}`
        : `$${item.adjusted_amount.toFixed(2)}`)
    : 'N/A'}
</td>

                                  <td>{item.adjusted_reason || 'N/A'}</td>
                                  <td>{item.adjusted_note || 'N/A'}</td>

                                 
                            
                              <button  className="btn btn-sm btn-danger" title="Delete" style={{  fontSize: '0.75rem', margin: "5px 0px 0px 10px" }}
                                onClick={(e) => deleteAdjustment(e, item.id)}><i class="bi bi-trash3"></i> </button>
                             
                              
                                </tr>
                      ))}
                  </tbody>
              </table>
              </div>
          ) : (
            <div className="d-flex justify-content-between align-items-center" style={{marginTop: '-30px'}}>
              <p>No adjustments made yet.</p>
            
            </div>
          )}
          
      </div>



  ),
},
  ...(customerById.discount_details && customerById.discount_details.length > 0 ?
[{
  label: 'Discount History',
  value: (
      <div className="mt-0">
          {customerById.discount_details && customerById.discount_details.length > 0 ? (
               <div class="table-responsive">
              <table class="display dataTable dtr-inline" style={{ width: "100%", overflowY: 'auto' }}>
                  <thead>
                      <tr>
                          <th>Description</th>
                          <th>Type</th>
                          <th>Value </th>
                          <th>Amount</th>
                
                      </tr>
                  </thead>
                  <tbody>
                  {/* {customerById.discount_details && customerById.discount_details
                .map((item, index) => ( */}
                  {Array.isArray(customerById.discount_details) && customerById.discount_details.map((item, index) => (
                          <tr key={index}>
                              <td>{item.description || 'Discount'}</td>
                              <td>{item.type}</td>
                              <td>{item.value} </td>
                              <td>${item.amount}</td>
                             
                          </tr>
                      ))}
                  </tbody>
              </table>
              </div>
          ) : (
            <p>No discounts processed yet.</p>
          )}
      </div>
  ),
}] :[]),

 ...(customerById.promo_details && customerById.promo_details.length > 0 ?
[{
  label: 'Promo code History',
  value: (
      <div className="mt-0">
          {customerById.promo_details && customerById.promo_details.length > 0 ? (
               <div class="table-responsive">
              <table class="display dataTable dtr-inline" style={{ width: "100%", overflowY: 'auto' }}>
                  <thead>
                      <tr>
                          <th>Promo code</th>
                          <th>Type</th>
                          <th>Value </th>
                          <th>Amount</th>
                
                      </tr>
                  </thead>
                  <tbody>
                  {/* {customerById.promo_details && customerById.promo_details
                .map((item, index) => ( */}
                    {Array.isArray(customerById.promo_details) && customerById.promo_details.map((item, index) => (
                          <tr key={index}>
                              <td>{item.code_name || 'Promo code'}</td>
                              <td>{item.type}</td>
                              <td>{item.value} </td>
                              <td>${item.amount}</td>
                             
                          </tr>
                      ))}
                  </tbody>
              </table>
              </div>
          ) : (
            <p>No promo codes processed yet.</p>
          )}
      </div>
      ),
 }] :[]),



].map((detail, index) => (
    <div className="d-flex border-bottom py-2" key={index}>
        <div className="col-5 p-1 border-end vm_font_bold text-secondary">{detail.label}</div>
        <div className="col-7 p-1 ps-3">{detail.value}</div>
    </div>
))}



           


</div>
</div>
</div>

</div>
</div>
</div>

<div className="mt-2 pt-2 px-3 pb-3">
  <div className="vm_content_box_1 mt-2">
    <div className="title">
      <h2>Generate Custom Payment Link</h2>
      </div>
      <div className="content py-0 mt-3 bg-white px-3 mb-3 w-100" >

            <div className="row">
            <div className="col-md-12">
            <div className="row  pb-3">
        {/* Total Due */}
        <div className="form-group row mb-1">
          <div className="col-md-4 d-flex align-items-center">
            <label className="form-label mb-0">Total Due</label>
          </div>
          <div className="col-md-8">
            <input
              type="text"
              className="form-control"
             // value={`${customerById.grand_total ? customerById.grand_total.toFixed(2) : '0.00'}`}
             value={`${(
              (customerById.grand_total) - 
              paymentHistory.reduce((sum, p) => sum + Number(p.payment_amount), 0)
            ).toFixed(2)}`}
            
              readOnly
            />
          </div>
        </div>
        
        {/* Generate Payment Link */}
        <div className="form-group row mb-1">
          <div className="col-md-4 d-flex align-items-center">
            <label className="form-label mb-0">Payment Amount Requested</label>
          </div>
          <div className="col-md-8">
            <input
              type="number"
              className="form-control"
             value={generatePaymentAmount} 
              onChange={(e) => setGeneratePaymentAmount(e.target.value)}
            />
          </div>
        </div>

        {/* Reason */}
        <div className="form-group row mb-1">
          <div className="col-md-4 d-flex align-items-center">
            <label className="form-label mb-0">Reason</label>
          </div>
          <div className="col-md-8">
            <input
              type="text"
              className="form-control"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>
        </div>

        {/* Note */}
        <div className="form-group row mb-1">
          <div className="col-md-4 d-flex align-items-center">
            <label className="form-label mb-0">Note</label>
          </div>
          <div className="col-md-8">
            <textarea
            row={5}
              className="form-control"
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </div>
        </div>

         <div class="d-flex justify-content-end pt-3 ">
        <button
        className="btn btn-sm btn_secondary text-white"
        onClick={handlePaymentEmailDialogOpen}
     >
     Send by email
      </button>
</div>



        </div>
        </div>
       

      </div>
    </div>
  </div>
</div>



{/* 
<div className="px-3 pb-3">
  <div className="vm_content_box_1 mt-2">
    <div className="title">
      <h2>Adjustment</h2>
      </div>
      <div className="content py-0 mt-3 bg-white px-3 mb-3 w-100" >

            <div className="row">
            <div className="col-md-12">
            <div className="row  pb-3">
     
        <div className="form-group row mb-1">
          <div className="col-md-4 d-flex align-items-center">
            <label className="form-label mb-0">Date</label>
          </div>
          <div className="col-md-8">
          <input
      type="date"
      className="form-control"
      name="adjustedDate"
      id="adjustedDate"
      value={adjustedDate}
      onChange={(e) => setAdjustedDate(e.target.value)}
    />
           
          </div>
        </div>
        
 
        <div className="form-group row mb-1">
          <div className="col-md-4 d-flex align-items-center">
            <label className="form-label mb-0">Amount</label>
          </div>
          <div className="col-md-8">
            <input
              type="number"
              className="form-control"
             value={adjustedAmount} 
              onChange={(e) => setAdjustedAmount(e.target.value)}
            />
          </div>
        </div>


        <div className="form-group row mb-1">
          <div className="col-md-4 d-flex align-items-center">
            <label className="form-label mb-0">Reason</label>
          </div>
          <div className="col-md-8">
            <input
              type="text"
              className="form-control"
              value={adjustedReason}
              onChange={(e) => setAdjustedReason(e.target.value)}
            />
          </div>
        </div>

    
        <div className="form-group row mb-1">
          <div className="col-md-4 d-flex align-items-center">
            <label className="form-label mb-0">Note</label>
          </div>
          <div className="col-md-8">
            <textarea
            row={5}
              className="form-control"
              value={adjustedNote}
              onChange={(e) => setAdjustedNote(e.target.value)}
            />
          </div>
        </div>

         <div class="d-flex justify-content-end pt-3 ">
        <button
        className="btn btn-sm btn_secondary text-white"
        onClick={handleSaveAdjustment}
     >
   Save
      </button>
</div>



        </div>
        </div>
       

      </div>
    </div>
  </div>
</div> */}


            <div class=" px-3 pb-3 ">
            <div class="vm_content_box_1 mt-2">
        <div class="title">
            <h2>Consent Form Details</h2>
           
                       <a
         href={`/consent-form-page/${customerById.booking_ref_id}/${customerById.booking_id}`}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-sm btn_secondary"
        style={{ color: 'white', textDecoration: 'none' }}
    >
        Fill Out Consent Forms
    </a>
                      
                                    
                
            </div>


            <div className="d-flex justify-content-between align-items-center position-relative">
           <div style={{padding:'20px'}}>
       
           </div>
          
            <div className="status-container">
            <span className="status-text">Adults: {filteredConsentFormDetails && filteredConsentFormDetails.length}/{customerById.no_of_adults}</span>
            </div>

   
  </div>
        <div class="content">
                            <>
                            <div class="table-responsive"> 
                            <table class="display dataTable dtr-inline" style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                           <th>S.No</th>
                                            <th>Name</th>
                                            <th>DOB</th>
                                            <th>Photo/Video</th>
                                            <th>Submitted on</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>


                                    <tbody>
                                   

{filteredConsentFormDetails && filteredConsentFormDetails.length === 0 ? (
        <tr>
          <td colSpan="4" style={{ textAlign: "center", verticalAlign: "middle" }}>
            <p className="odd" style={{ margin: 0 }}>No records found</p>
          </td>
        </tr>
      ) : (

                                        filteredConsentFormDetails && filteredConsentFormDetails.slice((currentPage * perPage), ((currentPage * perPage) + perPage)).map((item, index) => (
                                            <tr key={index}>
                                      <td>{(currentPage * perPage) + index + 1}</td>
                                                <td><p>{item.name}</p> </td>
                                                <td><p> {moment(item.dob).format('D MMMM YYYY')}</p> </td>
          <td>
  {item.photoconsent === "true" || item.photoconsent === true ? (
    <i
      className="bi bi-check-circle-fill text-success"
      style={{ fontSize: '1.0rem', color: '#28a745' }}
    />
  ) : (
    <i
      className="bi bi-x-circle-fill text-danger"
      style={{ fontSize: '1.0rem', color: '#dc3545' }}
    />
  )}
</td>


                                                <td><p> {moment(item.created_at).format('MMM D, YYYY, h:mm A')}</p> </td>
                                                <td>

{/* <button class="btn btn-sm btn_secondary"   style={{ background: "orange", color: "white"}}
                          onClick={(e) => handleConsentOpen(item, index)}  ><i class="bi bi-eye"></i>  {pdfConsentLoading[index] ? <span className="spinner-border spinner-border-sm ms-2" /> : null}</button> */}
{item.file_path && (
 <button
  className="btn btn-sm btn_secondary"
  style={{ background: "orange", color: "white" }}
  onClick={(e) => {
    e.preventDefault();
    // Construct full URL to the stored PDF file
    const fileUrl = `${LARAVEL_API_URL}/${item.file_path}`;
    window.open(fileUrl, '_blank');
  }}
>
  <i className="bi bi-eye"></i>{" "}
  {pdfConsentLoading[index] ? <span className="spinner-border spinner-border-sm ms-2" /> : null}
</button>
)}
<button class="btn btn-sm btn_secondary" style={{ background: "red", color: "white", margin: "0px 0px 0px 10px" }}
                          onClick={(e) => deleteAdultConsent(e, item)}  ><i class="bi bi-trash3"></i> </button>
</td>
                                           
                                            </tr>


                                        )))}
                                    </tbody>
                                    <tfoot style={{ borderTop: "1px solid #dee2e6", height: "1px" }}>
    <tr>
        <td colSpan="16" style={{ padding: 0, margin: 0, height: "1px" }}></td>
    </tr>
    </tfoot>
                                  
                                </table>
                               </div>
                                    </>
                      

        </div>
       
       
        <div className="d-flex justify-content-between align-items-center position-relative">
           <div style={{padding:'20px'}}>
       
           </div>
        <div className="status-container">
    <span className="status-text">Kids: {filteredKidsFormDetails && filteredKidsFormDetails.reduce((count, form) => count + form.children.length,0)}/{customerById.no_of_children}</span>
  </div>

  </div>
        <div class="content">
                            <>
                            <div class="table-responsive"> 
                            <table class="display dataTable dtr-inline" style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                         
                                            {/* <th>Guardian Name</th> */}
                                            <th>Guardian Name</th>
                                            <th>Child details</th>
                                            <th>Photo/Video</th>
                                            <th>Submitted on</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>


                                    <tbody>
                         

{filteredKidsFormDetails && filteredKidsFormDetails.length === 0 ?(
        <tr>
          <td colSpan="4" style={{ textAlign: "center", verticalAlign: "middle" }}>
            <p className="odd" style={{ margin: 0 }}>No records found</p>
          </td>
        </tr>
      ) : (

                                        filteredKidsFormDetails && filteredKidsFormDetails.slice((currentPage * perPage), ((currentPage * perPage) + perPage)).map((item, index) => (
                                            <tr key={index}>
                                              
                                                <td>{item.guardian_name} </td>
                                                <td>
              {item.children.map((child, idx) => (
                <div key={idx} style={{ marginBottom: "8px" }}>
                  <strong>Name:</strong> {child.name}
                  <br />
                  <strong>DOB:</strong> {moment(child.dob).format('D MMMM YYYY')}
                </div>
              ))}
            </td>
   <td>
  {item.photoconsent === "true" || item.photoconsent === true ? (
    <i
      className="bi bi-check-circle-fill text-success"
      style={{ fontSize: '1.0rem', color: '#28a745' }}
    />
  ) : (
    <i
      className="bi bi-x-circle-fill text-danger"
      style={{ fontSize: '1.0rem', color: '#dc3545' }}
    />
  )}
</td>
            <td><p> {moment(item.created_at).format('MMM D, YYYY, h:mm A')}</p> </td>
            <td >
{item.file_path && (
 <button
  className="btn btn-sm btn_secondary"
  style={{ background: "orange", color: "white" }}
  onClick={(e) => {
    e.preventDefault();
    // Construct full URL to the stored PDF file
    const fileUrl = `${LARAVEL_API_URL}/${item.file_path}`;
    window.open(fileUrl, '_blank');
  }}
>
  <i className="bi bi-eye"></i>{" "}
  {pdfConsentLoading[index] ? <span className="spinner-border spinner-border-sm ms-2" /> : null}
</button>
)}
<button class="btn btn-sm btn_secondary" style={{ background: "red", color: "white", margin: "0px 0px 0px 10px" }}
                          onClick={(e) => deleteKidConsent(e, item)}  ><i class="bi bi-trash3"></i> </button>
</td>
                                            </tr>


                                        )))}
                                    </tbody>
                                    <tfoot style={{ borderTop: "1px solid #dee2e6", height: "1px" }}>
    <tr>
        <td colSpan="16" style={{ padding: 0, margin: 0, height: "1px" }}></td>
    </tr>
</tfoot>
                               
                                </table>
                                </div>
                                    </>
                      

        </div>
      
      












{/* 
            <ul className="nav nav-tabs" id="messageTabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button className={`nav-link ${activeTab === 'adults' ? 'active' : ''}`} id="adults-tab" data-bs-toggle="tab" data-bs-target="#adults" type="button" role="tab" aria-controls="adults"  aria-selected={activeTab === 'adults' ? 'true' : 'false'} onClick={() => setActiveTab('adults')}>Adults</button>
          </li>
            
            
          <li className="nav-item" role="presentation">
            <button className={`nav-link ${activeTab === 'kids' ? 'active' : ''}`} id="kids-tab" data-bs-toggle="tab" data-bs-target="#kids" type="button" role="tab" aria-controls="kids"   aria-selected={activeTab === 'kids' ? 'true' : 'false'} onClick={() => setActiveTab('kids')}>Kids</button>
          </li>
            
        </ul>

        <div className="tab-content" id="messageTabsContent">
        <div className={`tab-pane fade ${activeTab === 'adults' ? 'show active' : ''}`} id="adults" role="tabpanel" aria-labelledby="adults-tab"> 
        <div className="status-container">
    <span className="status-text">Adults: {filteredConsentFormDetails && filteredConsentFormDetails.length}/{customerById.no_of_adults}</span>
  </div>
        <div class="content">
            
        <div class="row pt-3">
        
                          <div class="col-md-9 form-group" >
                                  <div class="d-flex input_wrapper">
                                  <div ><label>Show   <select name="example_length" aria-controls="example" value={perPage} onChange={(e) => {setCurrentPage(0);setPerPage(Number(e.target.value))}}>
                                      <option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option>
                                    </select>  entries</label>
                                    </div>
                              
                   
                                  </div>
                              </div>
  
                              <div class="col-md-3 form-group">
                                  <div class="d-flex input_wrapper">
                                      <div class="icon_wrapper">
                                          <i class="bi bi-search icon"></i>
                                      </div>
                                      <input class="form-control" name="searchQuery" id="searchQuery" placeholder="Search" type="text" 
                                      value={searchQuery} onChange={(e) => {setSearchQuery(e.target.value)}}/>
                                  </div>
                              </div>
                          </div>

                          
                            <><table class="display dataTable dtr-inline" style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                           <th>S.No</th>
                                            <th>Name</th>
                                            <th>DOB</th>
                                            <th>Submitted on</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>


                                    <tbody>
                                    {filteredConsentFormDetails && filteredConsentFormDetails.length === 0 ?
        <table class="display dataTable dtr-inline">
        <tbody>
          <tr>
            <div class="row" style={{margin: "10px -500px 10px 10px"}}>
                       <p  valign="top" class="odd" style={{ textAlign: "center" }} >No records found</p> 
                       </div>
          </tr>
        </tbody>
      </table>
      :    null }

                                        {filteredConsentFormDetails && filteredConsentFormDetails.slice((currentPage * perPage), ((currentPage * perPage) + perPage)).map((item, index) => (
                                            <tr key={index}>
                                      <td>{(currentPage * perPage) + index + 1}</td>
                                                <td><p>{item.name}</p> </td>
                                                <td><p> {moment(item.dob).format('D MMMM YYYY')}</p> </td>
                                                <td><p> {moment(item.created_at).format('MMM D, YYYY, h:mm A')}</p> </td>
                                                <td>


<button class="btn btn-sm btn_secondary" style={{ background: "red", color: "white", margin: "0px 0px 0px 10px" }}
                          onClick={(e) => deleteAdultConsent(e, item)}  ><i class="bi bi-trash3"></i> </button>
</td>
                                           
                                            </tr>


                                        ))}
                                    </tbody>
                                    <tfoot style={{ borderTop: "1px solid #dee2e6", height: "1px" }}>
    <tr>
        <td colSpan="16" style={{ padding: 0, margin: 0, height: "1px" }}></td>
    </tr>
    </tfoot>
                                
                                </table>
                                <div class="col-md-4" style={{ float: "left", padding: "20px 0px 0px 0px" }}>
                                {filteredConsentFormDetails && filteredConsentFormDetails.length > 0 && `Showing 1 to ${Math.min(perPage, filteredConsentFormDetails.length)} of ${filteredConsentFormDetails.length} entries`}
                                    </div><div class="col-md-8" style={{ float: "right" }}>

                                        <ReactPaginate style={{ float: "right" }}
                                            previousLabel={"< Prev"}
                                            nextLabel={"Next >"}
                                            breakLabel={'...'}
                                            pageCount={Math.ceil(filteredConsentFormDetails && filteredConsentFormDetails.length / perPage)}
                                            onPageChange={handlePageChange}
                                            containerClassName={"pagination pagination-sm justify-content-center custom-pagination"} // Bootstrap pagination class
                                            disabledClassName={"disabled"}
                                            breakClassName={['page-item']}
                                            breakLinkClassName={'page-link'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item'}
                                            nextLinkClassName={'page-link'}
                                            activeClassName={['active']} />


                                    </div>
                                    </>
                      

        </div>
        </div>
        </div> */}

        {/* <div className="tab-content" id="messageTabsContent">
        <div className={`tab-pane fade ${activeTab === 'kids' ? 'show active' : ''}`} id="kids" role="tabpanel" aria-labelledby="kids-tab">
        <div className="status-container">
    <span className="status-text">Kids: {filteredKidsFormDetails && filteredKidsFormDetails.reduce((count, form) => count + form.children.length,0)}/{customerById.no_of_children}</span>
  </div>
        <div class="content">
        <div class="row pt-3">
                          
                          <div class="col-md-9 form-group" >
                                  <div class="d-flex input_wrapper">
                                  <div ><label>Show   <select name="example_length" aria-controls="example" value={perPage} onChange={(e) => {setCurrentPage(0);setPerPage(Number(e.target.value))}}>
                                      <option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option>
                                    </select>  entries</label>
                                    </div>
                              
                   
                                  </div>
                              </div>
  
                              <div class="col-md-3 form-group">
                                  <div class="d-flex input_wrapper">
                                      <div class="icon_wrapper">
                                          <i class="bi bi-search icon"></i>
                                      </div>
                                      <input class="form-control" name="searchQuery" id="searchQuery" placeholder="Search" type="text" 
                                      value={searchQuery} onChange={(e) => {setSearchQuery(e.target.value)}}/>
                                  </div>
                              </div>
                          </div>

                         
                            <><table class="display dataTable dtr-inline" style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                         
                                           
                                            <th>Guardian Name</th>
                                            <th>Child details</th>
                                            <th>Submitted on</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>


                                    <tbody>
                                    {filteredKidsFormDetails && filteredKidsFormDetails.length === 0 ?
        <table class="display dataTable dtr-inline">
        <tbody>
          <tr>
            <div class="row" style={{margin: "10px -500px 10px 10px"}}>
                       <p  valign="top" class="odd" style={{ textAlign: "center" }} >No records found</p> 
                       </div>
          </tr>
        </tbody>
      </table>
      :    null }

                                        {filteredKidsFormDetails && filteredKidsFormDetails.slice((currentPage * perPage), ((currentPage * perPage) + perPage)).map((item, index) => (
                                            <tr key={index}>
                                              
                                                <td>{item.guardian_name} </td>
                                                <td>
              {item.children.map((child, idx) => (
                <div key={idx} style={{ marginBottom: "8px" }}>
                  <strong>Name:</strong> {child.name}
                  <br />
                  <strong>DOB:</strong> {moment(child.dob).format('D MMMM YYYY')}
                </div>
              ))}
            </td>
            <td><p> {moment(item.created_at).format('MMM D, YYYY, h:mm A')}</p> </td>
            <td >


<button class="btn btn-sm btn_secondary" style={{ background: "red", color: "white", margin: "0px 0px 0px 10px" }}
                          onClick={(e) => deleteKidConsent(e, item)}  ><i class="bi bi-trash3"></i> </button>
</td>
                                            </tr>


                                        ))}
                                    </tbody>
                                    <tfoot style={{ borderTop: "1px solid #dee2e6", height: "1px" }}>
    <tr>
        <td colSpan="16" style={{ padding: 0, margin: 0, height: "1px" }}></td>
    </tr>
</tfoot>
                                    {/* <tfoot>
                                        <tr>
                                        <th>S.No</th>
                                        <th>Child Name</th>
                                            <th>Child DOB</th>
                                            <th>Submitted on</th>
                                        </tr>
                                    </tfoot> */}
                                {/* </table>
                                <div class="col-md-4" style={{ float: "left", padding: "20px 0px 0px 0px" }}>
                                {filteredKidsFormDetails && filteredKidsFormDetails.length > 0 && `Showing 1 to ${Math.min(perPage, filteredKidsFormDetails.length)} of ${filteredKidsFormDetails.length} entries`}
                                    </div><div class="col-md-8" style={{ float: "right" }}>

                                        <ReactPaginate style={{ float: "right" }}
                                            previousLabel={"< Prev"}
                                            nextLabel={"Next >"}
                                            breakLabel={'...'}
                                            pageCount={Math.ceil(filteredKidsFormDetails && filteredKidsFormDetails.length / perPage)}
                                            onPageChange={handlePageChange}
                                            containerClassName={"pagination pagination-sm justify-content-center custom-pagination"} // Bootstrap pagination class
                                            disabledClassName={"disabled"}
                                            breakClassName={['page-item']}
                                            breakLinkClassName={'page-link'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item'}
                                            nextLinkClassName={'page-link'}
                                            activeClassName={['active']} />


                                    </div>
                                    </>
                      

        </div>
        </div>
        </div> */} 
        </div>


        </div>
                </>

}




{newBookingVisible && 
            <>
<div class="d-flex mt-2 pt-2 px-3 border-top bg-light">


        <div className="vm_content_box_1 mt-2 ">
        
        <div className="form-box py-2 px-3 bg-light border  shadow-sm mb-4">
        <div class="title">
        <h2>New Booking</h2>
        </div>
        <div className="content py-3 bg-white px-3 mb-3 w-100" >
     
        <div className="col-md-12">
        <div className='row'>

          </div>
          </div>

         


                                                    </div>
                                                    </div>
                                                    </div>
                                                    </div>
                                          
           
                </>

}


           
{historyVisible && <div style={{height:'80vh'}} >



        <div class="main_title" >
            <h1><i class="bi bi-book"></i> Booking History</h1>
        </div>

        <div class="content_wrapper pt-0">
            
            <div>
                <div class="vm_content_box_1">
                    <div class="content">

                    <div class="row pt-3">
                          
                          <div class="col-md-9 form-group" >
                                  <div class="d-flex input_wrapper">
                                  <div><label>Show   <select name="example_length" aria-controls="example" value={perPage} onChange={(e) => {setCurrentPage(0);setPerPage(Number(e.target.value))}}>
                                      <option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option>
                                    </select>  entries</label>
                                    </div>
                                  </div>
                              </div>
  
                              <div class="col-md-3 form-group">
                                  <div class="d-flex input_wrapper">
                                      <div class="icon_wrapper">
                                          <i class="bi bi-search icon"></i>
                                      </div>
                                      <input class="form-control" name="searchQuery" id="searchQuery" placeholder="Search..." type="text" 
                                      value={searchQuery} onChange={(e) => {setSearchQuery(e.target.value)}}/>
                                  </div>
                              </div>
                          </div>

                        <table class="display inventory_table_list dataTable dtr-inline" style={{width:"100%"}}>
                            <thead>
                                <tr>
                                    <th>Booking Id</th>
                                    <th>Customer Name</th>
                                    <th>Location</th>
                                    {/* <th>Game</th> */}
                                    <th>Booked By</th>
                                    <th>Booked On</th>
                                    <th>Status</th>
                                    <th class="text-end">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {filteredBookedHistory.length === 0 ? 
                

                <div class="row" style={{margin: "10px -600px 10px 10px"}}>
                <p id="recordMessage" valign="top" class="odd" style={{ textAlign: "center" }} >No records found</p> 
                </div>
                  : null} 
                            {filteredBookedHistory.slice((currentPage * perPage), ((currentPage * perPage) + perPage)).map((item, index) => (
                                           
                                <>
                               
                                   <tr >
                                   <td style={{ verticalAlign: 'middle'}}>{item.booking_ref_id}</td>
                                    <td style={{ verticalAlign: 'middle'}}>{item.firstname} {item.lastname}</td>
                                    <td style={{ verticalAlign: 'middle'}}>{item.location_name}</td>
                                    {/* <td style={{ verticalAlign: 'middle'}}>{item.game_name}</td> */}
                                    <td style={{ verticalAlign: 'middle'}}>{item.first_name} {item.last_name}</td>
                                    <td style={{ verticalAlign: 'middle'}}>{moment(item.created_at).format('MMM D, YYYY, h:mm A')}</td>
                                    <td style={{ verticalAlign: 'middle', ...getStatusStyle(item.status) }}>{item.status}</td>
                                    <td >
                                        <div class="d-flex justify-content-md-end" style={{margin:"7px 0px 0px 0px"}}>
                                        <button class="btn btn-sm btn_secondary"onClick={() => {
  getCustomerById(item.id);
  setInfoVisible(true);
}} style={{ background: "orange", color: "white", margin: "0px 10px 0px 0px"}} >
                                        <i class="bi bi-eye"></i></button>
                               </div>
                                    </td>
                                   
                                </tr></>
))}
                            </tbody>
                            <tfoot style={{ borderTop: "1px solid #dee2e6", height: "1px" }}>
    <tr>
        <td colSpan="16" style={{ padding: 0, margin: 0, height: "1px" }}></td>
    </tr>
</tfoot>
                         
                        </table>
                        <div class="col-md-3" style={{ float: "left", padding: "20px 0px 0px 0px" }}>
                                        {filteredBookedHistory.length > 0 && `Showing 1 to ${Math.min(perPage, filteredBookedHistory.length)} of ${filteredBookedHistory.length} entries`}
                                    </div><div class="col-md-9" style={{ float: "right" }}>

                                        <ReactPaginate style={{ float: "right" }}
                                            previousLabel={"< Prev"}
                                            nextLabel={"Next >"}
                                            breakLabel={'...'}
                                            pageCount={Math.ceil(filteredBookedHistory.length / perPage)}
                                            onPageChange={handlePageChange}
                                            containerClassName={"pagination pagination-sm justify-content-center custom-pagination"} // Bootstrap pagination class
                                            disabledClassName={"disabled"}
                                            breakClassName={['page-item']}
                                            breakLinkClassName={'page-link'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item'}
                                            nextLinkClassName={'page-link'}
                                            activeClassName={['active']} />


                                    </div>
                    </div>
                </div>
            </div>
        </div>
      
        </div>


}


{invoiceVisible &&
        
        <div class="px-3 pb-5 pt-2 bg-light mt-3">
              <div className="d-flex justify-content-between align-items-center mb-1 border-bottom pb-2">
                          <h3 class="vm_font_semi_bold  mb-2 ">
                            <i className="bi bi-receipt"></i> Invoice 
                          </h3>
                          <div className="d-flex gap-2">
      <button
        className="btn btn-sm text-white"
        // disabled={pdfLoading} 
        style={{ backgroundColor: '#000' }} // Change this to your desired bg color
        onClick={handleEmailDialogOpen}
     >
       {pdfLoading? 'Loading...' :'Send Email'} 
      </button>

      <button
        onClick={() => window.print()}
        className="btn btn-sm btn_secondary text-white"
      >
        Print
      </button>
    </div>
                         </div>
                


  <div id="invoiceDiv"  >
    <div  style={{
   
                 
        display: 'flex',
        flexDirection: 'column',
        minHeight: '279mm',  // Height for Letter paper
        // minWidth: '216mm',   // Width for Letter paper
        position: 'relative',
        //padding: '0px 5px',
        overflow: 'hidden',
        width: '100%',
        maxWidth:"1920px",   // Default max-width for large screens
        margin: '0 auto',     // Center the content on large screens
      
}}> 
   <div style={{ flexGrow: 1 }}>
     {/* Header */}
     <div className="row invoice-header mb-4"  style={{
    marginBottom: 'auto',
    borderTop: '20px solid #059618',
    paddingRight: '5px',
    backgroundColor: '#d4edda', // light green background
    borderBottom: '1px solid #c3e6cb',
    alignItems:'center',
    flexWrap: 'wrap', // ensures it wraps on smaller viewports
    paddingLeft: '20px',
    paddingRight: '20px'
    }}>
  {/* Logo */}
  <div style={{ flex: '0 0 32%' }}>
    <img src={main_logo} alt="LaserCombat Logo" style={{ maxWidth: '150px' }} />
  </div>

  {/* Contact Info */}
  <div style={{ flex: '0 0 68%', textAlign: 'right' }}>
    <strong>Laser Combat</strong><br />
    {customerById?.location_address}<br />
    {customerById?.location_phone} | {customerById?.location_email}
  </div>
</div>


<div
  style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '1rem',
    flexWrap: 'wrap',
    gap: '10px',
    padding:'0px 20px 0px 20px'
  }}
>
  {/* Left Side - Customer Info */}
  <div style={{ flex: '1', minWidth: '200px', fontSize: '14px' }}>
    <p style={{ marginBottom: 0 }}>
      {customerById.firstname} {customerById.lastname}<br />
      {customerById.phone} | {customerById.email}
    </p>
  </div>

  {/* Right Side - Booking Info */}
 {/* Right Side - Booking Info */}
<div style={{ flexShrink: 0, textAlign: 'right', fontSize: '14px', minWidth: '200px' }}>
  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
    <strong style={{ textAlign: 'left', flex: 1 }}>Booking Id:</strong>
    <span style={{ textAlign: 'right', flex: 1 }}>{customerById.booking_ref_id}</span>
  </div>
  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    <strong style={{ textAlign: 'left', flex: 1 }}>Date:</strong>
    <span style={{ textAlign: 'right', flex: 1 }}>
      {new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })}
    </span>
  </div>
</div>

</div>


   
<table class="display inventory_table_list dataTable dtr-inline" style={{ padding:'0px 9px 0px 9px'}}>
  <thead className="thead-light">
    <tr>
      <th>Description</th>
      <th className="text-end">Total</th>
    </tr>
  </thead>
  <tbody>


  {customerById.game_type_name && (
  <tr>
    <td>
      {customerById.game_type_name}

      <small className="text-muted d-block">
        {
          (() => {
            let cartDetails = customerById.cart_details;

            // Handle stringified JSON or object form
            if (typeof cartDetails === 'string') {
              try {
                cartDetails = JSON.parse(cartDetails);
              } catch {
                cartDetails = [];
              }
            }

            // Convert object to array if needed
            if (cartDetails && !Array.isArray(cartDetails)) {
              cartDetails = Object.values(cartDetails);
            }

            if (!Array.isArray(cartDetails)) return null;

            const grouped = [];

            cartDetails.forEach(slot => {
              const pricePerSlot = parseFloat(slot.price_for_slot);
              const totalPlayers = parseInt(slot.total_players, 10);

              if (isNaN(pricePerSlot) || isNaN(totalPlayers)) return;

              const existing = grouped.find(item =>
                item.price === pricePerSlot && item.totalPlayers === totalPlayers
              );

              if (existing) {
                existing.count += 1;
              } else {
                grouped.push({ price: pricePerSlot, totalPlayers, count: 1 });
              }
            });

            if (grouped.length === 0) return null;

            return (
              <span>
                (
                {grouped.map((item, i) => (
                  <span key={i}>
                    {item.count} Game{item.count > 1 ? 's' : ''} × {item.totalPlayers} Player{item.totalPlayers > 1 ? 's' : ''} × ${item.price.toFixed(2)}
                    {i < grouped.length - 1 && ' + '}
                  </span>
                ))}
                )
              </span>
            );
          })()
        }
      </small>
    </td>
    <td className="text-end">${customerById.subtotal?.toFixed(2) || '0.00'}</td>
  </tr>
)}





    {customerById.package_price  ? (
      <>
      <tr>
        <td>Base Package - {customerById.package_name} / {customerById.game_package_name}</td>
        <td className="text-end">${customerById.package_price}</td>
      </tr>

    
    

      {Number(customerById.extra_player_price) !== 0 && (() => {
  let cartDetails = customerById.cart_details;

  // Parse if it's a JSON string
  if (typeof cartDetails === 'string') {
    try {
      cartDetails = JSON.parse(cartDetails);
    } catch {
      cartDetails = {};
    }
  }

  const extra = cartDetails?.extra_player_price;

  if (!extra) return null;

  const totalPlayers = parseInt(extra.total_players, 10) || 0;
  const noGames = parseInt(extra.no_games, 10) || 0;
  const pricePerSlot = parseFloat(extra.price_for_slot) || 0;

  return (
    <tr>
      <td>
        Extra Player Price
        <small className="text-muted d-block">
          ({totalPlayers} Player{totalPlayers !== 1 ? "s" : ""} × {noGames} Game{noGames !== 1 ? "s" : ""} × ${pricePerSlot.toFixed(2)})
        </small>
      </td>
      <td className="text-end">
        ${parseFloat(customerById.extra_player_price).toFixed(2)}
      </td>
    </tr>
  );
})()}

{Number(customerById.extra_game_price) !== 0 && (() => {
  let cartDetails = customerById.cart_details;

  // Parse if cartDetails is a JSON string
  if (typeof cartDetails === 'string') {
    try {
      cartDetails = JSON.parse(cartDetails);
    } catch {
      cartDetails = {};
    }
  }

  const extraGameSlots = Object.values(cartDetails || {}).filter(
    slot => slot.extra_game && slot.extra_game > 0
  );

  if (extraGameSlots.length === 0) return null;

  const aggregated = extraGameSlots.reduce(
    (acc, slot) => {
      const players = parseInt(slot.total_players, 10) || 0;
      const games = parseInt(slot.no_games, 10) || 0;
      const price = parseFloat(slot.price_for_slot) || 0;

      acc.totalPlayers = players;
      acc.totalGames += games;
      acc.pricePerSlot = price;

      return acc;
    },
    { totalPlayers: 0, totalGames: 0, pricePerSlot: 0 }
  );

  const totalCost = aggregated.totalPlayers * aggregated.totalGames * aggregated.pricePerSlot;

  return (
    <tr>
      <td>
        Extra Game Price
        <small className="text-muted d-block">
          ({aggregated.totalPlayers} Player{aggregated.totalPlayers !== 1 ? "s" : ""} ×{" "}
          {aggregated.totalGames} Game{aggregated.totalGames !== 1 ? "s" : ""} × ${aggregated.pricePerSlot.toFixed(2)})
        </small>
      </td>
      <td className="text-end">${totalCost.toFixed(2)}</td>
    </tr>
  );
})()}



</>
  ) : null}

{adjustmentHistory && adjustmentHistory
  .map((item, index) => {
    const amount = parseFloat(item.adjusted_amount);
    const formattedAmount = amount < 0
      ? `-$${Math.abs(amount).toFixed(2)}`
      : `$${amount.toFixed(2)}`;
      
    return (
      <tr>
        <td>{item.adjusted_reason || 'Adjustments'}</td>
        <td className="text-end">{formattedAmount}</td>
      </tr>
    );
  })}
  </tbody>
</table>


{customerById.package_price ?  
<div className="mt-2">
  <div className="row g-0 mb-1">
    <div className="col-10 text-end  p-0 text-nowrap">Sub Total:</div>
    <div className="col-2 text-end pe-3 text-nowrap" >
    ${(() => {
  let cartDetails = customerById.cart_details;

  // Safely parse cartDetails if it's a string
  if (typeof cartDetails === 'string') {
    try {
      cartDetails = JSON.parse(cartDetails);
    } catch {
      cartDetails = {};
    }
  }

  const extraGameCost = Object.values(cartDetails || {}).filter(slot => slot.extra_game > 0)
    .reduce((acc, slot) => {
      const totalPlayers = parseInt(slot.total_players, 10) || 0;
      const noGames = parseInt(slot.no_games, 10) || 0;
      const pricePerSlot = parseFloat(slot.price_for_slot) || 0;
      return acc + (totalPlayers * noGames * pricePerSlot);
    }, 0);

  const packagePrice = parseFloat(customerById.package_price) || 0;
  const extraPlayerPrice = parseFloat(customerById.extra_player_price) || 0;

  const total = packagePrice + extraPlayerPrice + extraGameCost+parseFloat(customerById.adjusted_total || 0);

  return total.toFixed(2);
})()}

    </div>
  </div>

 
 

{customerById.discount_details &&
  customerById.discount_details.map((item, index) => {
    const subtotal = parseFloat(customerById.subtotal || 0) + parseFloat(customerById.adjusted_total || 0);
    
    // Calculate discount amount based on type
    const amount =
      item.type === 'percentage'
        ? (subtotal * (item.value / 100))
        : parseFloat(item.value);

    const formattedAmount = amount > 0
      ? `-$${amount.toFixed(2)}`
      : `$${Math.abs(amount).toFixed(2)}`;

    return (
      <div className="row g-0 mb-1" key={index}>
        <div className="col-10 text-end p-0 text-nowrap">
          {item.description || 'Discount'} {item.type === 'percentage' ? `(${item.value}%)` : ''}
        </div>
        <div className="col-2 text-end pe-3 text-nowrap">
          {formattedAmount}
        </div>
      </div>
    );    
  })}

   {customerById.promo_details &&
  customerById.promo_details.map((item, index) => {
    const subtotal = parseFloat(customerById.subtotal || 0) + parseFloat(customerById.adjusted_total || 0);
    
    // Calculate discount amount based on type
    const amount =
      item.type === 'percentage'
        ? (subtotal * (item.value / 100))
        : parseFloat(item.value);

    const formattedAmount = amount > 0
      ? `-$${amount.toFixed(2)}`
      : `$${Math.abs(amount).toFixed(2)}`;

    return (
      <div className="row g-0 mb-1" key={index}>
        <div className="col-10 text-end p-0 text-nowrap">
          {item.code_name || 'Promo Code'} {item.type === 'percentage' ? `(${item.value}%)` : ''}
        </div>
        <div className="col-2 text-end pe-3 text-nowrap">
          {formattedAmount}
        </div>
      </div>
    );    
  })}

  <div className="row g-0 mb-1">
    <div className="col-10 text-end  p-0 text-nowrap">Total (before HST):</div>
    <div className="col-2 text-end pe-3 text-nowrap">
  ${((customerById.subtotal ? parseFloat(customerById.subtotal) : 0) +
    adjustmentHistory.reduce((acc, item) => acc + (item.adjusted_amount ? parseFloat(item.adjusted_amount) : 0), 0) -
    (customerById.discount_amount ? parseFloat(customerById.discount_amount) : 0) -
    (customerById.promo_amount ? parseFloat(customerById.promo_amount) : 0)
  ).toFixed(2)}
   </div>
  </div>

  <div className="row g-0 mb-1">
    <div className="col-10 text-end  p-0 text-nowrap">HST (13%):</div>
    <div className="col-2 text-end pe-3 text-nowrap">
    ${(customerById.hst.toFixed(2))}
    {/* ${(() => {
  let cartDetails = customerById.cart_details;

  // Safely parse if it's a string
  if (typeof cartDetails === 'string') {
    try {
      cartDetails = JSON.parse(cartDetails);
    } catch {
      cartDetails = {};
    }
  }

  const extraGameCost = Object.values(cartDetails || {}).filter(slot => slot.extra_game > 0)
    .reduce((acc, slot) => {
      const totalPlayers = parseInt(slot.total_players, 10) || 0;
      const noGames = parseInt(slot.no_games, 10) || 0;
      const pricePerSlot = parseFloat(slot.price_for_slot) || 0;
      return acc + (totalPlayers * noGames * pricePerSlot);
    }, 0);

  const packagePrice = parseFloat(customerById.package_price) || 0;
  const extraPlayerPrice = parseFloat(customerById.extra_player_price) || 0;

  const subtotal = packagePrice + extraPlayerPrice + extraGameCost;

  const adjustedTotal = parseFloat(customerById.adjusted_total || 0);
  const totalAfterAdjustment = subtotal + adjustedTotal;

  const tax = totalAfterAdjustment * 0.13;

  return tax.toFixed(2);
})()} */}

    </div>
  </div>

  <div className="row g-0 mb-1">
  <div className="col-10 text-end fw-bold p-0 text-nowrap">Grand Total:</div>
<div className="col-2 text-end fw-bold pe-3 text-nowrap">

${(customerById.grand_total).toFixed(2)}
  {/* ${(() => {
    let cartDetails = customerById.cart_details;

    // Handle if cart_details is a string
    if (typeof cartDetails === 'string') {
      try {
        cartDetails = JSON.parse(cartDetails);
      } catch {
        cartDetails = {};
      }
    }

    // Calculate extra game cost
    const extraGameCost = Object.values(cartDetails || {}).filter(slot => slot.extra_game > 0)
      .reduce((acc, slot) => {
        const totalPlayers = parseInt(slot.total_players, 10) || 0;
        const noGames = parseInt(slot.no_games, 10) || 0;
        const pricePerSlot = parseFloat(slot.price_for_slot) || 0;
        return acc + (totalPlayers * noGames * pricePerSlot);
      }, 0);

    // Parse the prices for package and extra player
    const packagePrice = parseFloat(customerById.package_price) || 0;
    const extraPlayerPrice = parseFloat(customerById.extra_player_price) || 0;

    // Calculate grand total with 13% tax
    const grandTotal = (packagePrice + extraPlayerPrice + extraGameCost) * 1.13;

    return grandTotal.toFixed(2);
  })()} */}
</div>

  </div>
  


  {/* {customerById.adjusted_total ?
  <div className="row g-0 mb-1">
    <div className="col-10 text-end fw-bold p-0 text-nowrap">Adjusted Total:</div>
    <div className="col-2 text-end fw-bold pe-3 text-nowrap">
      ${parseFloat(customerById.adjusted_total).toFixed(2)}
    </div>
  </div>
: null} */}

{paymentHistory && paymentHistory
  .map((item, index) => {
   
    return (
      <div className="row g-0 mb-1" key={index}>
        <div className="col-10 text-end p-0 text-nowrap">
        Paid {item.payment_method} ({moment(item.payment_date ?? item.created_at).format('DD-MMM-YY')}):
        </div>
        <div className="col-2 text-end pe-3 text-nowrap">
        {Number(item.payment_amount).toFixed(2)}
        </div>
      </div>
    );
  })}

  <div className="row g-0">
    <div className="col-10 text-end  p-0 text-nowrap">Balance Due:</div>
    <div className="col-2 text-end pe-3 text-nowrap">
    ${(
  (customerById.grand_total ) - 
  paymentHistory.reduce((sum, p) => sum + Number(p.payment_amount || 0), 0)
).toFixed(2)}


    </div>
  </div>
</div>
: null
}



{customerById.game_type_name &&  
<div className="mt-2">
  <div className="row g-0 mb-1">
    <div className="col-10 text-end p-0 text-nowrap">Sub Total:</div>
    <div className="col-2 text-end pe-3 text-nowrap">
    ${(customerById.subtotal + parseFloat(customerById.adjusted_total || 0)).toFixed(2)}
    </div>
  </div>

{customerById.discount_details &&
  customerById.discount_details.map((item, index) => {
    const subtotal = parseFloat(customerById.subtotal || 0) + parseFloat(customerById.adjusted_total || 0);
    
    // Calculate discount amount based on type
    const amount =
      item.type === 'percentage'
        ? (subtotal * (item.value / 100))
        : parseFloat(item.value);

    const formattedAmount = amount > 0
      ? `-$${amount.toFixed(2)}`
      : `$${Math.abs(amount).toFixed(2)}`;

    return (
      <div className="row g-0 mb-1" key={index}>
        <div className="col-10 text-end p-0 text-nowrap">
          {item.description || 'Discount'} {item.type === 'percentage' ? `(${item.value}%)` : ''}
        </div>
        <div className="col-2 text-end pe-3 text-nowrap">
          {formattedAmount}
        </div>
      </div>
    );    
  })}

  {customerById.promo_details &&
  customerById.promo_details.map((item, index) => {
    const subtotal = parseFloat(customerById.subtotal || 0) + parseFloat(customerById.adjusted_total || 0);
    
    // Calculate discount amount based on type
    const amount =
      item.type === 'percentage'
        ? (subtotal * (item.value / 100))
        : parseFloat(item.value);

    const formattedAmount = amount > 0
      ? `-$${amount.toFixed(2)}`
      : `$${Math.abs(amount).toFixed(2)}`;

    return (
      <div className="row g-0 mb-1" key={index}>
        <div className="col-10 text-end p-0 text-nowrap">
          {item.code_name || 'Promo Code'} {item.type === 'percentage' ? `(${item.value}%)` : ''}
        </div>
        <div className="col-2 text-end pe-3 text-nowrap">
          {formattedAmount}
        </div>
      </div>
    );    
  })}



  <div className="row g-0 mb-1">
    <div className="col-10 text-end  p-0 text-nowrap">Total (before HST):</div>
    <div className="col-2 text-end pe-3 text-nowrap">
  ${((customerById.subtotal ? parseFloat(customerById.subtotal) : 0) +
    adjustmentHistory.reduce((acc, item) => acc + (item.adjusted_amount ? parseFloat(item.adjusted_amount) : 0), 0) -
    (customerById.discount_amount ? parseFloat(customerById.discount_amount) : 0) -
    (customerById.promo_amount ? parseFloat(customerById.promo_amount) : 0)).toFixed(2)}
   </div>
  </div>


  <div className="row g-0 mb-1">
    <div className="col-10 text-end  p-0 text-nowrap">HST (13%):</div>
    <div className="col-2 text-end pe-3 text-nowrap">

      ${(customerById.hst.toFixed(2))}
    </div>
  </div>

  <div className="row g-0 mb-1">
      <div className="col-10 text-end fw-bold p-0 text-nowrap">Grand Total:</div>
      <div className="col-2 text-end fw-bold pe-3 text-nowrap">
        ${(customerById.grand_total).toFixed(2)}
        
      </div>
    </div>

 

  {/* <div className="row g-0 mb-1">
 
    <div className="col-10 text-end  p-0 text-nowrap">Total Paid:</div>
    <div className="col-2 text-end pe-3 text-nowrap">
      ${paymentHistory.reduce((sum, p) => sum + Number(p.payment_amount), 0).toFixed(2)}
    </div>
  </div> */}


  {paymentHistory && paymentHistory
  .map((item, index) => {
   
    return (
      <div className="row g-0 mb-1" key={index}>
        <div className="col-10 text-end p-0 text-nowrap">
        Paid {item.payment_method} ({moment(item.payment_date ?? item.created_at).format('DD-MMM-YY')}):

        </div>
        <div className="col-2 text-end pe-3 text-nowrap">
          {Number(item.payment_amount).toFixed(2)}
        </div>
      </div>
    );
  })}


  <div className="row g-0">
    <div className="col-10 text-end  p-0 text-nowrap">Balance Due:</div>
    <div className="col-2 text-end pe-3 text-nowrap">
    ${(
  (customerById.grand_total) - 
  paymentHistory.reduce((sum, p) => sum + Number(p.payment_amount || 0), 0)
).toFixed(2)}
    </div>
  </div>
</div>
}


 </div>

  {/* Footer */}
  
  <div
    style={{
      borderBottom: '20px solid #059618',
      textAlign: 'center',
    //   fontSize: '12px',
      padding: '10px',
    //   backgroundColor: '#d4edda'
    }}
  >
    {/* <p style={{ margin: 0 }}> */}
      If you have any questions or concerns regarding this invoice,<br />
      contact us at {customerById.location_phone} or {customerById.location_email}.<br />
      GST/HST Registration No: 748818416RT0001 <br />
      <strong>Thank you for booking with Laser Combat!</strong>
    {/* </p> */}
  </div>
    
    </div>
    
   </div>
            
            </div>}
           
        
    </div></>
            


                <a id="contact_history" class="a_id_contact_history position-relative"></a>
                <div class="activity bg-white" style={{width:'40%'}}>
                    
<div class="d-flex justify-content-between">
    <div class="main_title bg-white border-bottom w-100" >
        <h1><i class="bi bi-card-checklist"></i>Activity History</h1>
        <div class="dropdown">
            <i class="bi bi-three-dots-vertical vm_cursor_pointer me-0" data-bs-toggle="dropdown" aria-expanded="false"></i>
            <ul class="dropdown-menu">
                <li><a class="dropdown-item" href="#">Action</a></li>
                <li><a class="dropdown-item" href="#">Another action</a></li>
                <li><a class="dropdown-item" href="#">Something else here</a></li>
            </ul>
        </div>
    </div>
</div>
<div className="activity_wrapper">
  {inquiryById.length === 0 &&
  emailLogById.length === 0 &&
  smsLogById.length === 0 &&
  noteLogById.length === 0 &&
  meetLogById.length === 0 &&
  uploadLogById.length === 0 &&
  paymentLinkById.length === 0 &&
  paymentOnlyDeleteHistory.length === 0 &&
  adjustmentDeleteHistory.length === 0 &&
  bookedSlotLogById.length === 0 ? (
//   !customerById.status === 'Cancelled' ? ( 
    <p style={{ textAlign: "center", padding: "20px" }}>No Activity found</p>
  ) : (
    [...inquiryById, ...emailLogById, ...smsLogById, ...noteLogById, ...meetLogById, ...uploadLogById, ...paymentLinkById, ...paymentOnlyDeleteHistory, ...adjustmentDeleteHistory,
      ...customerById.consent_form_details,
      ...customerById.kids_form_details,
      ...bookedSlotLogById,
    //   customerById?.status === 'Cancelled' ? { ...customerById, isCancelled: true } : null
 
    
    ]
    // .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .sort((a, b) => {
      const dateA = (paymentOnlyDeleteHistory.includes(a) || adjustmentDeleteHistory.includes(a))
        ? new Date(a.updated_at)
        : new Date(a.created_at);
      const dateB = (paymentOnlyDeleteHistory.includes(b) || adjustmentDeleteHistory.includes(b))
        ? new Date(b.updated_at)
        : new Date(b.created_at);
      return dateB - dateA;
    })
     // .filter(item => item !== null)
    //   .sort((a, b) => {
    //     // For sorting, prioritize updated_at for cancelled bookings, created_at for others
    //     const dateA = a.isCancelled ? new Date(a.updated_at) : new Date(a.created_at);
    //     const dateB = b.isCancelled ? new Date(b.updated_at) : new Date(b.created_at);
    //     return dateB - dateA; // Most recent date first
    //   })
      .map((item, index) => (
        <div className="row pt-3" key={`activity-${index}`}>
          <div className="col-md-4 col-4 d-flex justify-content-center align-items-center pe-md-0">
            <div className="border-bottom col"></div>
            <div className={`${
              emailLogById.includes(item)  ? 'vm_bg_light_pink' :
              inquiryById.includes(item) ? 'vm_bg_light_orange' :
              smsLogById.includes(item) ? 'vm_bg_light_blue' :
              meetLogById.includes(item) ? 'vm_bg_light_green' :
              uploadLogById.includes(item) ? 'vm_bg_light_pink' :
              paymentLinkById.includes(item) ? 'vm_bg_light_blue' :
              paymentOnlyDeleteHistory.includes(item) ? 'vm_bg_light_purple' :
              adjustmentDeleteHistory.includes(item) ? 'vm_bg_light_purple' :
              customerById.consent_form_details.includes(item) ? 'vm_bg_light_green' :
              customerById.kids_form_details.includes(item) ? 'vm_bg_light_green' :
              bookedSlotLogById.includes(item) ? 'vm_bg_light_red' :
            //   item.isCancelled ? 'vm_bg_light_red' :
              'vm_bg_light_yellow'
            } px-2 py-1 text-center`}>
              {
  
      //  formatDate(item.created_at)
      (paymentOnlyDeleteHistory.includes(item) || adjustmentDeleteHistory.includes(item))
      ? formatDate(item.updated_at)
      : formatDate(item.created_at)
  }
            </div>
            <div className="border-bottom col"></div>
          </div>

          <div className={`col-md-8 col-8 ${
            emailLogById.includes(item) ? 'vm_bg_light_pink' :
            inquiryById.includes(item) ? 'vm_bg_light_orange' :
            smsLogById.includes(item) ? 'vm_bg_light_blue' :
            meetLogById.includes(item) ? 'vm_bg_light_green' :
            uploadLogById.includes(item) ? 'vm_bg_light_pink' :
            paymentLinkById.includes(item) ? 'vm_bg_light_blue' :
            paymentOnlyDeleteHistory.includes(item)? 'vm_bg_light_purple' :
            adjustmentDeleteHistory.includes(item)? 'vm_bg_light_purple' :
            customerById.consent_form_details.includes(item) || customerById.kids_form_details.includes(item) ? 'vm_bg_light_green' :
            bookedSlotLogById.includes(item) ? 'vm_bg_light_red' :
            // item.isCancelled ? 'vm_bg_light_red' :
            'vm_bg_light_yellow'
          } p-2`}>

              
                {/* {item.isCancelled && (
                <>
                    <span className="vm_font_bold">Booking Cancelled</span>
                </>
                )} */}



            {emailLogById.includes(item) && (
              <>
                <span className="vm_font_bold">Email sent</span>
                <div className="col-md-12 col-9 vm_bg_light_pink">
                  <p className="vm_font_bold">Subject | {item.subject}</p>
                  <p>
                    <a
                      className="btn btn-link p-0"
                      style={{ fontSize: '0.85rem' }}
                      onClick={() => handleToggleEmailActivity(item.id)}
                      aria-controls={`collapse-text-${item.id}`}
                      aria-expanded={openActivityEmailId === item.id}
                    >
                      {openActivityEmailId === item.id ? 'Show Less' : 'Show More'}
                    </a>
                  </p>
                  <Collapse in={openActivityEmailId === item.id}>
                    <div id={`collapse-text-${item.id}`} dangerouslySetInnerHTML={{ __html: item.message }} />
                  </Collapse>
                </div>
              </>
            )}
            {inquiryById.includes(item) && <span>Inquiry submitted</span>}
            {smsLogById.includes(item) && 
             <><span className="vm_font_bold">Sms sent</span><p >
                          <a
                              className="btn btn-link p-0"
                              style={{ fontSize: '0.85rem' }}
                              onClick={() => handleToggleSmsActivity(item.id)}
                              aria-controls={`collapse-text-${item.id}`}
                              aria-expanded={openActivitySmsId === item.id}
                          >
                              {openActivitySmsId === item.id ? 'Show Less' : 'Show More'}
                          </a>
                      </p>
                      <Collapse  in={openActivitySmsId === item.id}>
                    <div style={{paddingBottom:'5px'}} id={`collapse-text-${item.id}`} dangerouslySetInnerHTML={{ __html: item.message }} />
                  </Collapse>
                      </>
            
            }

            {meetLogById.includes(item) && <span>Appointment email sent</span>}
            {uploadLogById.includes(item) && <span>Document uploaded</span>}
            {customerById.consent_form_details.includes(item) && (
              customerById.consent_form_details
              .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                .filter(detail => detail === item)
                .map((detail, index) => (
                  <div key={index}>
                     <span className="vm_font_bold">
                     {Number(detail.is_deleted) === 1 ? 'Adult consent form deleted' : 'Adult consent form submitted'}
        </span>
        <p>Name: {detail.name} | Date of Birth: {moment(detail.dob).format('D MMMM YYYY')}</p>
                  </div>
                ))
            )}
            {customerById.kids_form_details.includes(item) && (
              customerById.kids_form_details
               .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                .filter(detail => detail === item)
                .map((detail, index) => (
                  <div key={index}>
                    <span className="vm_font_bold">
                    {Number(detail.is_deleted) === 1 ? 'Kids consent form deleted' : 'Kids consent form submitted'}
                    </span>
                    <p>Guardian Name: {detail.guardian_name}</p>
                    {detail.children.map((child, childIndex) => (
                      <div key={childIndex}>
                        <p>Child Name: {child.name} | Date of Birth: {moment(child.dob).format('D MMMM YYYY')}</p>
                      </div>
                    ))}
                  </div>
                ))
            )}



            {noteLogById.includes(item) && item.to && (
              <>
                <span className="vm_font_bold">Note email sent</span>
                <div className="col-md-12 col-9 vm_bg_light_yellow">
                  <p className="vm_font_bold">Subject | {item.subject}</p>
                  <p>
                    <a
                      className="btn btn-link p-0"
                      style={{ fontSize: '0.85rem' }}
                      onClick={() => handleToggleNoteActivity(item.id)}
                      aria-controls={`collapse-text-${item.id}`}
                      aria-expanded={openActivityNoteId === item.id}
                    >
                      {openActivityNoteId === item.id ? 'Show Less' : 'Show More'}
                    </a>
                  </p>
                  <Collapse in={openActivityNoteId === item.id}>
                    <div id={`collapse-text-${item.id}`} dangerouslySetInnerHTML={{ __html: item.message }} />
                  </Collapse>
                </div>
              </>
            )}
            {noteLogById.includes(item) && !item.to && (
              <>
                <span className="vm_font_bold">Note Saved</span>
                <div className="col-md-12 col-9 vm_bg_light_yellow">
                  <p className="vm_font_bold">Subject | {item.subject}</p>
                  <p>
                    <a
                      className="btn btn-link p-0"
                      style={{ fontSize: '0.85rem' }}
                      onClick={() => handleToggleNoteActivity(item.id)}
                      aria-controls={`collapse-text-${item.id}`}
                      aria-expanded={openActivityNoteId === item.id}
                    >
                      {openActivityNoteId === item.id ? 'Show Less' : 'Show More'}
                    </a>
                  </p>
                  <Collapse in={openActivityNoteId === item.id}>
                    <div id={`collapse-text-${item.id}`} dangerouslySetInnerHTML={{ __html: item.message }} />
                  </Collapse>
                </div>
              </>
            )}

{
paymentLinkById.includes(item) && 
            
            <div>
                       
             <>
              <span className="vm_font_bold">Payment Link Generated</span>
            <div className="col-md-12 col-9 vm_bg_light_blue pt">


              <p>Amount: {item.requested_amt} | Reason: {item.reason} |
              Status:
        <span style={{ color: item.is_completed === 1 ? 'green' : 'red', fontWeight: 'bold', marginLeft: '5px' }}>
          {item.is_completed === 1 ? 'Completed' : 'Not Completed'}
        </span>
        {item.note && (
          <>
            {' '}| Note: {item.note}
          </>
        )}
    
                {/* {item.updated_by && (
    <>  Updated by: {(() => {
      const userDetails = team.find(user => user.id === item.updated_by);
      return userDetails 
        ? `${userDetails.first_name} ${userDetails.last_name}` 
        : 'Unknown User';
    })()}
    </>
  )} */}
</p>
            </div>
            </>
                       
                    </div> 
                    
                        }


{
paymentOnlyDeleteHistory.includes(item) && 
            
            <div>
                       
             <>
              <span className="vm_font_bold">Payment Deleted</span>
            <div className="col-md-12 col-9 vm_bg_light_purple pt">


              <p>Payment Date: {moment(item.payment_date ?? item.created_at).format('DD-MMM-YY')} | Amount: {item.payment_amount} | Method: {item.payment_method} |
                Mode: {item.payment_mode.toLowerCase()} |
                {item.updated_by && isTeamLoaded && team.length > 0 && (
    <>  Updated by: {(() => {
      const userDetails = team.find(user => user.id === item.updated_by);
      return userDetails 
        ? `${userDetails.first_name} ${userDetails.last_name}` 
        : 'Unknown User';
    })()}
    </>
  )}
</p>
            </div>
            </>
                       
                    </div> 
                    
                        }


{
adjustmentDeleteHistory.includes(item) && 
            
            <div>
                       
             <>
              <span className="vm_font_bold">Adjustment Deleted</span>
            <div className="col-md-12 col-9 vm_bg_light_purple pt">


              <p>Date: {moment(item.adjusted_date).format('DD-MMM-YY')} | Amount: {item.adjusted_amount} | Reason: {item.adjusted_reason || 'N/A'} |
                Note: {item.adjusted_note || 'N/A'} |
                {item.adjusted_by && isTeamLoaded && team.length > 0 && (
    <>  Updated by: {(() => {
      const userDetails = team.find(user => user.id === item.adjusted_by);
      return userDetails 
        ? `${userDetails.first_name} ${userDetails.last_name}` 
        : 'Unknown User';
    })()}
    </>
  )}
</p>
            </div>
            </>
                       
                    </div> 
                    
                        }


{bookedSlotLogById.includes(item) && 
            
<div>
            {item.status === 'Cancelled' ? (
 <>
            <span className="vm_font_bold">Booking Cancelled</span>
            <div className="col-md-12 col-9 vm_bg_light_red pt">
  <p>Reason: {item.cancel_reason} |
      {item.updated_by && isTeamLoaded && team.length > 0 && (
    <> 
  updated by: {
          (() => {  
            const userDetails = team.find(user => user.id === item.updated_by);
            return userDetails 
            ? `${userDetails.first_name} ${userDetails.last_name}` 
            : 'Unknown User'; // Handle case if user not found
          })()
        }
        </>
      )}
  </p>

</div>

            </>
            ):(
                <>
<span className="vm_font_bold">Booking updated</span>
<div className="col-md-12 col-9 vm_bg_light_red pt">
  <p>Booked Date: {moment(item.booked_date).format('DD-MMM-YY')} | Booked Time: {formatBookedTime(item.booked_time)} | Adults: {item.no_of_adults} | Kids: {item.no_of_children} |
    {item.updated_by  && isTeamLoaded && team.length > 0 && (
      <> 
    updated by: {
            (() => {
              const userDetails = team.find(user => Number(user.id) === Number(item.updated_by));
              
          // console.log('item.updated_by:', item.updated_by);
          // console.log('team ids:', team.map(user => user.id));
          // console.log('typeof updated_by:', typeof item.updated_by);
          // console.log('typeof team.id[0]:', typeof team[0]?.id);
          // console.log('userDetails found:', userDetails ? userDetails.first_name : null);

              return userDetails 

              ? `${userDetails.first_name} ${userDetails.last_name}` 
              : 'Unknown User'; // Handle case if user not found
            })()
          }
          </>
    )}
    </p>

</div>
</>
            )}
        </div> 
        
            }
 
            
            {/* {item.isCancelled ? (
            <p>{getDayName(item.updated_at)} at {formatTime(item.updated_at)}</p>
        ) : ( */}
            {/* <p>{getDayName(item.created_at)} at {formatTime(item.created_at)}</p> */}
<p>
{
  (paymentOnlyDeleteHistory.includes(item) || adjustmentDeleteHistory.includes(item))
    ? `${getDayName(item.updated_at)} at ${formatTime(item.updated_at)}`
    : `${getDayName(item.created_at)} at ${formatTime(item.created_at)}`
}

</p>

        {/* )} */}
          </div>
        </div>
        
        
      ))
  )}




  <div className="py-5"></div>
  <div className="py-3"></div>
</div>
        </div>
    </div>



    

              
               
</div>
          
           
</div>

<Modal show={showEmailDialog} onHide={handleEmailDialogClose} maxWidth="sm" fullWidth>
<Modal.Header closeButton>
          <Modal.Title>Send Email</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div class="row">

               <div className="col-md-12">
  <div className="form-group">
    <label htmlFor="to">To</label>
    <input
      type="text"
      className="form-control"
      name="to"
      id="to"
      value={invoiceEmailData.to  }
      onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, to: e.target.value })}
    />
  </div>
</div>

<div className="col-md-12">
                            <div className="form-group">
                                <label htmlFor="template">Select Template</label>
                                <select  class="form-select" id="template" name="template"  value={invoiceEmailData.template} 
                               onChange={(event) => {
                                const selectedTemplateId = event.target.value;
                                const selectedTemplate = email_template.find(
                                  (item) => item.name === "Invoice"
                                );
                                
                                setInvoiceEmailData({
                                  ...invoiceEmailData,
                                  template: selectedTemplateId, // Update selected template
                                  subject: invoiceEmailData.subject, // Reset subject and message when template changes
                                  message: invoiceEmailData.message,
                                });
                              }}>
       <option value="">Select Template</option>
                    {email_template.map((item) => (
                        <option value={item.id} key={item.id}>
                            {item.template_name}
                        </option>
                        ))}
        </select>
                            </div>
                        </div>

                        <div className="col-md-12">
  <div className="form-group">
    <label htmlFor="subject">Subject</label>
    <input
      type="text"
      className="form-control"
      name="subject"
      id="subject"
      value={invoiceEmailData.subject}
      onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, subject: e.target.value })}
    />
  </div>
</div>

<div className="col-md-12">
  <div className="form-group">
    <label htmlFor="message">Message</label>
    <textarea
      type="text"
      rows={8} 
      className="form-control"
      name="message"
      id="message"
      value={invoiceEmailData.message}
      onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, message: e.target.value })}
    />
  </div>
</div>
                     

{/* Attachments Section */}
<div>
  <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
    <div style={{ width: '100%' }}>
      <h6 style={{ marginBottom: '8px' }}> Attachment: invoice attached </h6>
    </div>
  </div>
</div>

            </div>
          </Modal.Body>
          <Modal.Footer>

          <button class="btn btn-sm btn_secondary"
           onClick={handleSendEmail}
          >
           {emailLoading? 'Sending...':'Send'} 
          </button>

        
            </Modal.Footer>
        </Modal>



        <Modal show={showPaymentEmailDialog} onHide={handlePaymentEmailDialogClose} maxWidth="sm" fullWidth>
<Modal.Header closeButton>
          <Modal.Title>Send Email</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div class="row">

               <div className="col-md-12">
  <div className="form-group">
    <label htmlFor="to">To</label>
    <input
      type="text"
      className="form-control"
      name="to"
      id="to"
      value={invoiceEmailData.to  }
      onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, to: e.target.value })}
    />
  </div>
</div>

<div className="col-md-12">
                            <div className="form-group">
                                <label htmlFor="template">Select Template</label>
                                <select  class="form-select" id="template" name="template"  value={invoiceEmailData.template} 
                               onChange={(event) => {
                                const selectedTemplateId = event.target.value;
                                const selectedTemplate = email_template.find(
                                  (item) => item.name === "Payment Link"
                                );
                                
                                setInvoiceEmailData({
                                  ...invoiceEmailData,
                                  template: selectedTemplateId, // Update selected template
                                  subject: invoiceEmailData.subject, // Reset subject and message when template changes
                                  message: invoiceEmailData.message,
                                });
                              }}>
       <option value="">Select Template</option>
                    {email_template.map((item) => (
                        <option value={item.id} key={item.id}>
                            {item.template_name}
                        </option>
                        ))}
        </select>
                            </div>
                        </div>

                        <div className="col-md-12">
  <div className="form-group">
    <label htmlFor="subject">Subject</label>
    <input
      type="text"
      className="form-control"
      name="subject"
      id="subject"
      value={invoiceEmailData.subject}
      onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, subject: e.target.value })}
    />
  </div>
</div>

<div className="col-md-12">
  <div className="form-group">
    <label htmlFor="message">Message</label>
    <textarea
      type="text"
      rows={8} 
      className="form-control"
      name="message"
      id="message"
      value={invoiceEmailData.message}
      onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, message: e.target.value })}
    />
  </div>
</div>
 
            </div>
          </Modal.Body>
          <Modal.Footer>

          <button class="btn btn-sm btn_secondary"
           onClick={handlePaymentSendEmail}
          >
           {emailLoading? 'Sending...':'Send'} 
          </button>

        

            </Modal.Footer>
        </Modal>






        <Modal show={showAdjustmentModal} onHide={handleCloseAdjustmentModal}>
        <Modal.Header closeButton>
          <Modal.Title>Adjustment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
<div class="row">


<div className="col-md-6">
  <div className="form-group">
    <label htmlFor="payment_date">Date</label>
    <input
      type="date"
      className="form-control"
      name="adjustedDate"
      id="adjustedDate"
      value={adjustedDate}
      onChange={(e) => setAdjustedDate(e.target.value)}
    />
  </div>
</div>

       
<div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="amount">Amount</label>
                                <input
              type="number"
              className="form-control"
             value={adjustedAmount} 
              onChange={(e) => setAdjustedAmount(e.target.value)}
            />
                              
                            </div>
                        </div>

               <div className="col-md-12">
                            <div className="form-group">
                                <label htmlFor="reason">Reason</label>
                                <input
              type="text"
              className="form-control"
              value={adjustedReason}
              onChange={(e) => setAdjustedReason(e.target.value)}
            />
                    
                  {adjustmentError && <span style={{ color:'red'}}>{adjustmentError}</span>}         
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="form-group">
                                <label htmlFor="note">Note</label>
                                <textarea
            row={8}
              className="form-control"
              value={adjustedNote}
              onChange={(e) => setAdjustedNote(e.target.value)}
            />
                              
                            </div>
                        </div>
                    
                      
                        </div>
        </Modal.Body>
        <Modal.Footer>
         
          <button class="btn btn-sm btn_secondary" onClick={handleSaveAdjustment}>
           {adjustmentLoading? 'Saving...':'Save'} 
          </button>
        </Modal.Footer>
      </Modal>



</div>

          
           

    );
}
export default LeadsDetails;